import React, { useEffect, useState, useRef } from "react";
import { Row, Col } from "react-flexbox-grid";
import {
  Button,
  SelectField,
  TextField,
  DialogContainer,
  CircularProgress,
} from "react-md";
import { TextField as TextField2 } from "@material-ui/core";
import UploadFileIcon from "../../../../../assets/icons/upload-file-icon.png";
import crossIcon from "../../../../../assets/icons/close-cross1.png";
import "../styles/createPlan.css";
import FontIcon from "react-md/lib/FontIcons";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import EventService from "../../../../../service/event/EventService";
import PlansUtils from "../services/PlansUtils";
import {
  Accordion,
  AccordionDetails,
  Radio,
  withStyles,
  makeStyles,
  Popper,
  ClickAwayListener,
  Paper,
  MenuItem,
  FormControl,
  Select as Select2,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { AccordionSummary } from "@material-ui/core";
import { Checkbox } from "@material-ui/core";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import htmlToDraft from "html-to-draftjs";
import AuthenticationService from "../../../../../service/auth/AuthenticationService";
import ExpandableTableAssignedServices from "../helper/expandableTableAssignedServices";
import ExpandableTableSelectableAssignedServices from "../helper/expandableTableSelectableAssignedServices";
import successAnimationGif from "../../../../../assets/images/done-animation.gif";
import TopNote from "../../../../../components/common/TopNote";
import { useConfirmDialog } from "../helper/useConfirmDialog";
import { FAQDialog, useFAQDialog } from "../helper/useFAQDialog";
import CategorySelectDialog from "../helper/CategorySelectDialog";
import { normalizeLabel, labelKey } from "../helper/categoryLabel";
import GlobalSkeletonLoader from "../../../../../components/common/GlobalSkeletonLoader";
import Decimal from "decimal.js";
import getInfoText, { getInfoTitle } from "../helper/getInfoText";
import ValidatedAmountField from "../helper/ValidatedAmountField";
import {
  convertPercentToAmount,
  convertAmountToPercent,
} from "../helper/walletAmountConverters";
import validateWalletPayload from "../helper/validateWalletPayload";
import MultiSelectPicker from "../helper/MultiSelectPicker";
import InfoButton from "../helper/InfoButton";
import SponsorshipRulesTable from "../helper/sponsorshipRulesTable";
import AssignedPlansUtil from "../services/AssignedPlansUtils";

export const CreatePlan = (props) => {
  const [mode, setMode] = useState(1);
  const [accountDetails, setAccountDetails] = useState(null);
  const [planName, setPlanName] = useState("");
  const [planPrice, setPlanPrice] = useState("");
  const [planStatus, setPlanStatus] = useState(1);
  const [planDuration, setPlanDuration] = useState("");
  const [planDateFrom, setPlanDateFrom] = useState(null);
  const [planDateTo, setPlanDateTo] = useState(null);
  const [planDefaultTherapy, setPlanDefaultTherapy] = useState(null);
  const [planMobileImage, setPlanMobileImage] = useState(null);
  const [planMobilePreview, setPlanMobilePreview] = useState("");
  const [planDesktopImage, setPlanDesktopImage] = useState(null);
  const [planDesktopPreview, setPlanDesktopPreview] = useState("");
  const [planShortDescription, setPlanShortDescription] = useState("");
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [planLongDescription, setPlanLongDescription] = useState("");
  const [planAutoActivate, setPlanAutoActivate] = useState(false);
  const [planEmailDomains, setPlanEmailDomains] = useState([]);
  const [domainTyped, setDomainTyped] = useState("");
  const [isWalletIncluded, setIsWalletIncluded] = useState(false);
  const [isUnlimitedWallet, setIsUnlimitedWallet] = useState(false);
  const [canEditWalletLimit, setCanEditWalletLimit] = useState(false);
  const [walletLimit, setWalletLimit] = useState("");
  const [walletLimitInEditState, setWalletLimitInEditState] = useState("");
  const [canWalletBeUsedByFamily, setWalletCanBeUsedByFamily] = useState(false);
  const [familyRelationsArr, setFamilyRelationsArr] = useState([]);
  const [allRelations, setAllRelations] = useState([]);
  const [selectAllFamilyForWallet, setSelectAllFamilyForWallet] =
    useState(false);
  const [allowedFamilyRelationsForWallet, setAllowedFamilyRelationsForWallet] =
    useState([]);
  const [isReimbursementIncluded, setIsReimbursementIncluded] = useState(false);
  const [isWalletFaqsIncluded, setIsWalletFaqsIncluded] = useState(false);
  const [isCategoryRuleEnabled, setIsCategoryRuleEnabled] = useState(false);
  const [isServiceRuleEnabled, setIsServiceRuleEnabled] = useState(false);
  const [isClaimRuleEnabled, setIsClaimRuleEnabled] = useState(false);
  const [isAdditionalClaimRuleEnabled, setIsAdditionalClaimRuleEnabled] =
    useState(false);
  const [isEyeCareIncluded, setIsEyeCareIncluded] = useState(false);
  const [eyeCareModule, setEyeCareModule] = useState(1);
  const [selectedVisionProviders, setSelectedVisionProviders] = useState([]);
  const [editorStateVisionBenefits, setEditorStateVisionBenefits] = useState(
    EditorState.createEmpty(),
  );
  const [visionModuleTwoBenefitsCovered, setVisionModuleTwoBenefitsCovered] =
    useState("");
  const [selectedEligibleBenefits, setSelectedEligibleBenefits] = useState([]);
  const [selectedIneligibleBenefits, setSelectedIneligibleBenefits] = useState(
    [],
  );
  const [rawEligibleCodes, setRawEligibleCodes] = useState(null);
  const [rawIneligibleCodes, setRawIneligibleCodes] = useState(null);
  const [isAdditionalPlanRuleEnabled, setIsAdditionalPlanRuleEnabled] =
    useState(false);
  const [canReimbursementBeUsedByFamily, setReimbursementCanBeUsedByFamily] =
    useState(false);
  const [isBankAccountRequired, setIsBankAccountRequired] = useState(false);
  const [selectAllFamilyForReimbursement, setSelectAllFamilyForReimbursement] =
    useState(false);
  const [
    allowedFamilyRelationsForReimbursement,
    setAllowedFamilyRelationsForReimbursement,
  ] = useState([]);
  const [isWelcomeMsgIncluded, setIsWelcomeMsgIncluded] = useState(false);
  const [customMessage, setCustomMessage] = useState("");
  const [isCTAButtonEnabled, setIsCTAButtonEnabled] = useState(false);
  const [ctaButton, setCtaButton] = useState("");
  const [ctaText, setCtaText] = useState("");
  const [customCtaText, setCustomCtaText] = useState("");
  const [ctaLink, setCtaLink] = useState("");
  const [editorState2, setEditorState2] = useState(EditorState.createEmpty());
  const [loading, setLoading] = useState(false);
  const [fetchedPlan, setFetchedPlan] = useState("");
  const [fetchedVisionProviders, setFetchedVisionProviders] = useState([]);
  const [fetchedVisionBenefits, setFetchedVisionBenefits] = useState([]);
  const [expandableTile, setExpandableTile] = useState(<></>);
  const [assignedServicesArray, setAssignedServicesArray] = useState([]);
  const [allAssignedServicesArray, setAllAssignedServicesArray] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [filterObj, setFilterObj] = useState({});
  const [pageSize, setPageSize] = useState(30);
  const [totalCount, setTotalCount] = useState(10);
  const [componentMounted, setComponentMounted] = useState(false);
  const [walletExpanded, setWalletExpanded] = useState(() => {
    return props?.data?.mode == "view" || props?.data?.mode == "assign-service"
      ? false
      : isWalletIncluded;
  });
  const [reimbursementExpanded, setReimbursementExpanded] = useState(() => {
    return props?.data?.mode == "view" || props?.data?.mode == "assign-service"
      ? false
      : isReimbursementIncluded;
  });
  const [walletFaqsExpanded, setWalletFaqsExpanded] = useState(() => {
    return props?.data?.mode == "view" || props?.data?.mode == "assign-service"
      ? false
      : isWalletFaqsIncluded;
  });
  const [categoryRuleExpanded, setCategoryRuleExpanded] = useState(() => {
    return props?.data?.mode == "view" || props?.data?.mode == "assign-service"
      ? false
      : isCategoryRuleEnabled;
  });
  const [serviceRuleExpanded, setServiceRuleExpanded] = useState(() => {
    return props?.data?.mode == "view" || props?.data?.mode == "assign-service"
      ? false
      : isServiceRuleEnabled;
  });
  const [claimRuleExpanded, setClaimRuleExpanded] = useState(() => {
    return props?.data?.mode == "view" || props?.data?.mode == "assign-service"
      ? false
      : isClaimRuleEnabled;
  });
  const [additionalClaimRuleExpanded, setAdditionalClaimRuleExpanded] =
    useState(() => {
      return props?.data?.mode == "view" ||
        props?.data?.mode == "assign-service"
        ? false
        : isAdditionalClaimRuleEnabled;
    });
  const [additionalPlanRuleExpanded, setAdditionalPlanRuleExpanded] = useState(
    () => {
      return props?.data?.mode == "view" ||
        props?.data?.mode == "assign-service"
        ? false
        : isAdditionalPlanRuleEnabled;
    },
  );
  const [eyeCareExpanded, setEyeCareExpanded] = useState(() => {
    return props?.data?.mode == "view" || props?.data?.mode == "assign-service"
      ? false
      : isEyeCareIncluded;
  });
  const [welcomeMsgExpanded, setWelcomeMsgExpanded] = useState(() => {
    return props?.data?.mode == "view" || props?.data?.mode == "assign-service"
      ? false
      : isWelcomeMsgIncluded;
  });
  const [planToUpdate, setPlanToUpdate] = useState(null);
  const [openRenewDialog, setOpenRenewDialog] = useState(false);
  const [openInactiveDialog, setOpenInactiveDialog] = useState(false);
  const [openEndDateChangeDialog, setOpenEndDateChangeDialog] = useState(false);
  const [endDateUpdateError, setEndDateUpdateError] = useState(null);

  const [copyPayloadDraft, setCopyPayloadDraft] = useState(null);
  // "create-new" => triggered from copy-plan Save flow; payload includes the
  // assembled `plan` and newPlanId:0.
  // "import-into-existing" => triggered from "Import from existing plan" on
  // assign-service view; payload omits `plan` and uses the current plan's id
  // as newPlanId.
  const [copyServicesMode, setCopyServicesMode] = useState("create-new");
  const [isCopyServicesPromptOpen, setIsCopyServicesPromptOpen] =
    useState(false);
  const [isCopyServicesSelectorOpen, setIsCopyServicesSelectorOpen] =
    useState(false);
  const [copyServicesSourcePlan, setCopyServicesSourcePlan] = useState(null);
  const [copyServicesSourceAccount, setCopyServicesSourceAccount] =
    useState(null);
  const [copyServicesSearchInput, setCopyServicesSearchInput] = useState("");
  const [copyServicesLookupLoading, setCopyServicesLookupLoading] =
    useState(false);
  const [copyServicesArray, setCopyServicesArray] = useState([]);
  const [allCopyServicesArray, setAllCopyServicesArray] = useState([]);
  const [copyServicesPageNum, setCopyServicesPageNum] = useState(1);
  const [copyServicesPageSize] = useState(30);
  const [copyServicesTotalCount, setCopyServicesTotalCount] = useState(0);
  const [copyServicesFilterObj, setCopyServicesFilterObj] = useState({});
  const [selectedCopyServiceIds, setSelectedCopyServiceIds] = useState([]);
  const [isAllCopyServicesSelected, setIsAllCopyServicesSelected] =
    useState(false);
  const [isCopySuccessOpen, setIsCopySuccessOpen] = useState(false);
  const [therapyOptions, setTherapyOptions] = useState([
    {
      label: "",
      value: 0,
    },
  ]);
  const [serviceCategories, setServiceCategories] = useState([]);
  const [categoryRuleData, setCategoryRuleData] = useState([]);
  const [serviceRuleData, setServiceRuleData] = useState([]);
  const [claimRuleData, setClaimRuleData] = useState([]);
  const [valueTypeCategoryRuleSublimit, setValueTypeCategoryRuleSublimit] =
    useState(2); // 1 for percent and 2 for amount
  const [valueTypeCategoryRulePerTran, setValueTypeCategoryRulePerTran] =
    useState(2);
  const [valueTypeCategoryRuleCoPay, setValueTypeCategoryRuleCoPay] =
    useState(2);
  const [valueTypeServiceRuleSublimit, setValueTypeServiceRuleSublimit] =
    useState(2);
  const [valueTypeClaimRuleSublimit, setValueTypeClaimRuleSublimit] =
    useState(2);
  const [valueTypeClaimRulePerTran, setValueTypeClaimRulePerTran] = useState(2);
  const [valueTypeClaimRuleCoPay, setValueTypeClaimRuleCoPay] = useState(2);

  const [dropdownAnchor, setDropdownAnchor] = useState(null);
  const [openIndex, setOpenIndex] = useState(null);
  const [allServices, setAllServices] = useState([]);
  const [walletFaqs, setWalletFaqs] = useState([]);
  const [settingFixedAmountFalse, setSettingFixedAmountFalse] = useState(false);

  const [checkBoxInvoiceDateRule, setCheckBoxInvoiceDateRule] = useState(false);
  const [checkBoxConsiderPlanDuration, setCheckBoxConsiderPlanDuration] =
    useState(false);
  const [checkBoxAddClaimRuleDeclaration, setCheckBoxAddClaimRuleDeclaration] =
    useState(false);
  const [checkBoxDocumentType, setCheckBoxDocumentType] = useState(false);
  const [claimFilingDuration, setClaimFilingDuration] = useState("");
  const [editorStateDeclaration, setEditorStateDeclaration] = useState(
    EditorState.createEmpty(),
  );
  const [declaration, setDeclaration] = useState("");
  const [documentTypeOptions, setDocumentTypeOptions] = useState([]);
  const [documentTypeData, setDocumentTypeData] = useState([
    {
      typeId: 0,
      text: "",
    },
  ]);

  const [serviceCategoriesOptions, setServiceCategoriesOptions] = useState([
    {
      label: "",
      value: 0,
    },
  ]);
  const [additionalPlanRulesObjArr, setAdditionalPlanRulesObjArr] = useState([
    { serviceCatId: 0, obj: {} },
  ]);
  const [checkBoxPrescriptionRequired, setCheckBoxPrescriptionRequired] =
    useState(false);
  const [prescribedMedicinesSelected, setPrescribedMedicinesSelected] =
    useState([]);

  const [advSpRulesOnPlanResponse, setAdvSpRulesOnPlanResponse] =
    useState(null);

  const [advSpRulesOnPlanResponseInitial, setAdvSpRulesOnPlanResponseInitial] =
    useState(null);

  const plansUtils = new PlansUtils();
  const assignedPlansUtil = new AssignedPlansUtil();
  const authenticationService = new AuthenticationService();
  // const serviceTypesResolverRef = useRef(null);

  const planMobileImageInputRef = useRef(null);
  const planDesktopImageInputRef = useRef(null);
  const { confirm, ConfirmDialog } = useConfirmDialog();
  const PERCENT_TYPE = 1;
  const AMOUNT_TYPE = 2;
  const defaultServiceCatId = 3;

  useEffect(() => {
    getFamilyRelations();
    getDocumentTypeOptions();
    getAllHealthCheckupServices();
    getVisionProviders();
    getVisionBenefits();
    if (props?.data?.mode == "view" || props?.data?.mode == "assign-service") {
      getPlan(props?.data?.planId);
      setMode(2);
    } else if (props?.data?.mode == "update" || props?.data?.mode == "renew") {
      getPlan(props?.data?.planId);
      setMode(3);
    } else if (props?.data?.mode == "copy") {
      getPlan(props?.data?.planId);
      setMode(1);
    } else if (props?.data?.mode == "create") {
      getServiceTypesForWallet();
      getAccount(props?.data?.accountId);
      setMode(1);
    }
    getAdvSpRulesOnPlanByFilter(props?.data?.planId, {}, true);
    getTherapy();

    setComponentMounted(true);
  }, []);

  useEffect(() => {
    if (fetchedVisionBenefits.length > 0 && rawEligibleCodes) {
      setSelectedEligibleBenefits(
        rawEligibleCodes
          .map((code) => {
            const b = fetchedVisionBenefits.find((b) => b.code === code);
            return b ? { label: b.name, value: b.id } : null;
          })
          .filter(Boolean),
      );
      setRawEligibleCodes(null);
    }
    if (fetchedVisionBenefits.length > 0 && rawIneligibleCodes) {
      setSelectedIneligibleBenefits(
        rawIneligibleCodes
          .map((code) => {
            const b = fetchedVisionBenefits.find((b) => b.code === code);
            return b ? { label: b.name, value: b.id } : null;
          })
          .filter(Boolean),
      );
      setRawIneligibleCodes(null);
    }
  }, [fetchedVisionBenefits, rawEligibleCodes, rawIneligibleCodes]);

  const useStylesForSelectDD = makeStyles(() => ({
    noUnderlineInput: {
      border: "1px solid #ccc",
      borderRadius: 15,
      padding: "10px",
      backgroundColor: "transparent",
      transition: "all 0.2s ease",
      "&:hover": {
        borderColor: "#aaa",
      },
      "&:focus": {
        backgroundColor: "transparent",
        borderRadius: 15,
      },
    },
    noUnderline: {
      "&:before, &:after": {
        display: "none",
      },
      "& .MuiSelect-select:focus": {
        backgroundColor: "transparent",
        borderRadius: 15,
      },
      "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
        borderRadius: 15,
      },
    },
  }));

  const classes = useStylesForSelectDD();

  useEffect(() => {
    if (
      fetchedPlan?.id &&
      (props?.data?.mode == "assign-service" || props?.data?.mode == "renew")
    ) {
      getAssignedServicesToPlanByFilter(fetchedPlan?.id);
    }
  }, [fetchedPlan, pageNum, pageSize]);

  useEffect(() => {
    if (
      fetchedPlan?.id &&
      (props?.data?.mode == "assign-service" || props?.data?.mode == "renew")
    ) {
      getAssignedServicesToPlanByFilter(fetchedPlan?.id, {
        ...(filterObj ?? {}),
        pageNum: 1,
      });
    }
  }, [filterObj]);

  useEffect(() => {
    if (
      fetchedPlan?.id &&
      (props?.data?.mode == "assign-service" || props?.data?.mode == "renew")
    ) {
      getAllAssignedServicesToPlan(fetchedPlan?.id);
    }
  }, [fetchedPlan]);

  useEffect(() => {
    if (!(serviceRuleData && serviceRuleData.length > 0)) {
      setValueTypeServiceRuleSublimit(valueTypeCategoryRuleSublimit);
    }
    if (!(claimRuleData && claimRuleData.length > 0)) {
      setValueTypeClaimRuleSublimit(valueTypeCategoryRuleSublimit);
      setValueTypeClaimRulePerTran(valueTypeCategoryRulePerTran);
      setValueTypeClaimRuleCoPay(valueTypeCategoryRuleCoPay);
    }
  }, [
    valueTypeCategoryRuleSublimit,
    valueTypeCategoryRulePerTran,
    valueTypeCategoryRuleCoPay,
  ]);

  const PRESCRIBED_MEDICINES_OPTIONS = [
    {
      label: "FMCG",
      value: "fmcg",
    },
    {
      label: "Pharma",
      value: "pharma",
    },
    {
      label: "PL",
      value: "pl",
    },
  ];

  useEffect(() => {
    if (
      serviceCategoriesOptions.length > 1 &&
      additionalPlanRulesObjArr[0].serviceCatId === 0
    ) {
      const exists = serviceCategoriesOptions.some(
        (opt) => opt.value === defaultServiceCatId,
      );
      if (exists) {
        const updated = [...additionalPlanRulesObjArr];
        updated[0].serviceCatId = defaultServiceCatId;
        setAdditionalPlanRulesObjArr(updated);
      }
    }
  }, [serviceCategoriesOptions]);

  useEffect(() => {
    if (mode !== 2 && isWalletIncluded) {
      setWalletExpanded(true);
    }
  }, [mode, isWalletIncluded]);
  useEffect(() => {
    if (mode !== 2 && isReimbursementIncluded) {
      setReimbursementExpanded(true);
    }
  }, [mode, isReimbursementIncluded]);
  useEffect(() => {
    if (mode !== 2 && isWalletFaqsIncluded) {
      setWalletFaqsExpanded(true);
    }
  }, [mode, isWalletFaqsIncluded]);
  useEffect(() => {
    if (mode !== 2 && isCategoryRuleEnabled) {
      setCategoryRuleExpanded(true);
    }
  }, [mode, isCategoryRuleEnabled]);
  useEffect(() => {
    if (mode !== 2 && isServiceRuleEnabled) {
      setServiceRuleExpanded(true);
    }
  }, [mode, isServiceRuleEnabled]);
  useEffect(() => {
    if (mode !== 2 && isClaimRuleEnabled) {
      setClaimRuleExpanded(true);
    }
  }, [mode, isClaimRuleEnabled]);
  useEffect(() => {
    if (mode !== 2 && isAdditionalClaimRuleEnabled) {
      setAdditionalClaimRuleExpanded(true);
    }
  }, [mode, isAdditionalClaimRuleEnabled]);
  useEffect(() => {
    if (mode !== 2 && isAdditionalPlanRuleEnabled) {
      setAdditionalPlanRuleExpanded(true);
    }
  }, [mode, isAdditionalPlanRuleEnabled]);
  useEffect(() => {
    if (mode !== 2 && isEyeCareIncluded) {
      setEyeCareExpanded(true);
    }
  }, [mode, isEyeCareIncluded]);
  useEffect(() => {
    if (mode !== 2 && isWelcomeMsgIncluded) {
      setWelcomeMsgExpanded(true);
    }
  }, [mode, isWelcomeMsgIncluded]);

  useEffect(() => {
    if (settingFixedAmountFalse === true) {
      if (areAllFixedAmountsFalse() === true) {
        setSettingFixedAmountFalse(false);
        // below cases are for changeWalletToUnLimited
        changeAllToAmountIfNeeded();
        setWalletLimitInEditState(walletLimit);
        setCanEditWalletLimit(false);
        setIsUnlimitedWallet(true);
      }
    }
  }, [
    settingFixedAmountFalse,
    categoryRuleData,
    serviceRuleData,
    claimRuleData,
  ]);

  useEffect(() => {
    if (
      componentMounted &&
      (props?.data?.mode == "assign-service" || props?.data?.mode == "renew")
    ) {
      setExpandableTile((prev) => (
        <ExpandableTableAssignedServices
          {...{
            data: {
              accountId: props?.data?.accountId,
              planData: fetchedPlan,
              assignedServices: assignedServicesArray,
              allAssignedServicesArray: allAssignedServicesArray,
            },
            setView: props?.setView,
            goToPrevPage: navigateToPrevPage,
            goToNextPage: navigateToNextPage,
            fetchAssignedServicesToPlanByFilter:
              getAssignedServicesToPlanByFilter,
            totalCount: totalCount,
            pageNum: pageNum,
            pageSize: pageSize,
            filterObj: filterObj,
            setFilterObj: setFilterObj,
            mode: props?.data?.mode == "renew" ? 2 : 1,
          }}
        />
      ));
    }
  }, [assignedServicesArray, allAssignedServicesArray]);

  useEffect(() => {
    if (
      areArraysEqual(allRelations, allowedFamilyRelationsForWallet) &&
      allowedFamilyRelationsForWallet.length != 0
    ) {
      setSelectAllFamilyForWallet(true);
    } else {
      setSelectAllFamilyForWallet(false);
    }
  }, [allowedFamilyRelationsForWallet, allRelations]);
  useEffect(() => {
    if (
      areArraysEqual(allRelations, allowedFamilyRelationsForReimbursement) &&
      allowedFamilyRelationsForReimbursement.length != 0
    ) {
      setSelectAllFamilyForReimbursement(true);
    } else {
      setSelectAllFamilyForReimbursement(false);
    }
  }, [allowedFamilyRelationsForReimbursement, allRelations]);

  useEffect(() => {
    if (isWalletIncluded == false) {
      setIsUnlimitedWallet(false);
      setWalletLimit("");
      setWalletLimitInEditState("");
      setCanEditWalletLimit(false);
      setWalletCanBeUsedByFamily(false);
      setSelectAllFamilyForWallet(false);
      setAllowedFamilyRelationsForWallet([]);
      setWalletExpanded(false);
      //----
      setIsReimbursementIncluded(false);
      setIsWalletFaqsIncluded(false);
      setIsCategoryRuleEnabled(false);
      setIsServiceRuleEnabled(false);
      setIsClaimRuleEnabled(false);
    }
  }, [isWalletIncluded]);

  useEffect(() => {
    if (isReimbursementIncluded == false) {
      setReimbursementCanBeUsedByFamily(false);
      setIsBankAccountRequired(false);
      setSelectAllFamilyForReimbursement(false);
      setAllowedFamilyRelationsForReimbursement([]);
      setReimbursementExpanded(false);
      //----
      setIsClaimRuleEnabled(false);
      if (isAdditionalClaimRuleEnabled) {
        setIsAdditionalClaimRuleEnabled(false);
      }
    }
  }, [isReimbursementIncluded]);

  useEffect(() => {
    if (isWalletFaqsIncluded === false) {
      setWalletFaqs([]);
      setWalletFaqsExpanded(false);
    }
  }, [isWalletFaqsIncluded]);

  useEffect(() => {
    if (isCategoryRuleEnabled === false && serviceCategories.length > 0) {
      createEmptyCategoryRule(serviceCategories);
      setCategoryRuleExpanded(false);
      // setIsServiceRuleEnabled(false);
      // setIsClaimRuleEnabled(false);
    }
  }, [isCategoryRuleEnabled]);

  useEffect(() => {
    if (isServiceRuleEnabled === false) {
      setServiceRuleData([]);
      setServiceRuleExpanded(false);
    }
  }, [isServiceRuleEnabled]);

  useEffect(() => {
    if (isClaimRuleEnabled === false) {
      setClaimRuleData([]);
      setClaimRuleExpanded(false);
    }
  }, [isClaimRuleEnabled]);

  useEffect(() => {
    if (isWelcomeMsgIncluded == false) {
      setCustomMessage("");
      setIsCTAButtonEnabled(false);
      setCtaText("");
      setCustomCtaText("");
      setCtaLink("");
      setEditorState2(EditorState.createEmpty());
    }
  }, [isWelcomeMsgIncluded]);

  useEffect(() => {
    if (planMobileImage != null) {
      uploadImage(planMobileImage)
        .then((e) => {
          setPlanMobilePreview(e);
        })
        .catch((err) => {
          EventService.emit("showError", {
            message: `Error while uploading the plan mobile image: ${err}`,
          });
        });
    }
  }, [planMobileImage]);
  useEffect(() => {
    if (planDesktopImage != null) {
      uploadImage(planDesktopImage)
        .then((e) => {
          setPlanDesktopPreview(e);
        })
        .catch((err) => {
          EventService.emit("showError", {
            message: `Error while uploading the plan desktop image: ${err}`,
          });
        });
    }
  }, [planDesktopImage]);

  useEffect(() => {
    if (!isAdditionalClaimRuleEnabled) {
      setCheckBoxInvoiceDateRule(false);
      setCheckBoxConsiderPlanDuration(false);
      setCheckBoxAddClaimRuleDeclaration(false);
      setCheckBoxDocumentType(false);
      setClaimFilingDuration("");
      setEditorStateDeclaration(EditorState.createEmpty());
      setDeclaration("");
      resetDocumentTypeData();
      setAdditionalClaimRuleExpanded(false);
    }
  }, [isAdditionalClaimRuleEnabled]);

  useEffect(() => {
    if (!isAdditionalPlanRuleEnabled) {
      setCheckBoxPrescriptionRequired(false);
      setPrescribedMedicinesSelected([]);
    }
  }, [isAdditionalPlanRuleEnabled]);

  const OrangeRadio = withStyles({
    root: {
      color: "#F97E0F",
      padding: 0,
      transform: "scale(0.8)",
      margin: -1,
      "&$checked": {
        color: "#F97E0F",
      },
    },
    checked: {},
  })((props) => <Radio disableRipple {...props} />);

  const PurpleRadio = withStyles({
    root: {
      color: "#6A5EF5",
      padding: 0,
      transform: "scale(0.8)",
      margin: -1,
      "&$checked": {
        color: "#6A5EF5",
      },
    },
    checked: {},
  })((props) => <Radio disableRipple {...props} />);

  const uploadImage = (file) => {
    return new Promise((resolve, reject) => {
      const data = new FormData();
      data.append("file", file, file.name);

      plansUtils.uploadImg(
        data,
        (res) => {
          resolve(res.publicUrl);
        },
        (err) => {
          reject(err);
        },
      );
    });
  };

  const navigateToNextPage = () => {
    if (pageNum * pageSize < totalCount) {
      setPageNum((prevPageNum) => prevPageNum + 1);
    }
  };
  const navigateToPrevPage = () => {
    if (pageNum > 1) {
      setPageNum((prevPageNum) => prevPageNum - 1);
    }
  };

  const areArraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;
    return [...arr1].sort().toString() === [...arr2].sort().toString();
  };

  let PLAN_STATUS_OPTIONS = [
    {
      label: "Active",
      value: 1,
    },
    {
      label: "Inactive",
      value: 2,
    },
  ];
  let WALLET_TYPE_OPTIONS = [
    {
      label: "Limited",
      value: 1,
    },
    {
      label: "Unlimited",
      value: 2,
    },
  ];

  let CTA_BUTTON_OPTIONS = [
    {
      label: "Open Camera",
      value: "OPEN_CAMERA",
    },
    {
      label: "Open Upload Image",
      value: "UPLOAD_IMAGE",
    },
    {
      label: "Open Meditation",
      value: "OPEN_MEDITATION",
    },
    {
      label: "Open Upload Documents",
      value: "UPLOAD_DOCUMENT",
    },
    {
      label: "Open Vital Chart",
      value: "OPEN_VITAL_CHART",
    },
    {
      label: "Open Share Vitals",
      value: "OPEN_VITAL",
    },
    {
      label: "Open Routine Reporting",
      value: "OPEN_REPORTING",
    },
    {
      label: "Open Health Plan",
      value: "OPEN_HEALTH_PLAN",
    },
    {
      label: "Open Profile",
      value: "OPEN_PROFILE",
    },
    {
      label: "Open Upload Option",
      value: "OPEN_UPLOAD_OPTION",
    },
    {
      label: "Open Home",
      value: "OPEN_HOME",
    },
    {
      label: "Get Offer",
      value: "BOOKING_OFFER",
    },
    {
      label: "Custom CTA text",
      value: "CUSTOM_CTA",
    },
  ];
  function getLabelFromValue(value) {
    const option = CTA_BUTTON_OPTIONS.find((opt) => opt.value === value);
    return option ? option.label : null;
  }

  const exitPage = () => {
    setMode(1);
    setAccountDetails(null);
    setPlanName("");
    setPlanPrice("");
    setPlanStatus("");
    setPlanDuration("");
    setPlanDateFrom(null);
    setPlanDateTo(null);
    setPlanDefaultTherapy(null);
    setPlanMobileImage(null);
    setPlanMobilePreview("");
    setPlanDesktopImage(null);
    setPlanDesktopPreview("");
    setPlanShortDescription("");
    setEditorState(EditorState.createEmpty());
    setPlanLongDescription("");
    setPlanAutoActivate(false);
    setPlanEmailDomains([]);
    setDomainTyped("");
    setIsWalletIncluded(false);
    setIsUnlimitedWallet(false);
    setCanEditWalletLimit(false);
    setWalletLimit("");
    setWalletLimitInEditState("");
    setWalletCanBeUsedByFamily(false);
    setFamilyRelationsArr([]);
    setAllRelations([]);
    setSelectAllFamilyForWallet(false);
    setAllowedFamilyRelationsForWallet([]);
    setIsReimbursementIncluded(false);
    setReimbursementCanBeUsedByFamily(false);
    setIsBankAccountRequired(false);
    setSelectAllFamilyForReimbursement(false);
    setAllowedFamilyRelationsForReimbursement([]);
    setIsWelcomeMsgIncluded(false);
    setCustomMessage("");
    setIsCTAButtonEnabled(false);
    setCtaText("");
    setCtaButton("");
    setCustomCtaText("");
    setCtaLink("");
    setEditorState2(EditorState.createEmpty());
    setLoading(false);
    setPlanToUpdate(null);
    setOpenRenewDialog(false);
    setOpenInactiveDialog(false);
    setOpenEndDateChangeDialog(false);
    setEndDateUpdateError(null);
    setServiceCategories([]);
    setCategoryRuleData([]);
    setAllServices([]);
    props.setView(2, {
      mode: "assign",
      accountId: props?.data?.accountId,
    });
  };

  const getTherapy = () => {
    const onResponse = (res) => {
      if (res != null && res.fields != null && res.fields.length > 0) {
        let allTherapies = res.fields.map((e) => {
          return {
            label: e.text,
            value: Number(e.tag.trim()),
          };
        });
        setTherapyOptions([...therapyOptions, ...allTherapies]);
      }
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    plansUtils.getTherapy(onResponse, onError);
  };
  const getAccount = (id) => {
    const onResponse = (res) => {
      setAccountDetails(res);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    plansUtils.getAccountsById(id, onResponse, onError);
  };

  const getAccountByAccountCode = (code) => {
    let body = {
      pageNum: 1,
      pageSize: 1,
      accountCode: code,
    };
    const onResponse = (res) => {
      setAccountDetails(res.accounts[0]);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    plansUtils.getAccountsByFilter(body, onResponse, onError);
  };

  const getAllAssignedServicesToPlan = (id) => {
    const onResponse = (res) => {
      setAllAssignedServicesArray(res?.services ?? []);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };

    plansUtils.getAssignedServicesToPlanByFilter(
      {
        pageNum: 0,
        pageSize: 0,
        planIds: [id],
      },
      onResponse,
      onError,
    );
  };

  const getAssignedServicesToPlanByFilter = (id, filters) => {
    const onResponse = (res) => {
      setTotalCount((prev) => res?.totalCount ?? 0);
      setAssignedServicesArray(res?.services ?? []);
      if (filters) {
        setPageNum(1);
      }
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };

    plansUtils.getAssignedServicesToPlanByFilter(
      {
        pageNum: pageNum,
        pageSize: pageSize,
        planIds: [id],
        ...(filters ? filters : (filterObj ?? {})),
        includeGroupRuleDetails: true,
        // "serviceTypeIds":["67ac2bf47a2de919dc103605"]
      },
      onResponse,
      onError,
    );
  };

  const getAdvSpRulesOnPlanByFilter = (id, filters, initialCall = false) => {
    const onResponse = (res) => {
      setAdvSpRulesOnPlanResponse(res);
      if (initialCall) {
        setAdvSpRulesOnPlanResponseInitial(res);
      }
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error while fetching advance sponsorship rules: ${err?.message}`,
      });
    };

    assignedPlansUtil.getAdvSpRulesOnPlanByFilter(
      {
        planId: id,
        ...(filters ? filters : {}),
      },
      true,
      onResponse,
      onError,
    );
  };

  const getVisionBenefits = () => {
    const onResponse = (res) => {
      let visionBenefits = res.benefits;
      setFetchedVisionBenefits(visionBenefits);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    plansUtils.getVisionBenefits(onResponse, onError);
  };

  const getVisionProviders = () => {
    const onResponse = (res) => {
      let visionProviders = res.providers;
      setFetchedVisionProviders(visionProviders);
      // Default-select all providers only when creating a new plan. For
      // view/update/renew/copy the prefill from getPlan() decides which
      // providers are checked, so don't override it here.
      if (props?.data?.mode == "create") {
        setSelectedVisionProviders(visionProviders.map((p) => p.id));
      }
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    plansUtils.getVisionServiceProviders(onResponse, onError);
  };

  // Switching the eye care module discards the configuration of the module we
  // are leaving. Module 1 and Module 2 are mutually exclusive, so the cashless
  // provider selection (shared array, filtered by moduleType) and all the
  // Module 2-only fields are cleared whenever the user moves to the other module.
  const handleEyeCareModuleChange = (newModule) => {
    if (newModule === eyeCareModule) return;
    setSelectedVisionProviders([]);
    setEditorStateVisionBenefits(EditorState.createEmpty());
    setVisionModuleTwoBenefitsCovered("");
    setSelectedEligibleBenefits([]);
    setSelectedIneligibleBenefits([]);
    setRawEligibleCodes(null);
    setRawIneligibleCodes(null);
    setEyeCareModule(newModule);
  };

  const getPlan = (id) => {
    let body = {
      pageNum: 1,
      pageSize: 1,
      planIds: [id],
    };

    const onResponse = (res) => {
      let plan = res.plans[0];
      let accountCode = plan.accountCode;

      if (props?.data?.mode == "copy") {
        // Copy mode: new plan belongs to the target account
        // (props.data.accountId), not the source plan's account.
        getAccount(props?.data?.accountId);
      } else {
        getAccountByAccountCode(accountCode);
      }
      setFetchedPlan(plan);
      getServiceTypesForWallet(plan);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };

    plansUtils.getPlanByFilter(body, onResponse, onError);
  };

  const setData = (plan, ser) => {
    const isCopy = props?.data?.mode == "copy";
    // const stringifiedClaimRules = normalizeValueFields(normalizedClaimRules, 'numberToString');
    setPlanName(isCopy ? "" : plan.basicDetails.name);
    setPlanPrice(plan.basicDetails.price == 0 ? "" : plan.basicDetails.price);
    setPlanStatus(
      props?.data?.mode == "renew" || isCopy ? 1 : plan.basicDetails.status,
    );
    setPlanDuration(
      props?.data?.mode == "renew" || isCopy
        ? ""
        : plan.basicDetails.duration == 0
          ? ""
          : plan.basicDetails.duration,
    );
    setPlanDateFrom(
      props?.data?.mode == "renew" || isCopy
        ? null
        : plan.basicDetails.startDate,
    );
    setPlanDateTo(
      props?.data?.mode == "renew" || isCopy
        ? null
        : moment.utc(plan.basicDetails.endDate).startOf("day").toISOString(),
    );
    setPlanDefaultTherapy(plan.basicDetails?.defaultTherapy);

    setPlanMobilePreview(
      isCopy
        ? ""
        : plan.basicDetails.mobileCover
          ? plan.basicDetails.mobileCover
          : "",
    );

    setPlanDesktopPreview(
      isCopy
        ? ""
        : plan.basicDetails.desktopCover
          ? plan.basicDetails.desktopCover
          : "",
    );
    setPlanShortDescription(
      plan.basicDetails.shortDescription
        ? plan.basicDetails.shortDescription
        : "",
    );
    let contentBlock = htmlToDraft(plan?.basicDetails?.longDescription);
    if (contentBlock) {
      let contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks,
      );
      let editorState = EditorState.createWithContent(contentState);
      setEditorState(editorState);
    }
    setPlanLongDescription(
      plan.basicDetails.longDescription
        ? plan.basicDetails.longDescription
        : "",
    );
    setPlanAutoActivate(plan.basicDetails.autoActivate);
    setPlanEmailDomains(
      isCopy ||
        plan.basicDetails.emailDomains == null ||
        plan.basicDetails.emailDomains.length === 0
        ? []
        : plan.basicDetails.emailDomains,
    );
    setIsWalletIncluded(plan.walletDetails.isWalletIncluded);
    setIsUnlimitedWallet(plan.walletDetails.isUnlimitedWallet);
    setWalletLimit(
      plan?.walletDetails?.walletLimit === null ||
        plan.walletDetails.walletLimit === 0
        ? ""
        : plan.walletDetails.walletLimit,
    );
    setWalletLimitInEditState(
      plan?.walletDetails?.walletLimit === null ||
        plan.walletDetails.walletLimit === 0
        ? ""
        : plan.walletDetails.walletLimit,
    );
    setWalletCanBeUsedByFamily(plan.walletDetails.canBeUsedByFamily);
    setAllowedFamilyRelationsForWallet(
      plan.walletDetails.allowedFamilyRelations === null ||
        plan.walletDetails.allowedFamilyRelations.length === 0
        ? []
        : plan.walletDetails.allowedFamilyRelations,
    );
    setIsReimbursementIncluded(
      plan.reimbursementDetails.isReimbursementIncluded,
    );
    setReimbursementCanBeUsedByFamily(
      plan.reimbursementDetails.canReimburseUsedByFamily,
    );
    setIsBankAccountRequired(
      plan?.reimbursementDetails?.isBankAccountRequired ?? false,
    );

    setAllowedFamilyRelationsForReimbursement(
      plan.reimbursementDetails.allowedFamilyRelations === null ||
        plan.reimbursementDetails.allowedFamilyRelations.length === 0
        ? []
        : plan.reimbursementDetails.allowedFamilyRelations,
    );
    const walletFaqs = Array.isArray(plan.walletFaqs) ? plan.walletFaqs : [];
    setIsWalletFaqsIncluded(walletFaqs.length > 0);
    setWalletFaqs(walletFaqs);

    const walletRules = plan.walletRules ?? {};

    if (!walletRules.isCategoryRuleEnabled) {
      // If undefined or false
      createEmptyCategoryRule(ser);
    } else {
      // Only runs when isCategoryRuleEnabled is true
      setIsCategoryRuleEnabled(walletRules.isCategoryRuleEnabled);

      setCategoryRuleData(
        walletRules.serviceCategoryRules == null ||
          walletRules.serviceCategoryRules.length === 0
          ? []
          : walletRules.serviceCategoryRules,
      );

      if (
        walletRules.serviceCategoryRules &&
        walletRules.serviceCategoryRules.length > 0
      ) {
        const first = walletRules.serviceCategoryRules[0];
        setValueTypeCategoryRuleSublimit(first.sublimit.unit);
        setValueTypeCategoryRulePerTran(first.perTransactionlimit.unit);
        setValueTypeCategoryRuleCoPay(first.coPaylimit.unit);
      }

      // const serviceTypes = await getServiceTypesForWalletAsync();

      // if (!Array.isArray(walletRules.serviceCategoryRules)) {
      //   createEmptyCategoryRule(serviceTypes);
      // } else {
      //   setCategoryRuleData(walletRules.serviceCategoryRules);
      // }
    }

    setIsServiceRuleEnabled(walletRules.isServiceRuleEnabled ?? false);

    setServiceRuleData(walletRules.serviceRules ?? []);

    if (walletRules.serviceRules && walletRules.serviceRules.length > 0) {
      const first = walletRules.serviceRules[0];
      setValueTypeServiceRuleSublimit(first.sublimit.unit);
    }

    setIsClaimRuleEnabled(walletRules.isClaimRuleEnabled ?? false);

    setClaimRuleData(walletRules.claimRules ?? []);
    if (walletRules.claimRules && walletRules.claimRules.length > 0) {
      const first = walletRules.claimRules[0];
      setValueTypeClaimRuleSublimit(first.sublimit.unit);
      setValueTypeClaimRulePerTran(first.perTransactionlimit.unit);
      setValueTypeClaimRuleCoPay(first.coPaylimit.unit);
    }

    const additionalClaimRules = plan?.additionalClaimRules;

    if (additionalClaimRules?.enabled) {
      setIsAdditionalClaimRuleEnabled(true);

      const { invoiceDate, declaration, documentType } = additionalClaimRules;

      if (invoiceDate?.enabled) {
        setCheckBoxInvoiceDateRule(true);

        const minDays = invoiceDate.invoiceMinDays ?? 0;
        setClaimFilingDuration(minDays);

        if (invoiceDate.permitBeforePlanStartDate) {
          setCheckBoxConsiderPlanDuration(true);
        }
      }

      if (declaration?.enabled) {
        setCheckBoxAddClaimRuleDeclaration(true);

        const declarationText = declaration.text ?? "";
        setDeclaration(declarationText);

        const contentBlock = htmlToDraft(declarationText);
        if (contentBlock) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock.contentBlocks,
          );
          setEditorStateDeclaration(
            EditorState.createWithContent(contentState),
          );
        }
      }

      if (documentType?.enabled) {
        setCheckBoxDocumentType(true);
        setDocumentTypeData(documentType.options ?? []);
      }
    }

    const pharmacyRules = plan?.additionalPlanRules?.pharmacyRules;

    if (
      pharmacyRules?.prescriptionRequired ||
      (pharmacyRules?.allowedCategories &&
        pharmacyRules?.allowedCategories.length > 0)
    ) {
      setIsAdditionalPlanRuleEnabled(true);
      setCheckBoxPrescriptionRequired(
        pharmacyRules?.prescriptionRequired ? true : false,
      );

      const allowed = pharmacyRules.allowedCategories || [];
      setPrescribedMedicinesSelected(
        PRESCRIBED_MEDICINES_OPTIONS.filter((e) => allowed.includes(e.value)),
      );
      setAdditionalPlanRulesObjArr((prev) => {
        if (prev.some((item) => item.serviceCatId === defaultServiceCatId))
          return prev; // already set
        const updated = [...prev];
        updated[0] = { ...updated[0], serviceCatId: defaultServiceCatId };
        return updated;
      });
    }

    const eyeCareDetails = plan?.eyeCareDetails;
    if (
      eyeCareDetails?.eyeModuleOneDetails != null ||
      eyeCareDetails?.eyeModuleTwoDetails != null
    ) {
      setIsEyeCareIncluded(true);
      if (eyeCareDetails?.eyeModuleOneDetails != null) {
        setEyeCareModule(1);
        setSelectedVisionProviders(
          eyeCareDetails.eyeModuleOneDetails.eyeCareCashlessProviders ?? [],
        );
      } else if (eyeCareDetails?.eyeModuleTwoDetails != null) {
        setEyeCareModule(2);
        setSelectedVisionProviders(
          eyeCareDetails.eyeModuleTwoDetails.eyeCareCashlessProviders ?? [],
        );
        const benefitsDesc =
          eyeCareDetails.eyeModuleTwoDetails.benefitsDescription ?? "";
        setVisionModuleTwoBenefitsCovered(benefitsDesc);
        const contentBlockVision = htmlToDraft(benefitsDesc);
        if (contentBlockVision) {
          const contentState = ContentState.createFromBlockArray(
            contentBlockVision.contentBlocks,
          );
          setEditorStateVisionBenefits(
            EditorState.createWithContent(contentState),
          );
        }
        setRawEligibleCodes(
          eyeCareDetails.eyeModuleTwoDetails.eligibleCategories ?? [],
        );
        setRawIneligibleCodes(
          eyeCareDetails.eyeModuleTwoDetails.inEligibleCategories ?? [],
        );
      }
    }

    setIsWelcomeMsgIncluded(plan.planChatDetails.isCustomMessage);
    setCustomMessage(
      plan.planChatDetails.customMessage
        ? plan.planChatDetails.customMessage
        : "",
    );
    setIsCTAButtonEnabled(plan.planChatDetails.isCTAButton);
    setCtaButton(plan.planChatDetails.ctaButton);
    setCustomCtaText(
      plan.planChatDetails.ctaButton === "CUSTOM_CTA"
        ? plan.planChatDetails.ctaText
        : "",
    );
    setCtaLink(plan.planChatDetails.ctaLink);
    let contentBlock2 = htmlToDraft(
      plan.planChatDetails.customMessage
        ? plan.planChatDetails.customMessage
        : "",
    );
    if (contentBlock2) {
      let contentState = ContentState.createFromBlockArray(
        contentBlock2.contentBlocks,
      );
      let editorState2 = EditorState.createWithContent(contentState);
      setEditorState2(editorState2);
    }

    setLoading(false);
  };

  const getFamilyRelations = () => {
    const onResponse = (res) => {
      let desiredOrder = [5, 3, 1, 2, 4, 8, 9, 6, 7, 10];
      res.sort((a, b) => {
        return desiredOrder.indexOf(a.code) - desiredOrder.indexOf(b.code);
      });
      let allRelations = res.map((e) => {
        return e.code;
      });
      setAllRelations(allRelations);
      setFamilyRelationsArr(res);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    plansUtils.getFamilyRelations(onResponse, onError);
  };

  const getDocumentTypeOptions = () => {
    const onResponse = (res) => {
      if (res && res.length > 0) {
        setDocumentTypeOptions(
          res.map((e) => {
            return {
              label: e.name,
              value: e.id,
            };
          }),
        );
      }
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    plansUtils.getDocumentTypeOptions(onResponse, onError);
  };

  const getAllHealthCheckupServices = () => {
    const onResponse = (res) => {
      setAllServices(
        res === null || res.services === null || res.services.length === 0
          ? []
          : res.services,
      );
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    plansUtils.getServicesByFilter(
      {
        pageNum: 0,
        pageSize: 0,
        serviceTypeIds: [2],
      },
      onResponse,
      onError,
    );
  };
  const renderWhitelistedDomains = () => {
    if (accountDetails?.whitelistedDomains) {
      if (accountDetails.whitelistedDomains.length == 0) {
        return <></>;
      } else {
        return (
          <div className="account-module-domains-container">
            {accountDetails.whitelistedDomains.map((e, index) => {
              return (
                <div
                  className="account-module-domains-box"
                  style={{ marginTop: "10px" }}
                >
                  <div className="account-module-font">{`@${e}`}</div>
                </div>
              );
            })}
          </div>
        );
      }
    }
  };

  const planMobileUploadClick = () => {
    if (planMobileImageInputRef.current) {
      planMobileImageInputRef.current.click();
    }
  };

  const planMobileImageSelected = (event) => {
    const file = event.target.files[0];

    if (!file) {
      console.log("No file selected or file picker was canceled");
      return;
    }

    const maxSize = 20 * 1024 * 1024; // 20MB
    if (file.size > maxSize) {
      EventService.emit("showError", {
        message: "File size cannot be more than 20MB",
      });
      return;
    }

    const img = new Image();
    img.onload = function () {
      const { width, height } = this;
      const aspectRatio = width / height;

      if (width < 328 || height < 175) {
        EventService.emit("showError", {
          message: "Image dimensions must be at least 328x175 pixels",
        });
        return;
      }

      if (aspectRatio < 1.865 || aspectRatio > 1.885) {
        EventService.emit("showError", {
          message:
            "Aspect ratio (width/height) must be between 1.865 and 1.885",
        });
        return;
      }

      setPlanMobileImage(file);
    };

    img.src = URL.createObjectURL(file);
  };

  const planDesktopUploadClick = () => {
    if (planDesktopImageInputRef.current) {
      planDesktopImageInputRef.current.click();
    }
  };

  const planDesktopImageSelected = (event) => {
    const file = event.target.files[0];

    if (!file) {
      console.log("No file selected or file picker was canceled");
      return;
    }

    const maxSize = 20 * 1024 * 1024; // 20MB
    if (file.size > maxSize) {
      EventService.emit("showError", {
        message: "File size cannot be more than 20MB",
      });
      return;
    }

    const img = new Image();
    img.onload = function () {
      const { width, height } = this;
      const aspectRatio = width / height;

      if (width < 435 || height < 232) {
        EventService.emit("showError", {
          message: "Image dimensions must be at least 435x232 pixels",
        });
        return;
      }

      if (aspectRatio < 1.865 || aspectRatio > 1.885) {
        EventService.emit("showError", {
          message:
            "Aspect ratio (width/height) must be between 1.865 and 1.885",
        });
        return;
      }

      setPlanDesktopImage(file);
    };

    img.src = URL.createObjectURL(file);
  };

  const _onEditorStateChange = (editorState) => {
    let body = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    setPlanLongDescription(body);
    setEditorState(editorState);
  };
  const _onEditorStateChange2 = (editorState2) => {
    let body = draftToHtml(convertToRaw(editorState2.getCurrentContent()));
    setCustomMessage(body);
    setEditorState2(editorState2);
  };
  const _onEditorStateChangeDeclaration = (editorStateDeclaration) => {
    let body = draftToHtml(
      convertToRaw(editorStateDeclaration.getCurrentContent()),
    );
    setDeclaration(body);
    setEditorStateDeclaration(editorStateDeclaration);
  };
  const _onEditorStateChangeVisionBenefits = (editorStateVisionBenefits) => {
    let body = draftToHtml(
      convertToRaw(editorStateVisionBenefits.getCurrentContent()),
    );
    setVisionModuleTwoBenefitsCovered(body);
    setEditorStateVisionBenefits(editorStateVisionBenefits);
  };

  const handleAddPlanEmailDomainIcon = () => {
    if (domainTyped.trim() != "") {
      setPlanEmailDomains([...planEmailDomains, domainTyped]);
      setDomainTyped("");
    }
  };
  const renderPlanEmailDomains = () => {
    if (planEmailDomains.length == 0) {
      return <></>;
    } else {
      return (
        <div className="mp-plan-domains-container">
          {planEmailDomains.map((e, index) => {
            return (
              <div className="mp-plan-domains-box">
                <div className="mp-plan-font">{`@${e}`}</div>
                <div>
                  <FontIcon
                    style={{
                      color: "#6A5EF5",
                      fontSize: "17px",
                      fontWeight: 700,
                      marginLeft: "8px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      if (mode != 2) {
                        let removedDomainObj = planEmailDomains.filter(
                          (_, i) => i !== index,
                        );
                        setPlanEmailDomains(removedDomainObj);
                      }
                    }}
                  >
                    close
                  </FontIcon>
                </div>
              </div>
            );
          })}
        </div>
      );
    }
  };

  // ZY-10084: plan end date rules, mirrored from api-client-config-service so the user is
  // told at the point of editing rather than by a 400 after submitting.

  // True when the plan end date differs from the one the plan was fetched with. Both sides are
  // compared at the start of their UTC day, matching how the payload is built.
  const isPlanEndDateChanged = () => {
    const originalEndDate = fetchedPlan?.basicDetails?.endDate
      ? moment.utc(fetchedPlan.basicDetails.endDate).startOf("day").toISOString()
      : null;
    const currentEndDate = planDateTo
      ? moment.utc(planDateTo).startOf("day").toISOString()
      : null;
    return originalEndDate !== currentEndDate;
  };

  // Editing a plan that already exists, as opposed to creating, copying or renewing one. Only
  // then is there a settled end date that the edit has to move forward from.
  const isExistingPlanEdit = () => mode === 3 && props?.data?.mode !== "renew";

  // ZY-10084: the end date of an existing plan only ever moves forward. Two floors apply - it
  // can never land in the past, and it can never come back from the date the plan was fetched
  // with - so the earliest day a change may land on is whichever of the two is later. Today
  // itself is allowed, since today is a valid last day for a plan. Create, copy and renew are
  // not moving a settled end date, so only the "not in the past" floor applies to them.
  const getPlanEndDateFloor = () => {
    const today = moment.utc().startOf("day");
    if (!isExistingPlanEdit()) return today;
    const originalEndDate = fetchedPlan?.basicDetails?.endDate
      ? moment.utc(fetchedPlan.basicDetails.endDate).startOf("day")
      : null;
    if (!originalEndDate) return today;
    return originalEndDate.isAfter(today) ? originalEndDate : today;
  };

  const isPlanEndDateAllowed = (endDate) => {
    if (!endDate) return false;
    return moment
      .utc(endDate)
      .startOf("day")
      .isSameOrAfter(getPlanEndDateFloor());
  };

  // The picker must not offer a day the form would refuse to save - a KAM cannot pick what they
  // would not be allowed to submit. The end date also still cannot precede the plan start date,
  // so the floor is whichever is later. Create, copy and renew keep their own floors, which
  // exist for different reasons.
  const getPlanEndDateMinDate = (baseMinDate) => {
    if (!isExistingPlanEdit()) return baseMinDate;
    const floor = getPlanEndDateFloor();
    if (!baseMinDate) return floor;
    return moment.utc(baseMinDate).isAfter(floor) ? baseMinDate : floor;
  };

  // Propagating a new end date down to patients is limited to accounts on this code prefix,
  // which is the "Corporate" account type shown on the plan form. Plans on any other account
  // can still have their end date changed - only the propagation is withheld, so the dialog
  // offers no Yes for them.
  const PLAN_END_DATE_PROPAGATION_ACCOUNT_CODE_PREFIX = "04";
  const isAccountEligibleForEndDatePropagation = () =>
    (accountDetails?.accountCode || "")
      .trim()
      .startsWith(PLAN_END_DATE_PROPAGATION_ACCOUNT_CODE_PREFIX);

  const handleSave = () => {
    if (isDataValid()) {
      let planObj = {
        accountId: mode == 3 ? accountDetails.id : props?.data?.accountId,
        accountCode: accountDetails?.accountCode,
        tenantId: authenticationService.getTenantId(),
        basicDetails: {
          name: planName,
          price: planPrice == "" ? 0 : planPrice,
          status: planStatus,
          mobileCover: planMobilePreview,
          desktopCover: planDesktopPreview,
          shortDescription: planShortDescription,
          longDescription: planLongDescription,
          duration: planDuration == "" ? 0 : planDuration,
          startDate: planDateFrom,
          endDate: planDateTo,
          defaultTherapy: planDefaultTherapy == null ? 0 : planDefaultTherapy,
          autoActivate: planAutoActivate,
          emailDomains: planEmailDomains,
        },
        walletDetails: {
          isWalletIncluded: isWalletIncluded,
          isUnlimitedWallet: isUnlimitedWallet,
          walletLimit:
            isWalletIncluded === false
              ? null
              : isUnlimitedWallet
                ? null
                : walletLimit == ""
                  ? null
                  : walletLimit,
          canBeUsedByFamily: canWalletBeUsedByFamily,
          allowedFamilyRelations: allowedFamilyRelationsForWallet,
        },
        reimbursementDetails: {
          isReimbursementIncluded: isReimbursementIncluded,
          canReimburseUsedByFamily: canReimbursementBeUsedByFamily,
          allowedFamilyRelations: allowedFamilyRelationsForReimbursement,
          isBankAccountRequired: isBankAccountRequired ?? false,
        },
        walletRules:
          mode === 3 && isWalletIncluded === false
            ? {}
            : {
                isCategoryRuleEnabled: isCategoryRuleEnabled,
                serviceCategoryRules:
                  isCategoryRuleEnabled === false
                    ? null
                    : normalizeValueFields(categoryRuleData, "stringToNumber"),
                isServiceRuleEnabled: isServiceRuleEnabled,
                serviceRules:
                  isServiceRuleEnabled === false
                    ? null
                    : normalizeValueFields(serviceRuleData, "stringToNumber"),
                isClaimRuleEnabled: isClaimRuleEnabled,
                claimRules:
                  isClaimRuleEnabled === false
                    ? null
                    : normalizeValueFields(claimRuleData, "stringToNumber"),
              },
        walletFaqs:
          mode === 3 && walletFaqs.length === 0
            ? []
            : isWalletFaqsIncluded && walletFaqs.length > 0
              ? walletFaqs
              : null,
        additionalClaimRules: {
          enabled: isAdditionalClaimRuleEnabled,
          invoiceDate: {
            enabled: checkBoxInvoiceDateRule,
            invoiceMinDays: claimFilingDuration == "" ? 0 : claimFilingDuration,
            permitBeforePlanStartDate: checkBoxConsiderPlanDuration,
          },
          declaration: {
            enabled: checkBoxAddClaimRuleDeclaration,
            text: declaration,
          },
          documentType: {
            enabled: checkBoxDocumentType,
            options: documentTypeData.filter((e) => e.typeId != 0),
          },
        },
        additionalPlanRules: {
          pharmacyRules: {
            allowedCategories: prescribedMedicinesSelected.map((e) => e.value),
            prescriptionRequired: checkBoxPrescriptionRequired,
          },
        },
        eyeCareDetails: isEyeCareIncluded
          ? eyeCareModule === 1
            ? {
                eyeModuleOneDetails: {
                  eyeCareCashlessProviders: selectedVisionProviders.filter(
                    (id) =>
                      fetchedVisionProviders
                        .filter((p) => p.moduleType === 1)
                        .some((p) => p.id === id),
                  ),
                },
                eyeModuleTwoDetails: null,
              }
            : {
                eyeModuleOneDetails: null,
                eyeModuleTwoDetails: {
                  benefitsDescription: visionModuleTwoBenefitsCovered,
                  eyeCareCashlessProviders: selectedVisionProviders.filter(
                    (id) =>
                      fetchedVisionProviders
                        .filter((p) => p.moduleType === 2)
                        .some((p) => p.id === id),
                  ),
                  serviceCategory: "Avail eye care",
                  eligibleCategories: selectedEligibleBenefits.map((s) => {
                    const benefit = fetchedVisionBenefits.find(
                      (b) => b.id === s.value,
                    );
                    return benefit ? benefit.code : s.value;
                  }),
                  inEligibleCategories: selectedIneligibleBenefits.map((s) => {
                    const benefit = fetchedVisionBenefits.find(
                      (b) => b.id === s.value,
                    );
                    return benefit ? benefit.code : s.value;
                  }),
                },
              }
          : {},
        planChatDetails: {
          isCustomMessage: isWelcomeMsgIncluded,
          customMessage: customMessage,
          isCTAButton: isCTAButtonEnabled,
          ctaButton: ctaButton,
          ctaText:
            ctaButton === "CUSTOM_CTA"
              ? customCtaText
              : getLabelFromValue(ctaButton),
          ctaLink: ctaLink,
        },
        createdBy: authenticationService.getUserProfile().employeeProfile?.id,
        updatedBy: authenticationService.getUserProfile().employeeProfile?.id,
      };

      if (props?.data?.mode == "copy") {
        // Copy mode: open the "do you want to copy services?" prompt instead of
        // calling createPlan/updatePlan. The actual POST happens on Yes/No
        // selection.
        setCopyPayloadDraft(planObj);
        setIsCopyServicesPromptOpen(true);
      } else if (mode == 3) {
        if (props?.data?.mode == "renew") {
          let renewObj = planObj;
          renewObj.id = fetchedPlan.id;
          renewObj.masterPlanId = fetchedPlan.masterPlanId;
          delete renewObj.accountId;
          setPlanToUpdate(renewObj);
          setOpenRenewDialog(true);
        } else {
          delete planObj.createdBy;
          // ZY-10107: plan end date.
          // Regardless of any other changes, confirm before saving when the
          // plan end date has been changed from its originally fetched value.
          if (isPlanEndDateChanged()) {
            setPlanToUpdate(planObj);
            setOpenEndDateChangeDialog(true);
          } else if (
            fetchedPlan?.basicDetails?.status === 1 &&
            planObj?.basicDetails?.status === 2
          ) {
            setPlanToUpdate(planObj);
            setOpenInactiveDialog(true);
          } else {
            updatePlan(planObj);
          }
        }
      } else {
        createPlan(planObj);
      }
    }
  };

  // Performs the plan update from within the end-date-change dialog itself so
  // the dialog can show an inline loader and, on failure, an inline error
  // message (instead of closing immediately / showing a toast).
  const updatePlanFromEndDateDialog = (body) => {
    setLoading(true);
    setEndDateUpdateError(null);
    const onResponse = () => {
      setLoading(false);
      setOpenEndDateChangeDialog(false);
      setPlanToUpdate(null);
      EventService.emit("showError", {
        message: `Plan updated`,
      });
      exitPage();
    };
    const onError = (err) => {
      // Keep the dialog open, drop the Yes/No buttons and surface the API
      // error message inline so the user can read it and then continue editing.
      setLoading(false);
      setEndDateUpdateError(
        err?.message || "Something went wrong. Please try again.",
      );
    };
    plansUtils.updatePlan(body, fetchedPlan?.id, onResponse, onError);
  };

  // Called from the end-date-change confirmation dialog. Both Yes and No
  // proceed to update the plan; only the propagateNewEndDate flag differs.
  // Preserves the active -> inactive confirmation if that change is also made.
  const proceedAfterEndDateConfirm = (propagateNewEndDate) => {
    if (planToUpdate == null) return;
    const body = { ...planToUpdate, propagateNewEndDate };
    const willBecomeInactive =
      fetchedPlan?.basicDetails?.status === 1 &&
      planToUpdate?.basicDetails?.status === 2;
    if (willBecomeInactive) {
      // Status is also moving to inactive: hand off to the inactive
      // confirmation, which owns the actual update for that case.
      setOpenEndDateChangeDialog(false);
      setPlanToUpdate(body);
      setOpenInactiveDialog(true);
    } else {
      updatePlanFromEndDateDialog(body);
    }
  };

  const openCopyServicesSelector = () => {
    // Default the services-source-plan picker to the plan currently being copied from.
    const initialSource =
      props?.data?.sourcePlan || fetchedPlan
        ? {
            id: props?.data?.sourcePlan?.id ?? fetchedPlan?.id,
            basicDetails: {
              name:
                props?.data?.sourcePlan?.basicDetails?.name ??
                fetchedPlan?.basicDetails?.name,
            },
            accountCode:
              props?.data?.sourcePlan?.accountCode ?? fetchedPlan?.accountCode,
          }
        : null;
    setCopyServicesMode("create-new");
    setCopyServicesSourcePlan(initialSource);
    setCopyServicesSearchInput(
      initialSource?.id ? String(initialSource.id) : "",
    );
    setCopyServicesSourceAccount(
      props?.data?.sourceAccountName
        ? { accountName: props.data.sourceAccountName }
        : null,
    );
    setSelectedCopyServiceIds([]);
    setIsAllCopyServicesSelected(false);
    setCopyServicesPageNum(1);
    setCopyServicesFilterObj({});
    setIsCopyServicesPromptOpen(false);
    setIsCopyServicesSelectorOpen(true);
    if (initialSource?.id) {
      fetchCopyServices(initialSource.id, {}, 1);
      fetchAllCopyServices(initialSource.id);
    }
  };

  // Opens the same service-selection popup, but for the assign-service flow:
  // empty Plan ID input, no pre-fetched source, and any subsequent copyPlan
  // call will use the current plan as newPlanId (no `plan` payload).
  const openImportServicesSelector = () => {
    if (!fetchedPlan?.id) {
      EventService.emit("showError", { message: "Unable to get plan id" });
      return;
    }
    setCopyServicesMode("import-into-existing");
    setCopyServicesSourcePlan(null);
    setCopyServicesSourceAccount(null);
    setCopyServicesSearchInput("");
    setCopyServicesArray([]);
    setAllCopyServicesArray([]);
    setCopyServicesTotalCount(0);
    setSelectedCopyServiceIds([]);
    setIsAllCopyServicesSelected(false);
    setCopyServicesPageNum(1);
    setCopyServicesFilterObj({});
    setIsCopyServicesPromptOpen(false);
    setIsCopyServicesSelectorOpen(true);
  };

  const fetchCopyServicesPlan = () => {
    const idNum = Number(copyServicesSearchInput);
    if (!copyServicesSearchInput || Number.isNaN(idNum) || idNum <= 0) {
      EventService.emit("showError", {
        message: "Enter a valid Plan ID",
      });
      return;
    }
    setCopyServicesLookupLoading(true);
    plansUtils.getPlanByFilter(
      { pageNum: 1, pageSize: 1, planIds: [idNum] },
      (res) => {
        const plan = res?.plans?.[0];
        if (!plan) {
          setCopyServicesLookupLoading(false);
          EventService.emit("showError", {
            message: `No plan found for ID ${idNum}`,
          });
          return;
        }
        setCopyServicesSourcePlan(plan);
        setSelectedCopyServiceIds([]);
        setIsAllCopyServicesSelected(false);
        setCopyServicesPageNum(1);
        setCopyServicesFilterObj({});
        fetchCopyServices(plan.id, {}, 1);
        fetchAllCopyServices(plan.id);
        if (plan.accountCode) {
          plansUtils.getAccountByCode(
            plan.accountCode,
            (acc) => {
              setCopyServicesSourceAccount(acc);
              setCopyServicesLookupLoading(false);
            },
            (err) => {
              setCopyServicesLookupLoading(false);
              EventService.emit("showError", {
                message: `Error in fetching account: ${err?.message}`,
              });
            },
          );
        } else {
          setCopyServicesLookupLoading(false);
        }
      },
      (err) => {
        setCopyServicesLookupLoading(false);
        EventService.emit("showError", {
          message: `Error in fetching plan: ${err?.message}`,
        });
      },
    );
  };

  const fetchCopyServices = (planId, filters, page) => {
    plansUtils.getAssignedServicesToPlanByFilter(
      {
        pageNum: page ?? copyServicesPageNum,
        pageSize: copyServicesPageSize,
        planIds: [planId],
        ...(filters ?? copyServicesFilterObj ?? {}),
        includeGroupRuleDetails: true,
      },
      (res) => {
        setCopyServicesArray(res?.services ?? []);
        setCopyServicesTotalCount(res?.totalCount ?? 0);
      },
      (err) => {
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      },
    );
  };

  const fetchAllCopyServices = (planId) => {
    plansUtils.getAssignedServicesToPlanByFilter(
      { pageNum: 0, pageSize: 0, planIds: [planId] },
      (res) => {
        setAllCopyServicesArray(res?.services ?? []);
      },
      (err) => {
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      },
    );
  };

  const hasActiveCopyFilters = (f) => {
    if (!f) return false;
    return (
      (Array.isArray(f.ids) && f.ids.length > 0) ||
      (Array.isArray(f.serviceTypeIds) && f.serviceTypeIds.length > 0) ||
      (Array.isArray(f.nameMatch) && f.nameMatch.length > 0) ||
      (Array.isArray(f.modeNames) && f.modeNames.length > 0) ||
      Boolean(f.status)
    );
  };

  const fetchAllFilteredCopyServiceIds = (onDone) => {
    const planId = copyServicesSourcePlan?.id;
    if (!planId) {
      EventService.emit("showError", {
        message: "Source plan not found",
      });
      return;
    }
    setLoading(true);
    plansUtils.getAssignedServicesToPlanByFilter(
      {
        pageNum: 0,
        pageSize: 0,
        planIds: [planId],
        ...(copyServicesFilterObj ?? {}),
        includeGroupRuleDetails: true,
      },
      (res) => {
        setLoading(false);
        const ids = (res?.services ?? [])
          .map((s) => s?.id)
          .filter((id) => id != null);
        onDone(ids);
      },
      (err) => {
        setLoading(false);
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      },
    );
  };

  useEffect(() => {
    if (isCopyServicesSelectorOpen && copyServicesSourcePlan?.id) {
      fetchCopyServices(
        copyServicesSourcePlan.id,
        copyServicesFilterObj,
        copyServicesPageNum,
      );
    }
  }, [copyServicesPageNum, copyServicesFilterObj]);

  const toggleCopyService = (id) => {
    if (id == null) return;
    setIsAllCopyServicesSelected(false);
    setSelectedCopyServiceIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };

  const toggleAllCopyServices = (checked) => {
    setIsAllCopyServicesSelected(Boolean(checked));
    if (checked) {
      setSelectedCopyServiceIds([]);
    } else {
      setSelectedCopyServiceIds([]);
    }
  };

  const copyServicesGoToPrevPage = () => {
    if (copyServicesPageNum > 1) {
      setCopyServicesPageNum((p) => p - 1);
    }
  };
  const copyServicesGoToNextPage = () => {
    if (copyServicesPageNum * copyServicesPageSize < copyServicesTotalCount) {
      setCopyServicesPageNum((p) => p + 1);
    }
  };

  const exitCopyFlowToAssignedPlans = () => {
    const wasImport = copyServicesMode === "import-into-existing";
    setIsCopyServicesPromptOpen(false);
    setIsCopyServicesSelectorOpen(false);
    setIsCopySuccessOpen(false);
    setCopyPayloadDraft(null);
    setCopyServicesMode("create-new");
    if (wasImport) {
      // Stay on the current assign-service view; just refresh the services list.
      if (fetchedPlan?.id) {
        getAssignedServicesToPlanByFilter(fetchedPlan.id);
        getAllAssignedServicesToPlan(fetchedPlan.id);
      }
      return;
    }
    props.setView(2, { accountId: props?.data?.accountId });
  };

  const copyPlan = (copyAllServices, serviceIds) => {
    let body;
    if (copyServicesMode === "import-into-existing") {
      const sourcePlanId = copyServicesSourcePlan?.id;
      const newPlanId = fetchedPlan?.id;
      if (!sourcePlanId || !newPlanId) {
        EventService.emit("showError", {
          message: "Source plan or destination plan missing.",
        });
        return;
      }
      body = {
        sourcePlanId,
        newPlanId,
        copyAllServices: Boolean(copyAllServices),
        serviceIds: copyAllServices ? [] : (serviceIds ?? []),
      };
    } else {
      const planForBody = copyPayloadDraft;
      if (!planForBody) {
        EventService.emit("showError", {
          message: "Plan data not assembled. Try again.",
        });
        return;
      }
      const sourcePlanId =
        props?.data?.sourcePlan?.id ?? props?.data?.planId ?? fetchedPlan?.id;
      body = {
        sourcePlanId,
        newPlanId: 0,
        copyAllServices: Boolean(copyAllServices),
        serviceIds: copyAllServices ? [] : (serviceIds ?? []),
        plan: planForBody,
      };
    }
    setLoading(true);
    plansUtils.copyPlan(
      body,
      () => {
        setLoading(false);
        setIsCopyServicesPromptOpen(false);
        setIsCopyServicesSelectorOpen(false);
        setIsCopySuccessOpen(true);
      },
      (err) => {
        setLoading(false);
        // On failure, close whichever copy-services popup is open and return
        // the user to the Copy Plan screen.
        setIsCopyServicesPromptOpen(false);
        setIsCopyServicesSelectorOpen(false);
        EventService.emit("showError", {
          message: `Error copying plan: ${err?.message}`,
        });
      },
    );
  };
  const isMessageEffectivelyEmpty = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent || tempDiv.innerText || "";
    return text.trim() === "";
  };

  const isDataValid = () => {
    if (planName == "") {
      EventService.emit("showError", {
        message: "Please enter the plan name",
      });
      return false;
    } else if (planStatus != 1 && planStatus != 2) {
      EventService.emit("showError", {
        message: "Please select plan status",
      });
      return false;
    } else if (planDateFrom == null) {
      EventService.emit("showError", {
        message: "Please fill plan start date",
      });
      return false;
    } else if (planDateTo == null) {
      EventService.emit("showError", {
        message: "Please fill plan end date",
      });
      return false;
    } else if (isPlanEndDateChanged() && !isPlanEndDateAllowed(planDateTo)) {
      // ZY-10084: a plan end date only ever moves forward. Guarded only when the date is
      // actually being changed, so editing other fields on a plan that has already ended is
      // still possible.
      EventService.emit("showError", {
        message: `Plan end date can only be moved forward. It cannot be set earlier than ${getPlanEndDateFloor().format(
          "DD MMM YYYY",
        )}.`,
      });
      return false;
    } else if (planMobilePreview == null || planMobilePreview == "") {
      EventService.emit("showError", {
        message: "Please upload plan image mobile view",
      });
      return false;
    } else if (planShortDescription == "") {
      EventService.emit("showError", {
        message: "Please enter plan short description",
      });
      return false;
    } else if (isMessageEffectivelyEmpty(planLongDescription)) {
      EventService.emit("showError", {
        message: "Please enter plan long description",
      });
      return false;
    } else if (isReimbursementIncluded && !isClaimRuleEnabled) {
      EventService.emit("showError", {
        message: "To add claim included, you must add advanced claim rules",
      });
      return false;
    } else if (
      isWalletIncluded == true &&
      isUnlimitedWallet == false &&
      canEditWalletLimit
    ) {
      EventService.emit("showError", {
        message:
          "Wallet limit is in edit mode, please check to confirm the amount",
      });
      return false;
    } else if (
      isWalletIncluded == true &&
      isUnlimitedWallet == false &&
      (walletLimit == "" || walletLimit == 0)
    ) {
      EventService.emit("showError", {
        message: "Please enter some wallet limit",
      });
      return false;
    } else if (
      validateWalletPayload({
        isCategoryRuleEnabled,
        categoryRuleData,
        isServiceRuleEnabled,
        serviceRuleData,
        isClaimRuleEnabled,
        claimRuleData,
        isWalletFaqsIncluded,
        walletFaqs,
        isUnlimitedWallet,
        walletLimit,
      }) === false
    ) {
      return false;
    } else if (
      isAdditionalClaimRuleEnabled &&
      !checkBoxInvoiceDateRule &&
      !checkBoxAddClaimRuleDeclaration &&
      !checkBoxDocumentType
    ) {
      EventService.emit("showError", {
        message: "Please fill at least one additional claim rule",
      });
      return false;
    } else if (checkBoxInvoiceDateRule == true && claimFilingDuration == "") {
      EventService.emit("showError", {
        message: "Please enter acceptable invoice date form current days",
      });
      return false;
    } else if (
      checkBoxAddClaimRuleDeclaration == true &&
      isMessageEffectivelyEmpty(declaration)
    ) {
      EventService.emit("showError", {
        message: "Please enter declaration text",
      });
      return false;
    } else if (
      checkBoxDocumentType == true &&
      documentTypeData.filter((e) => e.typeId != 0).length === 0
    ) {
      EventService.emit("showError", {
        message: "Please enter document type label",
      });
      return false;
    } else if (
      checkBoxDocumentType == true &&
      documentTypeData.filter((e) => e.typeId != 0).length > 0 &&
      documentTypeData.filter((e) => e.text.trim() === "").length
    ) {
      EventService.emit("showError", {
        message: "Please enter document type text",
      });
      return false;
    } else if (
      isAdditionalPlanRuleEnabled &&
      checkBoxPrescriptionRequired === false &&
      prescribedMedicinesSelected.length === 0
    ) {
      EventService.emit("showError", {
        message: "Please fill additional plan rules for Prescribed medicines",
      });
      return false;
    } else if (
      isWelcomeMsgIncluded == true &&
      isMessageEffectivelyEmpty(customMessage)
    ) {
      EventService.emit("showError", {
        message: "Please enter welcome message on chat",
      });
      return false;
    } else if (
      isWelcomeMsgIncluded == true &&
      isCTAButtonEnabled == true &&
      ctaButton == ""
    ) {
      EventService.emit("showError", {
        message: "Please select a CTA button text",
      });
      return false;
    } else if (
      isWelcomeMsgIncluded == true &&
      isCTAButtonEnabled == true &&
      ctaButton == "CUSTOM_CTA" &&
      customCtaText.trim() == ""
    ) {
      EventService.emit("showError", {
        message: "Please enter custom CTA text",
      });
      return false;
    } else if (
      isWelcomeMsgIncluded == true &&
      isCTAButtonEnabled == true &&
      ctaButton == "CUSTOM_CTA" &&
      customCtaText.trim() != "" &&
      ctaLink.trim() == ""
    ) {
      EventService.emit("showError", {
        message: "Please enter custom CTA link",
      });
      return false;
    } else {
      return true;
    }
  };

  let createPlan = (body) => {
    setLoading(true);
    const onResponse = (res) => {
      setLoading(false);
      EventService.emit("showError", {
        message: `Plan created`,
      });
      exitPage();
    };
    const onError = (err) => {
      setLoading(false);
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    plansUtils.createPlan(body, onResponse, onError);
  };
  let updatePlan = (body) => {
    setLoading(true);
    const onResponse = (res) => {
      setLoading(false);
      EventService.emit("showError", {
        message: `Plan updated`,
      });
      exitPage();
    };
    const onError = (err) => {
      setLoading(false);
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    plansUtils.updatePlan(body, fetchedPlan?.id, onResponse, onError);
  };
  let renewPlan = (body) => {
    setLoading(true);
    const onResponse = (res) => {
      setLoading(false);
      EventService.emit("showError", {
        message: `Plan renewed`,
      });
      exitPage();
    };
    const onError = (err) => {
      setPlanToUpdate(null);
      setOpenRenewDialog(false);
      setLoading(false);
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    plansUtils.renewPlan(body, onResponse, onError);
  };

  const isWalletLimitNotFilled = () => {
    if (isUnlimitedWallet == false && canEditWalletLimit) {
      EventService.emit("showError", {
        message:
          "Wallet limit is in edit mode, please check to confirm the amount",
      });
      return true;
    } else if (
      isUnlimitedWallet == false &&
      (walletLimit === "" || walletLimit === 0)
    ) {
      EventService.emit("showError", {
        message: "Please set the wallet limit first",
      });
      return true;
    } else {
      return false;
    }
  };

  //Wallet----------------
  function normalizeValueFields(dataArray, direction) {
    return dataArray.map((item) => {
      const updatedItem = { ...item };

      const transformValue = (val, type) => {
        if (type === "stringToNumber") {
          if (val === "" || val === null || isNaN(Number(val))) return 0;
          return Math.max(0, parseFloat(val));
        } else if (type === "numberToString") {
          if (val > 0) return val.toString();
          return val;
        }
        return val;
      };

      const limitFields = ["sublimit", "perTransactionlimit", "coPaylimit"];

      limitFields.forEach((field) => {
        if (updatedItem[field] && typeof updatedItem[field] === "object") {
          updatedItem[field] = {
            ...updatedItem[field],
            value: transformValue(updatedItem[field].value, direction),
          };
        }
      });

      return updatedItem;
    });
  }

  function canUpdateField(allow, value) {
    // allow true will allow update in case of mode 3
    // allow false will check value, if value is empty then it will allow update
    if (mode === 1) return true;
    if (mode === 2) return false;

    if (mode === 3) {
      if (allow === true) return true;
      if (allow === false) {
        return (
          value === undefined || value === null || value === "" || value === 0
        );
      }
      return false;
    }

    return false;
  }

  const handleInfoClick = async (num) => {
    const result = await confirm({
      title: getInfoTitle(num),
      width: "900px",
      box: getInfoText(num),
      buttons: {
        1: "close", // fixed : 1 is reserved for x close button
      },
    });
  };
  const deSelectWalletIncluded = async () => {
    const result = await confirm({
      title: "Deactivate Wallet",
      message:
        "Are you sure you want to deselect the wallet? This will remove all information regarding 'Wallet included', 'Claim included', 'Wallet and claim FAQs', 'Advanced wallet rules', 'Advanced health checkup service level rules', 'Advanced claim rules' and 'Additional claim rules' sections.",
      width: "800px",
      buttons: {
        1: "close", // fixed : 1 is reserved for x close button
        2: { label: "Cancel", color: "zyGreen" },
        3: { label: "Confirm", color: "zyOrange" },

        // 4: { label: "Continue Anyway", color: "zyGreen" },
      },
    });

    if (result === "1" || result === "2") {
      return;
    } else if (result === "3") {
      setIsWalletIncluded(false);
    }
  };
  const deSelectReimbursementIncluded = async () => {
    const result = await confirm({
      title: "Deactivate claim",
      message:
        "Are you sure you want to deselect the claim ? This will remove all information regarding 'Claim included', 'Advanced claims rules', 'Additional claim rules' section.",
      width: "800px",
      buttons: {
        1: "close", // fixed : 1 is reserved for x close button
        2: { label: "Cancel", color: "zyGreen" },
        3: { label: "Confirm", color: "zyOrange" },

        // 4: { label: "Continue Anyway", color: "zyGreen" },
      },
    });

    if (result === "1" || result === "2") {
      return;
    } else if (result === "3") {
      setIsReimbursementIncluded(false);
    }
  };
  const deSelectFAQsIncluded = async () => {
    const result = await confirm({
      title: "Remove FAQs",
      message: "Are you sure you want to remove all Wallet and claim FAQs ?",
      width: "800px",
      buttons: {
        1: "close", // fixed : 1 is reserved for x close button
        2: { label: "Cancel", color: "zyGreen" },
        3: { label: "Confirm", color: "zyOrange" },

        // 4: { label: "Continue Anyway", color: "zyGreen" },
      },
    });

    if (result === "1" || result === "2") {
      return;
    } else if (result === "3") {
      setIsWalletFaqsIncluded(false);
    }
  };
  const deSelectCategoryRuleIncluded = async () => {
    const result = await confirm({
      title: "Deactivate Advanced wallet rules",
      message: "Are you sure you want to uncheck additional wallet rules",
      width: "800px",
      buttons: {
        1: "close", // fixed : 1 is reserved for x close button
        2: { label: "Cancel", color: "zyGreen" },
        3: { label: "Confirm", color: "zyOrange" },

        // 4: { label: "Continue Anyway", color: "zyGreen" },
      },
    });

    if (result === "1" || result === "2") {
      return;
    } else if (result === "3") {
      setIsCategoryRuleEnabled(false);
    }
  };
  const deSelectServiceRuleIncluded = async () => {
    const result = await confirm({
      title: "Deactivate Advanced health checkup service level rules",
      message:
        "Are you sure you want to uncheck advanced health checkup service level rules",
      width: "800px",
      buttons: {
        1: "close", // fixed : 1 is reserved for x close button
        2: { label: "Cancel", color: "zyGreen" },
        3: { label: "Confirm", color: "zyOrange" },

        // 4: { label: "Continue Anyway", color: "zyGreen" },
      },
    });

    if (result === "1" || result === "2") {
      return;
    } else if (result === "3") {
      setIsServiceRuleEnabled(false);
    }
  };
  const deSelectClaimRuleIncluded = async () => {
    const result = await confirm({
      title: "Deactivate Advanced claims rules",
      message: "Are you sure you want to uncheck advanced claims rules",
      width: "800px",
      buttons: {
        1: "close", // fixed : 1 is reserved for x close button
        2: { label: "Cancel", color: "zyGreen" },
        3: { label: "Confirm", color: "zyOrange" },

        // 4: { label: "Continue Anyway", color: "zyGreen" },
      },
    });

    if (result === "1" || result === "2") {
      return;
    } else if (result === "3") {
      setIsClaimRuleEnabled(false);
    }
  };

  const reduceWalletLimitConfirm = async () => {
    const result = await confirm({
      title: "Are you sure you want to reduce wallet limit",
      message:
        "*Please be careful if once confirmed, all entries you made will be deleted. You have to add all entries again",
      width: "850px",
      buttons: {
        1: "close", // fixed : 1 is reserved for x close button
        2: { label: "Cancel", color: "zyGreen" },
        3: { label: "Confirm", color: "zyOrange" },

        // 4: { label: "Continue Anyway", color: "zyGreen" },
      },
    });

    if (result === "1" || result === "2") {
      return;
    } else if (result === "3") {
      setWalletLimit(walletLimitInEditState);
      setCanEditWalletLimit(false);

      setIsCategoryRuleEnabled(false);
      setIsServiceRuleEnabled(false);
      setIsClaimRuleEnabled(false);
    }
  };
  const increaseWalletLimitConfirm = async () => {
    const result = await confirm({
      title: "Are you sure you want to increase wallet limit",
      message:
        "*Please be careful if once confirmed, all entries you made will remain unchanged. You can make changes to entries if necessary",
      width: "850px",
      buttons: {
        1: "close", // fixed : 1 is reserved for x close button

        2: { label: "Cancel", color: "zyGreen" },
        3: { label: "Confirm", color: "zyOrange" },
        // 4: { label: "Continue Anyway", color: "zyGreen" },
      },
    });

    if (result === "1" || result === "2") {
      return;
    } else if (result === "3") {
      setWalletLimit(walletLimitInEditState);
      setCanEditWalletLimit(false);
    }
  };
  const changeWalletToLimitedConfirm = async () => {
    const result = await confirm({
      title: "Are you sure you want to change the wallet type to 'Limited'?",
      message:
        "*Please be careful if once confirmed, all entries you made will be deleted. You have to add all entries again",
      width: "850px",
      buttons: {
        1: "close", // fixed : 1 is reserved for x close button
        2: { label: "Cancel", color: "zyGreen" },
        3: { label: "Confirm", color: "zyOrange" },

        // 4: { label: "Continue Anyway", color: "zyGreen" },
      },
    });

    if (result === "1" || result === "2") {
      return;
    } else if (result === "3") {
      setIsCategoryRuleEnabled(false);
      setIsServiceRuleEnabled(false);
      setIsClaimRuleEnabled(false);

      setWalletLimitInEditState("");
      setWalletLimit("");
      setCanEditWalletLimit(false);
      setIsUnlimitedWallet(false);
    }
  };
  const changeWalletToUnLimitedConfirm = async () => {
    const result = await confirm({
      title: "Are you sure you want to change the wallet type to 'Unlimited'?",
      message:
        "*Please be careful if once confirmed, all entries you made will remain unchanged. You can make changes to entries if necessary",
      width: "850px",
      buttons: {
        1: "close", // fixed : 1 is reserved for x close button
        2: { label: "Cancel", color: "zyGreen" },
        3: { label: "Confirm", color: "zyOrange" },

        // 4: { label: "Continue Anyway", color: "zyGreen" },
      },
    });

    if (result === "1" || result === "2") {
      return;
    } else if (result === "3") {
      updateAllRuleDataWithFixedAmountFalse();
      // remaing convertion handled in the useEffect
    }
  };

  const deSelectAdditionalClaimRules = async () => {
    const result = await confirm({
      title: "Deactivate additional claim rules",
      message:
        "Are you sure you want to deselect additional claim rules? This will remove all information regarding 'Invoice date rule', 'Declaration' and 'Document type' rules",
      width: "800px",
      buttons: {
        1: "close", // fixed : 1 is reserved for x close button
        2: { label: "Cancel", color: "zyGreen" },
        3: { label: "Confirm", color: "zyOrange" },

        // 4: { label: "Continue Anyway", color: "zyGreen" },
      },
    });

    if (result === "1" || result === "2") {
      return;
    } else if (result === "3") {
      setIsAdditionalClaimRuleEnabled(false);
    }
  };

  const deSelectAdditionalPlanRules = async () => {
    const result = await confirm({
      title: "Deactivate additional plan rules",
      message: "Are you sure you want to deselect additional plan rules?",
      width: "800px",
      buttons: {
        1: "close", // fixed : 1 is reserved for x close button
        2: { label: "Cancel", color: "zyGreen" },
        3: { label: "Confirm", color: "zyOrange" },

        // 4: { label: "Continue Anyway", color: "zyGreen" },
      },
    });

    if (result === "1" || result === "2") {
      return;
    } else if (result === "3") {
      setIsAdditionalPlanRuleEnabled(false);
    }
  };

  //FAQ---
  function stripHtmlTags(htmlString) {
    if (!htmlString) return "";

    const div = document.createElement("div");
    div.innerHTML = htmlString;

    return div.textContent || div.innerText || "";
  }

  const {
    confirm2,
    dialogState,
    questionEditorState,
    setQuestionEditorState,
    answerEditorState,
    setAnswerEditorState,
    handleClose,
  } = useFAQDialog();

  const handleOpenFAQ = async () => {
    const result = await confirm2({
      title: "FAQ",
      message: "Edit the fields below:",
      questionText: "<p>What is your return policy?</p>",
      answerText: "<p>You may return items within 30 days.</p>",
      width: "700px",
      buttons: {
        1: "close",
        2: { label: "Save", color: "zyOrange" },
        3: { label: "Cancel", color: "zyGrey" },
      },
    });
  };

  const getServiceTypesForWallet = (plan) => {
    const onResponse = (res) => {
      if (res != null && res.length > 0) {
        setServiceCategories(res);
        let allServiceCategoriesOptions = res.map((e) => {
          return {
            label: e.name,
            value: e.id,
          };
        });
        setServiceCategoriesOptions([
          ...serviceCategoriesOptions,
          ...allServiceCategoriesOptions.filter((e) => e.value === 3),
        ]);
        // setServiceCategoriesOptions([
        //   ...serviceCategoriesOptions,
        //   ...allServiceCategoriesOptions,
        // ]);

        if (props?.data?.mode == "create") {
          createEmptyCategoryRule(res);
        } else {
          setData(plan, res);
        }
      }
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
      // const resolve = serviceTypesResolverRef.current;
      // if (resolve) {
      //   resolve([]);
      //   serviceTypesResolverRef.current = null;
      // }
    };

    plansUtils.getServiceTypesForWallet(onResponse, onError);
  };

  // const getServiceTypesForWalletAsync = () => {
  //   return new Promise((resolve) => {
  //     if (serviceCategories.length > 0) {
  //       resolve(serviceCategories);
  //     } else {
  //       serviceTypesResolverRef.current = resolve;
  //     }
  //   });
  // };

  const changeAllToAmountIfNeeded = () => {
    if (valueTypeCategoryRuleSublimit === 1) changeToAmount(1);
    // if (valueTypeCategoryRulePerTran === 1) changeToAmount(2);
    // if (valueTypeCategoryRuleCoPay === 1) changeToAmount(3);
    if (valueTypeServiceRuleSublimit === 1) changeToAmount(4);
    if (valueTypeClaimRuleSublimit === 1) changeToAmount(5);
    // if (valueTypeClaimRulePerTran === 1) changeToAmount(6);
    // if (valueTypeClaimRuleCoPay === 1) changeToAmount(7);
  };

  const createEmptyCategoryRule = (serviceTypes) => {
    setValueTypeCategoryRuleSublimit(2);
    setValueTypeCategoryRulePerTran(2);
    setValueTypeCategoryRuleCoPay(2);
    setValueTypeServiceRuleSublimit(2);
    setValueTypeClaimRuleSublimit(2);
    setValueTypeClaimRulePerTran(2);
    setValueTypeClaimRuleCoPay(2);
    let serviceTypesData = serviceTypes.map((e) => {
      return {
        serviceCategoryId: e.id,
        isFixedAmount: false,
        sublimit: {
          enabled: false,
          value: 0,
          unit: 2,
        },
        perTransactionlimit: {
          enabled: false,
          value: 0,
          unit: 2,
        },
        coPaylimit: {
          enabled: false,
          value: 0,
          unit: 2,
        },
      };
    });
    setCategoryRuleData(serviceTypesData);
  };

  const createEmptyWalletFaq = () => ({
    question: "",
    answer: "",
  });
  const createEmptyServiceRule = () => ({
    serviceIds: [],
    isFixedAmount: false,
    serviceCardName: "",
    sublimit: {
      enabled: false,
      value: 0,
      unit: valueTypeServiceRuleSublimit,
    },
  });

  const createEmptyClaimRule = () => ({
    claimType: "",
    instructions: "",
    serviceCategoryId: 0,
    isFixedAmount: false,
    inclusions: [],
    exclusions: [],
    sublimit: {
      enabled: false,
      value: 0,
      unit: valueTypeClaimRuleSublimit,
    },
    perTransactionlimit: {
      enabled: false,
      value: 0,
      unit: valueTypeClaimRulePerTran,
    },
    coPaylimit: {
      enabled: false,
      value: 0,
      unit: valueTypeClaimRuleCoPay,
    },
  });
  const addEmptyWalletFaq = () => {
    setWalletFaqs((prev) => [...prev, createEmptyWalletFaq()]);
  };
  const addEmptyServiceRule = () => {
    setServiceRuleData((prev) => [...prev, createEmptyServiceRule()]);
  };

  const addEmptyClaimRule = () => {
    setClaimRuleData((prev) => [...prev, createEmptyClaimRule()]);
  };
  const deleteWalletFaq = (indexToDelete) => {
    setWalletFaqs((prev) => prev.filter((_, index) => index !== indexToDelete));
  };
  const deleteServiceRule = (indexToDelete) => {
    setServiceRuleData((prev) =>
      prev.filter((_, index) => index !== indexToDelete),
    );
  };

  const deleteClaimRule = (indexToDelete) => {
    setClaimRuleData((prev) =>
      prev.filter((_, index) => index !== indexToDelete),
    );
  };

  const updateWalletFaq = (index, ques, ans) => {
    setWalletFaqs((prev) => {
      if (index < 0 || index >= prev.length) return prev;
      const row = prev[index];
      let updatedRow;

      updatedRow = {
        question: ques,
        answer: ans,
      };
      if (!updatedRow) return prev;

      const updatedList = [...prev];
      updatedList[index] = updatedRow;
      return updatedList;
    });
  };

  const updateCategoryRule = (
    serviceCategoryId,
    valueForColumn,
    checkboxOrValue,
    value,
    unit,
  ) => {
    setCategoryRuleData((prev) => {
      const index = prev.findIndex(
        (e) => e.serviceCategoryId === serviceCategoryId,
      );
      if (index === -1) return prev;

      const row = prev[index];
      let updatedRow;

      const getUpdatedLimit = (limit, isEnableChange) => ({
        enabled: isEnableChange ? value : limit.enabled,
        value: isEnableChange ? 0 : checkboxOrValue === 2 ? value : limit.value,
        unit: checkboxOrValue === 2 ? (unit ?? limit.unit) : limit.unit,
      });

      if (valueForColumn === 1) {
        updatedRow = {
          ...row,
          sublimit: getUpdatedLimit(row.sublimit, checkboxOrValue === 1),
          isFixedAmount: checkboxOrValue === 1 ? false : row.isFixedAmount,
        };
        if (checkboxOrValue === 1) {
          setClaimRuleData((prev) =>
            prev.map((item) =>
              item.serviceCategoryId === serviceCategoryId
                ? { ...item, serviceCategoryId: 0 }
                : item,
            ),
          );
        }
      }

      if (valueForColumn === 2) {
        updatedRow = {
          ...row,
          perTransactionlimit: getUpdatedLimit(
            row.perTransactionlimit,
            checkboxOrValue === 1,
          ),
        };
      }

      if (valueForColumn === 3) {
        updatedRow = {
          ...row,
          coPaylimit: getUpdatedLimit(row.coPaylimit, checkboxOrValue === 1),
        };
      }

      if (valueForColumn === 4) {
        updatedRow = {
          ...row,
          isFixedAmount: value,
        };
      }

      if (!updatedRow) return prev;

      const updatedList = [...prev];
      updatedList[index] = updatedRow;

      // Sync with Reimbursement Rules
      if (isClaimRuleEnabled) {
        setClaimRuleData((prevRules) =>
          prevRules.map((r) => {
            if (r.serviceCategoryId !== serviceCategoryId) return r;
            const newRule = { ...r };
            // Only prepare converter if walletLimit is valid
            const walletLimitDecimal = walletLimit && new Decimal(walletLimit);
            const convertValue = (val, fromUnit, toUnit) => {
              if (val === 0 || val === "" || val == null) return val;
              if (fromUnit === toUnit) return val;
              // If walletLimit is falsy, skip conversion
              if (!walletLimitDecimal) return val;
              return toUnit === PERCENT_TYPE
                ? convertAmountToPercent(val, walletLimitDecimal)
                : convertPercentToAmount(val, walletLimitDecimal);
            };
            if (updatedRow.sublimit) {
              const targetUnit = valueTypeClaimRuleSublimit;
              const convertedValue = convertValue(
                updatedRow.sublimit.value,
                updatedRow.sublimit.unit,
                targetUnit,
              );
              newRule.sublimit = {
                ...updatedRow.sublimit,
                value: convertedValue,
                unit: targetUnit,
              };
            }

            // if (updatedRow.perTransactionlimit) {
            //   const targetUnit = valueTypeClaimRulePerTran;
            //   const convertedValue = convertValue(
            //     updatedRow.perTransactionlimit.value,
            //     updatedRow.perTransactionlimit.unit,
            //     targetUnit
            //   );

            //   newRule.perTransactionlimit = {
            //     ...updatedRow.perTransactionlimit,
            //     value: convertedValue,
            //     unit: targetUnit,
            //   };
            // }

            // if (updatedRow.coPaylimit) {
            //   const targetUnit = valueTypeClaimRuleCoPay;
            //   const convertedValue = convertValue(
            //     updatedRow.coPaylimit.value,
            //     updatedRow.coPaylimit.unit,
            //     targetUnit
            //   );

            //   newRule.coPaylimit = {
            //     ...updatedRow.coPaylimit,
            //     value: convertedValue,
            //     unit: targetUnit,
            //   };
            // }

            newRule.isFixedAmount = updatedRow.isFixedAmount;

            return newRule;
          }),
        );
      }

      return updatedList;
    });
  };

  const updateServiceRule = (
    index,
    valueForColumn,
    checkboxOrValue,
    value,
    unit,
  ) => {
    setServiceRuleData((prev) => {
      if (index < 0 || index >= prev.length) return prev;

      const row = prev[index];
      let updatedRow;

      if (valueForColumn === 1) {
        updatedRow = {
          ...row,
          sublimit: {
            enabled: checkboxOrValue === 1 ? value : row.sublimit.enabled,
            value:
              checkboxOrValue === 2
                ? value
                : checkboxOrValue === 1
                  ? 0
                  : row.sublimit.value,
            unit:
              checkboxOrValue === 2
                ? (unit ?? row.sublimit.unit)
                : row.sublimit.unit,
          },
          isFixedAmount: checkboxOrValue === 1 ? false : row.isFixedAmount,
        };
      }

      if (valueForColumn === 4) {
        updatedRow = {
          ...row,
          isFixedAmount: value,
        };
      }

      if (valueForColumn === 5) {
        updatedRow = {
          ...row,
          serviceIds: value,
        };
      }

      if (valueForColumn === 6) {
        updatedRow = {
          ...row,
          serviceCardName: value,
        };
      }

      if (!updatedRow) return prev;

      const updatedList = [...prev];
      updatedList[index] = updatedRow;
      return updatedList;
    });
  };

  const updateClaimRule = (
    index,
    valueForColumn,
    checkboxOrValue,
    value,
    unit,
  ) => {
    setClaimRuleData((prev) => {
      if (index < 0 || index >= prev.length) return prev;

      const row = prev[index];
      let updatedRow;

      const getUpdatedLimit = (limit, isEnableChange) => ({
        enabled: isEnableChange ? value : limit.enabled,
        value: isEnableChange ? 0 : checkboxOrValue === 2 ? value : limit.value,
        unit: checkboxOrValue === 2 ? (unit ?? limit.unit) : limit.unit,
      });

      if (valueForColumn === 1) {
        updatedRow = {
          ...row,
          sublimit: getUpdatedLimit(row.sublimit, checkboxOrValue === 1),
          isFixedAmount: checkboxOrValue === 1 ? false : row.isFixedAmount,
        };
      }

      if (valueForColumn === 2) {
        updatedRow = {
          ...row,
          perTransactionlimit: getUpdatedLimit(
            row.perTransactionlimit,
            checkboxOrValue === 1,
          ),
        };
      }

      if (valueForColumn === 3) {
        updatedRow = {
          ...row,
          coPaylimit: getUpdatedLimit(row.coPaylimit, checkboxOrValue === 1),
        };
      }

      if (valueForColumn === 4) {
        updatedRow = {
          ...row,
          isFixedAmount: value,
        };
      }

      if (valueForColumn === 5) {
        const matchedRule = categoryRuleData.find(
          (e) => e.serviceCategoryId === value,
        );
        // When the service type actually changes, seed the row's exclusions with
        // that category's standard (locked) exclusions and clear inclusions —
        // the previous type's candidates no longer apply. Re-selecting the same
        // type leaves any curated inclusions/exclusions untouched.
        const categoryChanged = value !== row.serviceCategoryId;
        const selectedCat = serviceCategories.find((s) => s.id === value);

        const walletLimitDecimal = !isUnlimitedWallet
          ? new Decimal(walletLimit)
          : null;

        const convertUnit = (ruleValue, uiUnitType) => {
          if (!ruleValue || ruleValue.value == null) return ruleValue;

          if (ruleValue.unit === uiUnitType) {
            return {
              enabled: ruleValue.enabled,
              value: ruleValue.value,
              unit: uiUnitType,
            };
          } else {
            return {
              enabled: ruleValue.enabled,
              value: 0,
              unit: uiUnitType,
            };
          }

          // const { value: rawValue, unit } = ruleValue;
          // if (unit === uiUnitType) return ruleValue;

          // const convertedValue =
          //   uiUnitType === 1
          //     ? convertAmountToPercent(rawValue, walletLimitDecimal)
          //     : convertPercentToAmount(rawValue, walletLimitDecimal);

          // return {
          //   enabled: ruleValue.enabled,
          //   value: convertedValue,
          //   unit: uiUnitType,
          // };
        };

        updatedRow = {
          ...row,
          serviceCategoryId: value,
          exclusions: categoryChanged
            ? [...(selectedCat?.lockedExclusions || [])]
            : row.exclusions,
          inclusions: categoryChanged ? [] : row.inclusions,
          sublimit: matchedRule
            ? convertUnit(matchedRule.sublimit, valueTypeClaimRuleSublimit)
            : row.sublimit,
          perTransactionlimit: matchedRule
            ? convertUnit(
                matchedRule.perTransactionlimit,
                valueTypeClaimRulePerTran,
              )
            : row.perTransactionlimit,
          coPaylimit: matchedRule
            ? convertUnit(matchedRule.coPaylimit, valueTypeClaimRuleCoPay)
            : row.coPaylimit,
          isFixedAmount: matchedRule
            ? matchedRule.isFixedAmount
            : row.isFixedAmount,
        };
      }

      if (valueForColumn === 6) {
        updatedRow = {
          ...row,
          claimType: value,
        };
      }

      if (valueForColumn === 7) {
        updatedRow = {
          ...row,
          instructions: value,
        };
      }

      if (valueForColumn === 8) {
        updatedRow = {
          ...row,
          inclusions: value,
        };
      }

      if (valueForColumn === 9) {
        updatedRow = {
          ...row,
          exclusions: value,
        };
      }

      if (!updatedRow) return prev;

      const updatedList = [...prev];
      updatedList[index] = updatedRow;
      return updatedList;
    });
  };

  // ---- Inclusions / Exclusions category dialog ----
  const [categoryDialog, setCategoryDialog] = useState({
    open: false,
    index: -1,
    type: "inclusions", // "inclusions" | "exclusions"
  });

  const openCategoryDialog = (index, type) => {
    const rule = claimRuleData[index];
    if (!rule || !rule.serviceCategoryId) return;
    setCategoryDialog({ open: true, index, type });
  };

  const closeCategoryDialog = () => {
    setCategoryDialog((prev) => ({ ...prev, open: false }));
  };

  const categoryDialogRow =
    categoryDialog.index >= 0 ? claimRuleData[categoryDialog.index] : null;
  const categoryDialogServiceCategory = categoryDialogRow
    ? serviceCategories.find(
        (s) => s.id === categoryDialogRow.serviceCategoryId,
      )
    : null;
  const categoryDialogCandidates = categoryDialogServiceCategory
    ? (categoryDialog.type === "exclusions"
        ? categoryDialogServiceCategory.exclusionCandidates
        : categoryDialogServiceCategory.inclusionCandidates) || []
    : [];
  const categoryDialogSelected = categoryDialogRow
    ? (categoryDialog.type === "exclusions"
        ? categoryDialogRow.exclusions
        : categoryDialogRow.inclusions) || []
    : [];
  // Universal exclusions are locked (always-on, non-editable). They apply to the
  // exclusions dialog only — inclusions have no locked tier (standard inclusions
  // are always enforced by the workflow prose; inclusion checkboxes only ADD).
  const categoryDialogLocked =
    categoryDialog.type === "exclusions" && categoryDialogServiceCategory
      ? categoryDialogServiceCategory.lockedExclusions || []
      : [];

  const handleCategoryDialogSave = (labels) => {
    const columnCode = categoryDialog.type === "exclusions" ? 9 : 8;
    updateClaimRule(categoryDialog.index, columnCode, null, labels);
    closeCategoryDialog();
  };

  // "+ Add category" persists the new label to the GLOBAL service-category
  // catalog (its inclusion/exclusion candidate list) and updates local state so
  // the candidate appears immediately. Failure is non-blocking: the label stays
  // selected on the row as a custom value.
  const handleAddCandidateCategory = (rawLabel) => {
    const category = categoryDialogServiceCategory;
    const label = normalizeLabel(rawLabel);
    if (!category || !label) return;

    const field =
      categoryDialog.type === "exclusions"
        ? "exclusionCandidates"
        : "inclusionCandidates";
    const existing = category[field] || [];
    // Case-insensitive dedup so near-duplicates (case / whitespace variants)
    // don't accumulate in the global catalog (matches the backend normalizer).
    if (existing.some((c) => labelKey(c) === labelKey(label))) return;

    const updatedCandidates = [...existing, label];

    // Optimistic local update.
    setServiceCategories((prev) =>
      prev.map((s) =>
        s.id === category.id ? { ...s, [field]: updatedCandidates } : s,
      ),
    );

    const payload = {
      id: category.id,
      name: category.name,
      isActive: category.isActive,
      inclusionCandidates:
        field === "inclusionCandidates"
          ? updatedCandidates
          : category.inclusionCandidates || [],
      exclusionCandidates:
        field === "exclusionCandidates"
          ? updatedCandidates
          : category.exclusionCandidates || [],
    };

    plansUtils.updateServiceCategory(
      category.id,
      payload,
      () => {},
      (err) => {
        EventService.emit("showError", {
          message: `Error saving category: ${err?.message}`,
        });
      },
    );
  };

  const changeToPercent = (columnNo) => {
    const typeSetters = {
      1: setValueTypeCategoryRuleSublimit,
      2: setValueTypeCategoryRulePerTran,
      3: setValueTypeCategoryRuleCoPay,
      4: setValueTypeServiceRuleSublimit,
      5: setValueTypeClaimRuleSublimit,
      6: setValueTypeClaimRulePerTran,
      7: setValueTypeClaimRuleCoPay,
    };

    const fieldMap = {
      1: "sublimit",
      2: "perTransactionlimit",
      3: "coPaylimit",
      4: "sublimit",
      5: "sublimit",
      6: "perTransactionlimit",
      7: "coPaylimit",
    };

    const shouldConvert = (value) =>
      value !== 0 && value !== "" && value != null;
    const isClaim = columnNo >= 5;
    const isCategory = columnNo < 4;

    typeSetters[columnNo](PERCENT_TYPE);

    const forceZero = [2, 3, 6, 7].includes(columnNo);
    const needsConversion = [1, 4, 5].includes(columnNo);

    let walletLimitDecimal;
    if (!forceZero && !isUnlimitedWallet) {
      if (!walletLimit || walletLimit === "") {
        EventService.emit("showError", { message: "Wallet limit is empty" });
        return;
      }
      walletLimitDecimal = new Decimal(walletLimit);
      if (walletLimitDecimal.isNaN() || walletLimitDecimal.isZero()) {
        EventService.emit("showError", {
          message: "Wallet limit is invalid or zero",
        });
        return;
      }
    }

    const getValueToSet = (originalValue) => {
      if (forceZero || (needsConversion && isUnlimitedWallet)) return 0;
      return shouldConvert(originalValue)
        ? convertAmountToPercent(originalValue, walletLimitDecimal)
        : originalValue;
    };

    if ([1, 2, 3].includes(columnNo)) {
      setCategoryRuleData((prevData) =>
        prevData.map((row) => {
          const value = getValueToSet(row[fieldMap[columnNo]]?.value);
          updateCategoryRule(
            row.serviceCategoryId,
            columnNo,
            2,
            value,
            PERCENT_TYPE,
          );
          return row;
        }),
      );
    } else if (columnNo === 4) {
      serviceRuleData.forEach((row, index) => {
        const value = getValueToSet(row.sublimit?.value);
        updateServiceRule(index, 1, 2, value, PERCENT_TYPE);
      });
    } else if ([5, 6, 7].includes(columnNo)) {
      const colIndex = columnNo - 4;
      claimRuleData.forEach((row, index) => {
        const value = getValueToSet(row[fieldMap[columnNo]]?.value);
        updateClaimRule(index, colIndex, 2, value, PERCENT_TYPE);
      });
    }
  };

  const changeToAmount = (columnNo) => {
    const AMOUNT_TYPE = 2;

    const typeSetters = {
      1: setValueTypeCategoryRuleSublimit,
      2: setValueTypeCategoryRulePerTran,
      3: setValueTypeCategoryRuleCoPay,
      4: setValueTypeServiceRuleSublimit,
      5: setValueTypeClaimRuleSublimit,
      6: setValueTypeClaimRulePerTran,
      7: setValueTypeClaimRuleCoPay,
    };

    const fieldMap = {
      1: "sublimit",
      2: "perTransactionlimit",
      3: "coPaylimit",
      4: "sublimit",
      5: "sublimit",
      6: "perTransactionlimit",
      7: "coPaylimit",
    };

    const shouldConvert = (value) =>
      value !== 0 && value !== "" && value != null;
    const forceZero = [2, 3, 6, 7].includes(columnNo);
    const needsConversion = [1, 4, 5].includes(columnNo);

    let walletLimitDecimal;
    if (!forceZero && !isUnlimitedWallet) {
      if (!walletLimit || walletLimit === "") {
        EventService.emit("showError", { message: "Wallet limit is empty" });
        return;
      }
      walletLimitDecimal = new Decimal(walletLimit);
      if (walletLimitDecimal.isNaN() || walletLimitDecimal.isZero()) {
        EventService.emit("showError", {
          message: "Wallet limit is invalid or zero",
        });
        return;
      }
    }

    const getValueToSet = (originalValue) => {
      if (forceZero || (needsConversion && isUnlimitedWallet)) return 0;
      return shouldConvert(originalValue)
        ? convertPercentToAmount(originalValue, walletLimitDecimal)
        : originalValue;
    };

    // Category Rules: 1, 2, 3
    if ([1, 2, 3].includes(columnNo)) {
      typeSetters[columnNo](AMOUNT_TYPE);
      setCategoryRuleData((prevData) =>
        prevData.map((row) => {
          const field = fieldMap[columnNo];
          const value = getValueToSet(row[field]?.value);
          updateCategoryRule(
            row.serviceCategoryId,
            columnNo,
            2,
            value,
            AMOUNT_TYPE,
          );
          return row;
        }),
      );
    }

    // Service Rule: 4
    if (columnNo === 4) {
      typeSetters[columnNo](AMOUNT_TYPE);
      serviceRuleData.forEach((row, index) => {
        const value = getValueToSet(row.sublimit?.value);
        updateServiceRule(index, 1, 2, value, AMOUNT_TYPE);
      });
    }

    // Claim Rules: 5, 6, 7
    if ([5, 6, 7].includes(columnNo)) {
      const valueForColumn = columnNo - 4;
      typeSetters[columnNo](AMOUNT_TYPE);
      claimRuleData.forEach((row, index) => {
        const field = fieldMap[columnNo];
        const value = getValueToSet(row[field]?.value);
        updateClaimRule(index, valueForColumn, 2, value, AMOUNT_TYPE);
      });
    }
  };

  const canEdit = (columnNo, index) => {
    const serviceCategoryRules =
      fetchedPlan?.walletRules?.serviceCategoryRules ?? [];
    const serviceRules = fetchedPlan?.walletRules?.serviceRules ?? [];
    const claimRules = fetchedPlan?.walletRules?.claimRules ?? [];

    switch (columnNo) {
      case 1:
        return canUpdateField(
          true,
          serviceCategoryRules[index]?.sublimit?.value,
        );
      case 2:
        return canUpdateField(
          true,
          serviceCategoryRules[index]?.perTransactionlimit?.value,
        );
      case 3:
        return canUpdateField(
          true,
          serviceCategoryRules[index]?.coPaylimit?.value,
        );
      case 4:
        return canUpdateField(true, serviceRules[index]?.sublimit?.value);
      case 5:
        return canUpdateField(true, claimRules[index]?.sublimit?.value);
      case 6:
        return canUpdateField(
          true,
          claimRules[index]?.perTransactionlimit?.value,
        );
      case 7:
        return canUpdateField(true, claimRules[index]?.coPaylimit?.value);
      default:
        return true;
    }
  };

  function updateAllRuleDataWithFixedAmountFalse() {
    setCategoryRuleData(
      categoryRuleData.map((item) => ({
        ...item,
        isFixedAmount: false,
      })),
    );

    setServiceRuleData(
      serviceRuleData.map((item) => ({
        ...item,
        isFixedAmount: false,
      })),
    );

    setClaimRuleData(
      claimRuleData.map((item) => ({
        ...item,
        isFixedAmount: false,
      })),
    );
    setSettingFixedAmountFalse(true);
  }

  function areAllFixedAmountsFalse() {
    const allFalse = (arr) =>
      Array.isArray(arr) && arr.every((item) => item.isFixedAmount === false);

    return (
      allFalse(categoryRuleData) &&
      allFalse(serviceRuleData) &&
      allFalse(claimRuleData)
    );
  }

  const addNewDocumentTypeData = () => {
    setDocumentTypeData((prev) => [
      ...prev,
      {
        typeId: 0,
        text: "",
      },
    ]);
  };

  const resetDocumentTypeData = () => {
    setDocumentTypeData([
      {
        typeId: 0,
        text: "",
      },
    ]);
  };

  const handleServiceCategoryChange = (index, newValue) => {
    const updated = [...additionalPlanRulesObjArr];
    updated[index].serviceCatId = newValue;
    setAdditionalPlanRulesObjArr(updated);
  };

  const addNewServiceCategoryRow = () => {
    setAdditionalPlanRulesObjArr((prev) => [
      ...prev,
      { serviceCatId: 0, obj: {} },
    ]);
  };

  // filter out already selected categories for dropdown
  const getAvailableOptions = (index) => {
    const selectedIds = additionalPlanRulesObjArr
      .map((item, i) => (i === index ? null : item.serviceCatId))
      .filter(Boolean);

    return serviceCategoriesOptions.filter(
      (opt) => !selectedIds.includes(opt.value),
    );
  };

  function renderAdditionalPlanRulesForSerCatId(id, index) {
    let serviceCatSelector = (
      <Row className="align-items-center">
        <Col xs={12} sm={5} md={5} lg={3}>
          <div className="mp-plan-label">{`Service category`}</div>
          <div>
            <SelectField
              placeholder="Select"
              // disabled={mode === 2 || !isAdditionalPlanRuleEnabled}
              disabled={true}
              className="mp-plan-select-field"
              menuItems={getAvailableOptions(index)}
              value={additionalPlanRulesObjArr[index].serviceCatId}
              onChange={(e) => handleServiceCategoryChange(index, e)}
            />
          </div>
        </Col>

        <Col xs={12} sm={6} md={6} lg={8}></Col>

        <Col xs={12} sm={1} md={1} lg={1}>
          {index > 0 ? (
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                icon
                disabled={mode === 2 || !isAdditionalPlanRuleEnabled}
                style={{
                  cursor: mode == 2 ? "not-allowed" : "pointer",
                }}
                onClick={() => {
                  setAdditionalPlanRulesObjArr((prev) =>
                    prev.filter((_, i) => i !== index),
                  );
                }}
              >
                <FontIcon
                  style={{
                    lineHeight: "0",
                    marginBottom: "20px",
                  }}
                >
                  {"close"}
                </FontIcon>
              </Button>
            </div>
          ) : (
            <></>
          )}
        </Col>
      </Row>
    );

    if (id === 0) {
      return (
        <Row>
          <Col xs={12} sm={12} md={12} lg={12}>
            {serviceCatSelector}
          </Col>
        </Row>
      );
    }

    if (id === 3) {
      return (
        <Row>
          <Col xs={12} sm={12} md={12} lg={12}>
            {serviceCatSelector}
            <br />
            <Col xs={12} sm={5} md={5} lg={3}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div>
                  <Checkbox
                    id={`mp-plan-checkBoxPrescriptionRequired`}
                    name={`mp-plan-checkBoxPrescriptionRequired`}
                    color={mode == 2 ? "default" : "secondary"}
                    disabled={mode === 2 || !isAdditionalPlanRuleEnabled}
                    checked={checkBoxPrescriptionRequired}
                    style={{ marginLeft: "-10px" }}
                    onChange={(event) => {
                      setCheckBoxPrescriptionRequired(
                        !checkBoxPrescriptionRequired,
                      );
                    }}
                  />
                </div>
                <div className="mp-plan-label-checkbox-semibold-label">
                  {`Prescription required`}
                </div>
              </div>
              <div
                className="mp-plan-label"
                style={{ marginBottom: "4px" }}
              >{`Prescribed medicines category allowed`}</div>
              <div>
                <MultiSelectPicker
                  title="Search to select medicine category"
                  disabled={mode === 2 || !isAdditionalPlanRuleEnabled}
                  options={PRESCRIBED_MEDICINES_OPTIONS}
                  value={prescribedMedicinesSelected}
                  onChange={setPrescribedMedicinesSelected}
                  placeholder="Type to search..."
                  // getOptionDisabled={(option) => option.value === "otc"}
                />
              </div>
            </Col>
          </Col>
        </Row>
      );
    }

    return (
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          {serviceCatSelector}
        </Col>
      </Row>
    );
  }

  // ~00
  return (
    <div className="mp-plan-page-padding">
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="mp-plan-view">
            <div className="mp-plan-heading-with-back-button">
              <div
                className="mp-plan-back-btn"
                onClick={() => {
                  exitPage();
                }}
              >
                <FontIcon style={{ fontSize: "36px", marginTop: "2px" }}>
                  arrow_back
                </FontIcon>
              </div>
              <h1>
                {props?.data?.mode == "copy"
                  ? "Copy Plan"
                  : props?.data?.mode == "assign-service"
                    ? "Assigned services to plan"
                    : props?.data?.mode == "renew"
                      ? "Renew plan"
                      : mode == 2
                        ? `View plan`
                        : mode == 3
                          ? `Edit plan`
                          : `Add plan`}
              </h1>
            </div>
            <div className="mp-plan-buttons-container">
              <div className="mp-plan-buttons-right-alignment">
                {mode != 2 && (
                  <Button
                    id="save_cta"
                    raised
                    disabled={loading}
                    className={
                      loading
                        ? "mp-plan-button-save-disabled"
                        : "mp-plan-button-save-enabled"
                    }
                    onClick={() => {
                      handleSave();
                    }}
                  >
                    {props?.data?.mode == "copy"
                      ? "Copy"
                      : mode == 3 && props?.data?.mode != "renew"
                        ? "Update"
                        : "Save"}
                  </Button>
                )}

                <Button
                  id="cancel_cta"
                  raised
                  className="mp-plan-button-cancel"
                  disabled={loading}
                  onClick={() => {
                    exitPage();
                  }}
                >
                  {"Cancel"}
                </Button>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      {props?.data?.mode == "copy" &&
        (props?.data?.sourcePlan || fetchedPlan) && (
          <>
            <br />
            <Row>
              <Col xs={12} sm={12} md={12} lg={12}>
                <TopNote
                  color="rgba(218, 215, 253, 1)"
                  borderColor="rgba(106, 94, 245, 1)"
                  textColor="#26284D"
                  text={
                    <>
                      This plan is being copied from - <strong>Plan ID:</strong>{" "}
                      {(props?.data?.sourcePlan?.id ?? fetchedPlan?.id) || "-"},{" "}
                      <strong>Plan name:</strong>{" "}
                      {(props?.data?.sourcePlan?.basicDetails?.name ??
                        fetchedPlan?.basicDetails?.name) ||
                        "-"}
                      , <strong>Account code:</strong>{" "}
                      {(props?.data?.sourcePlan?.accountCode ??
                        fetchedPlan?.accountCode) ||
                        "-"}
                    </>
                  }
                />
              </Col>
            </Row>
          </>
        )}
      <br />
      <br />
      <div className="mp-plan-grey-heading">Account details</div>
      <br />
      <div className="mp-plan-create-service-container">
        <Row>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container">
              <div className="mp-plan-label">{`Account type`}</div>
              <div>
                <TextField
                  value={
                    accountDetails?.accountCode
                      ? accountDetails.accountCode.substring(0, 2) == "01"
                        ? "Zyla"
                        : accountDetails.accountCode.substring(0, 2) == "02"
                          ? "Insurance"
                          : accountDetails.accountCode.substring(0, 2) == "03"
                            ? "Pharma"
                            : accountDetails.accountCode.substring(0, 2) == "04"
                              ? "Corporate"
                              : accountDetails.accountCode.substring(0, 2) ==
                                  "05"
                                ? "Affinity"
                                : ""
                      : ""
                  }
                  lineDirection="left"
                  disabled
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={1} md={1} lg={1}>
            <div style={{ height: "20px" }}></div>
          </Col>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container">
              <div className="mp-plan-label">{`Account ID`}</div>
              <div>
                <TextField
                  value={
                    accountDetails?.accountCode
                      ? accountDetails.accountCode
                      : ""
                  }
                  lineDirection="left"
                  disabled
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={1} md={1} lg={1}>
            <div style={{ height: "20px" }}></div>
          </Col>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container">
              <div className="mp-plan-label">{`Status`}</div>
              <div>
                <TextField
                  value={
                    accountDetails?.status != undefined
                      ? accountDetails.status == true
                        ? "Active"
                        : "Inactive"
                      : ""
                  }
                  lineDirection="left"
                  disabled
                />
              </div>
            </div>
          </Col>
        </Row>
        <br />
        <Row>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container">
              <div className="mp-plan-label">{`Account name`}</div>
              <div>
                <TextField
                  value={
                    accountDetails?.accountName
                      ? accountDetails.accountName
                      : ""
                  }
                  lineDirection="left"
                  disabled
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={1} md={1} lg={1}>
            <div style={{ height: "20px" }}></div>
          </Col>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container">
              <div className="mp-plan-label">{`Account mode`}</div>
              <div>
                <TextField
                  value={accountDetails?.mode ? accountDetails.mode : ""}
                  lineDirection="left"
                  disabled
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={1} md={1} lg={1}>
            <div style={{ height: "20px" }}></div>
          </Col>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-plan-create-service-field-container">
              <div className="mp-plan-label">{`Key account manager`}</div>
              <div>
                <TextField
                  value={
                    accountDetails?.managerName
                      ? accountDetails.managerName
                      : ""
                  }
                  lineDirection="left"
                  disabled
                />
              </div>
            </div>
          </Col>
        </Row>
        {accountDetails?.whitelistedDomains != null &&
          accountDetails?.whitelistedDomains?.length > 0 && (
            <>
              <br />
              <Row>
                <Col xs={12} sm={3} md={3} lg={3}>
                  <div className="mp-plan-create-service-field-container">
                    <div className="mp-plan-label">{`Whitelisted email domains`}</div>
                    {renderWhitelistedDomains()}
                  </div>
                </Col>
              </Row>
            </>
          )}
      </div>
      <br />
      <div style={{ margin: "0px -15px 0px -15px" }}>
        <Accordion defaultExpanded={true}>
          <AccordionSummary
            expandIcon={<FontIcon>keyboard_arrow_down</FontIcon>}
            style={{ backgroundColor: "#CED4DA" }}
          >
            <div
              style={{
                fontWeight: "600",
                fontSize: "16px",
              }}
            >
              Plan details
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              {(props?.data?.mode == "assign-service" ||
                props?.data?.mode == "renew") && (
                <div>
                  <Row>
                    <Col xs={12} sm={3} md={3} lg={3}>
                      <div
                        className="mp-plan-create-service-field-container"
                        style={{ marginBottom: "10px" }}
                      >
                        <div className="mp-plan-label">
                          {props?.data?.mode == "renew"
                            ? `Old Plan ID`
                            : `Plan ID`}
                        </div>
                        <div>
                          <TextField
                            value={fetchedPlan?.id ? fetchedPlan?.id : ""}
                            lineDirection="left"
                            disabled
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
              <div style={{ margin: "0px -12px 0px -12px" }}>
                <Accordion
                  defaultExpanded={
                    props?.data?.mode == "assign-service" ? false : true
                  }
                >
                  <AccordionSummary
                    expandIcon={<FontIcon>keyboard_arrow_down</FontIcon>}
                    style={{ border: "1px solid #CED4DA", borderRadius: "5px" }}
                  >
                    <div
                      style={{
                        fontWeight: "600",
                        fontSize: "16px",
                      }}
                    >
                      Basic details
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="mp-plan-create-plan-container">
                      <Row>
                        <Col xs={12} sm={3} md={3} lg={3}>
                          <div className="mp-plan-create-service-field-container">
                            <div className="mp-plan-label">
                              {`Plan name`}
                              <label className="account-module-label-red">
                                *
                              </label>
                            </div>
                            <div>
                              <TextField
                                id={"plan_name"}
                                value={`${planName}`}
                                lineDirection="left"
                                placeholder="Type here"
                                disabled={mode == 2}
                                onChange={(e) => {
                                  setPlanName(e);
                                }}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col xs={12} sm={1} md={1} lg={1}>
                          <div style={{ height: "20px" }}></div>
                        </Col>
                        <Col xs={12} sm={3} md={3} lg={3}>
                          <div className="mp-plan-create-service-field-container">
                            <div className="mp-plan-label">{`Plan price (Rs)`}</div>
                            <div>
                              <TextField
                                id={"plan_price"}
                                value={`${planPrice}`}
                                lineDirection="left"
                                placeholder="Type here"
                                type="text"
                                disabled={mode == 2}
                                onChange={(e) => {
                                  let value = e.replace(/\D/g, "");
                                  if (value.length > 10) return;
                                  setPlanPrice(
                                    value == "" ? "" : Number(value),
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col xs={12} sm={1} md={1} lg={1}>
                          <div style={{ height: "20px" }}></div>
                        </Col>
                        <Col xs={12} sm={3} md={3} lg={3}>
                          <div className="mp-plan-create-service-field-container">
                            <div className="mp-plan-label">
                              {`Plan status`}
                              <label className="account-module-label-red">
                                *
                              </label>
                            </div>
                            <div>
                              <SelectField
                                id={"plan_status"}
                                placeholder="Select"
                                className="mp-plan-select-field"
                                menuItems={PLAN_STATUS_OPTIONS}
                                disabled={
                                  mode == 1 ||
                                  mode == 2 ||
                                  (props?.data?.mode == "update" &&
                                    fetchedPlan?.basicDetails?.status === 2) ||
                                  fetchedPlan?.basicDetails?.status === 3 ||
                                  fetchedPlan?.basicDetails?.status === 4 ||
                                  props?.data?.mode == "renew"
                                }
                                value={planStatus}
                                onChange={(e) => {
                                  setPlanStatus(e);
                                }}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col xs={12} sm={3} md={3} lg={3}>
                          <div className="mp-plan-create-service-field-container">
                            <div className="mp-plan-label">{`Plan duration (in days)`}</div>
                            <div>
                              <TextField
                                id={"plan_duration"}
                                value={`${planDuration}`}
                                lineDirection="left"
                                placeholder="Type here"
                                type="text"
                                disabled={mode == 2}
                                onChange={(e) => {
                                  let value = e.replace(/\D/g, "");
                                  if (value.length > 8) return;
                                  if (/^\d+$/.test(e) || e === "") {
                                    setPlanDuration(
                                      value == "" ? "" : Number(value),
                                    );
                                  }
                                }}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col xs={12} sm={1} md={1} lg={1}>
                          <div style={{ height: "20px" }}></div>
                        </Col>
                        <Col xs={12} sm={3} md={3} lg={3}>
                          <div className="mp-plan-create-service-field-container">
                            <div className="mp-plan-label">
                              {`Plan start date`}{" "}
                              <label className="account-module-label-red">
                                *
                              </label>
                            </div>
                            <div style={{ paddingTop: "6px" }}>
                              <MuiPickersUtilsProvider utils={MomentUtils}>
                                <KeyboardDatePicker
                                  id={"plan_start_date"}
                                  style={{ width: "100%" }}
                                  value={planDateFrom ? planDateFrom : null}
                                  onChange={(date) => {
                                    setPlanDateFrom(
                                      moment(date)
                                        .utc()
                                        .startOf("day")
                                        .toISOString(),
                                    );
                                  }}
                                  autoOk={true}
                                  className="mp-plan-start-date"
                                  format="DD MMM YYYY"
                                  placeholder="DD MM YYYY"
                                  keyboardIcon={
                                    <FontIcon id="calendar_icon">
                                      calendar_month
                                    </FontIcon>
                                  }
                                  variant="inline"
                                  minDate={
                                    mode == 1
                                      ? moment.utc("2017-01-01").startOf("day")
                                      : props?.data?.mode == "renew"
                                        ? moment(
                                            fetchedPlan?.basicDetails
                                              ?.status === 1 ||
                                              fetchedPlan?.basicDetails
                                                ?.status === 3
                                              ? fetchedPlan?.basicDetails
                                                  ?.endDate
                                              : fetchedPlan?.basicDetails
                                                    ?.stopDate ===
                                                  "0001-01-01T00:00:00Z"
                                                ? moment().utc().startOf("day")
                                                : fetchedPlan?.basicDetails
                                                    ?.stopDate,
                                          )
                                            .utc()
                                            .add(1, "day")
                                            .startOf("day")
                                        : moment
                                            .utc("2017-01-01")
                                            .startOf("day")
                                  }
                                  maxDate={planDateTo ? planDateTo : undefined}
                                  disabled={mode == 2}
                                />
                              </MuiPickersUtilsProvider>
                            </div>
                          </div>
                        </Col>
                        <Col xs={12} sm={1} md={1} lg={1}>
                          <div style={{ height: "20px" }}></div>
                        </Col>
                        <Col xs={12} sm={3} md={3} lg={3}>
                          <div className="mp-plan-create-service-field-container">
                            <div className="mp-plan-label">
                              {`Plan end date`}{" "}
                              <label className="account-module-label-red">
                                *
                              </label>
                            </div>
                            <div style={{ paddingTop: "6px" }}>
                              <MuiPickersUtilsProvider utils={MomentUtils}>
                                <KeyboardDatePicker
                                  id={"plan_end_date"}
                                  style={{ width: "100%" }}
                                  value={planDateTo ? planDateTo : null}
                                  onChange={(date) => {
                                    setPlanDateTo(
                                      moment(date)
                                        .utc()
                                        .startOf("day")
                                        .toISOString(),
                                    );
                                  }}
                                  autoOk={true}
                                  className="mp-plan-end-date"
                                  format="DD MMM YYYY"
                                  placeholder="DD MM YYYY"
                                  keyboardIcon={
                                    <FontIcon id="calendar_icon">
                                      calendar_month
                                    </FontIcon>
                                  }
                                  variant="inline"
                                  minDate={getPlanEndDateMinDate(
                                    planDateFrom
                                        ? planDateFrom
                                        : props?.data?.mode == "renew"
                                          ? moment(
                                              fetchedPlan?.basicDetails
                                                ?.status === 1 ||
                                                fetchedPlan?.basicDetails
                                                  ?.status === 3
                                                ? fetchedPlan?.basicDetails
                                                    ?.endDate
                                                : fetchedPlan?.basicDetails
                                                      ?.stopDate ===
                                                    "0001-01-01T00:00:00Z"
                                                  ? moment().utc().endOf("day")
                                                  : fetchedPlan?.basicDetails
                                                      ?.stopDate,
                                            )
                                              .utc()
                                              .add(1, "day")
                                              .endOf("day")
                                          : mode === 1
                                            ? moment
                                                .utc("2017-01-01")
                                                .endOf("day")
                                            : moment().utc().endOf("day"),
                                  )}
                                  maxDate={undefined}
                                  disabled={mode == 2}
                                />
                              </MuiPickersUtilsProvider>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col xs={12} sm={3} md={3} lg={3}>
                          <div className="mp-plan-create-service-field-container">
                            <div className="mp-plan-label">
                              {`Default therapy (if any)`}
                            </div>
                            <div>
                              <SelectField
                                id={"plan_default_therapy"}
                                placeholder="Select"
                                className="mp-plan-select-field"
                                menuItems={therapyOptions}
                                disabled={mode == 2}
                                value={planDefaultTherapy}
                                onChange={(e) => {
                                  setPlanDefaultTherapy(e);
                                }}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col xs={12} sm={3} md={3} lg={3}>
                          <div className="mp-plan-create-service-field-container">
                            <div className="mp-plan-label">
                              {`Plan image (Mobile view)`}
                              <label className="account-module-label-red">
                                *
                              </label>
                            </div>
                            <div className="mp-plan-image-requirements">{`(Max file size: 20mb, minimum dimensions 328*175px)`}</div>
                            <Button
                              id={"plan_image_mobile"}
                              raised
                              disabled={mode == 2}
                              className="mp-plan-button-upload"
                              onClick={() => {
                                planMobileUploadClick();
                              }}
                            >
                              {planMobilePreview == ""
                                ? "Upload image"
                                : "Update image"}
                            </Button>
                            <input
                              type="file"
                              accept="image/png, image/jpeg"
                              ref={planMobileImageInputRef}
                              style={{ display: "none" }}
                              onChange={planMobileImageSelected}
                            />
                            <Col xs={12} sm={5} md={4} lg={4}>
                              {planMobilePreview && planMobilePreview != "" && (
                                <>
                                  <div
                                    style={{
                                      display: "inline-block",
                                      border: "1px solid black",
                                      marginTop: "15px",
                                      marginLeft: "-6px",
                                    }}
                                  >
                                    <img
                                      src={planMobilePreview}
                                      alt="Selected Preview"
                                      style={{
                                        width: "200px",
                                        height: "auto",
                                        display: "block",
                                      }}
                                    />
                                  </div>
                                </>
                              )}
                            </Col>
                          </div>
                        </Col>
                        <Col xs={12} sm={1} md={1} lg={1}>
                          <div style={{ height: "20px" }}></div>
                        </Col>
                        <Col xs={12} sm={3} md={3} lg={3}>
                          <div className="mp-plan-create-service-field-container">
                            <div className="mp-plan-label">
                              {`Plan image (Desktop view)`}
                            </div>
                            <div className="mp-plan-image-requirements">{`(Max file size: 20mb, minimum dimensions 435*232px)`}</div>
                            <Button
                              id={"plan_desktop_mobile"}
                              raised
                              disabled={mode == 2}
                              className="mp-plan-button-upload"
                              onClick={() => {
                                planDesktopUploadClick();
                              }}
                            >
                              {planDesktopPreview == ""
                                ? "Upload image"
                                : "Update image"}
                            </Button>
                            <input
                              type="file"
                              accept="image/png, image/jpeg"
                              ref={planDesktopImageInputRef}
                              style={{ display: "none" }}
                              onChange={planDesktopImageSelected}
                            />
                            <Col xs={12} sm={5} md={4} lg={4}>
                              {planDesktopPreview &&
                                planDesktopPreview != "" && (
                                  <>
                                    <div
                                      style={{
                                        display: "inline-block",
                                        border: "1px solid black",
                                        marginTop: "15px",
                                        marginLeft: "-6px",
                                      }}
                                    >
                                      <img
                                        src={planDesktopPreview}
                                        alt="Selected Preview"
                                        style={{
                                          width: "200px",
                                          height: "auto",
                                          display: "block",
                                        }}
                                      />
                                    </div>
                                  </>
                                )}
                            </Col>
                          </div>
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col xs={12} sm={11} md={11} lg={11}>
                          <div className="mp-plan-field-container">
                            <div className="mp-plan-label">
                              {`Plan short description (50 characters)`}
                              <label className="mp-plan-label-red"> *</label>
                            </div>
                            <div>
                              <TextField
                                id={"plan_short_des"}
                                disabled={mode == 2}
                                value={
                                  planShortDescription
                                    ? `${planShortDescription}`
                                    : ""
                                }
                                lineDirection="left"
                                placeholder="Type here"
                                error={
                                  planShortDescription != null
                                    ? planShortDescription >= 50
                                      ? true
                                      : false
                                    : false
                                }
                                errorText="Short description can be of max 50 characters only"
                                onChange={(e) => {
                                  if (e.length <= 50) {
                                    setPlanShortDescription(e);
                                  }
                                }}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col xs={12} sm={11} md={11} lg={11}>
                          <div className="mp-plan-field-container">
                            <div className="mp-plan-label-2">
                              {`Plan long description`}
                              <label className="account-module-label-red">
                                *
                              </label>
                            </div>
                            <div
                              id={"plan_long_des"}
                              style={{
                                borderBottom: "2px solid #E4E4E4",
                                marginTop: "10px",
                              }}
                            >
                              <Editor
                                id={"plan_long_des"}
                                readOnly={mode == 2 ? true : false}
                                editorState={editorState}
                                wrapperClassName=""
                                editorClassName=""
                                onEditorStateChange={_onEditorStateChange}
                                stripPastedStyles={true}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col xs={12} sm={11} md={11} lg={11}>
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div>
                              <Checkbox
                                id={`auto_activate_checkbox`}
                                name={`mp-plan-checkbox-auto-activate`}
                                color={mode == 2 ? "default" : "secondary"}
                                disabled={mode == 2}
                                checked={planAutoActivate}
                                style={{ marginLeft: "-10px" }}
                                onChange={(event) => {
                                  setPlanAutoActivate(!planAutoActivate);
                                }}
                              />
                            </div>
                            <div className="mp-plan-label-checkbox">
                              {`Auto activate plan`}
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col xs={12} sm={3} md={3} lg={3}>
                          <div className="mp-plan-create-service-field-container">
                            <div className="mp-plan-label">
                              {`Email domain`}
                            </div>
                            <div style={{ display: "flex" }}>
                              <div className="account-module-email-prefix">{`@`}</div>
                              <TextField
                                id={"plan_email_domain"}
                                lineDirection="left"
                                value={domainTyped}
                                disabled={mode == 2}
                                placeholder="Type here"
                                inlineIndicator={
                                  <Button
                                    icon
                                    style={{
                                      margin: "-10px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <FontIcon
                                      style={{
                                        color: "#EF7C01",
                                        lineHeight: "0",
                                        marginBottom: "15px",
                                      }}
                                      onClick={() => {
                                        if (mode != 2) {
                                          handleAddPlanEmailDomainIcon();
                                        }
                                      }}
                                    >
                                      arrow_forward
                                    </FontIcon>
                                  </Button>
                                }
                                onChange={(e) => {
                                  setDomainTyped(e);
                                }}
                              />
                            </div>
                            {renderPlanEmailDomains()}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
              <div style={{ margin: "0px -12px 0px -12px" }}>
                <Accordion
                  expanded={walletExpanded}
                  onChange={() => setWalletExpanded((prev) => !prev)}
                >
                  <AccordionSummary
                    expandIcon={<FontIcon>keyboard_arrow_down</FontIcon>}
                    style={{ border: "1px solid #CED4DA", borderRadius: "5px" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontWeight: "600",
                        fontSize: "16px",
                        gap: "6px",
                      }}
                    >
                      <Checkbox
                        id="isWalletIncluded"
                        name="mp-plan-checkbox-isWalletIncluded"
                        color={mode == 2 ? "default" : "secondary"}
                        disabled={mode == 2}
                        checked={isWalletIncluded}
                        style={{ marginLeft: "-10px" }}
                        onChange={() => {
                          if (isWalletIncluded) {
                            deSelectWalletIncluded();
                          } else {
                            setIsWalletIncluded(!isWalletIncluded);
                          }
                        }}
                      />

                      <span>Wallet included</span>

                      <InfoButton onClick={() => handleInfoClick(1)} />
                    </div>
                  </AccordionSummary>

                  <AccordionDetails>
                    <div className="mp-plan-create-plan-container">
                      {/* <Row>
                        <Col xs={12} sm={11} md={11} lg={11}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <div>
                              <Checkbox
                                id={`mp-plan-checkbox-isUnlimitedWallet`}
                                name={`mp-plan-checkbox-isUnlimitedWallet`}
                                color={mode == 2 ? "default" : "secondary"}
                                disabled={
                                  mode == 2 || isWalletIncluded == false
                                }
                                checked={isUnlimitedWallet}
                                style={{ marginLeft: "-10px" }}
                                onChange={(event) => {
                                  if (!isUnlimitedWallet) {
                                    setWalletLimit("");
                                  }
                                  setIsUnlimitedWallet(!isUnlimitedWallet);
                                }}
                              />
                            </div>
                            <div className="mp-plan-label-checkbox">
                              Check mark if wallet unlimited or define limit
                              below
                              <label className="mp-plan-label-red"> *</label>
                            </div>
                          </div>

                          <div
                            className="mp-plan-create-service-field-container"
                            style={{ marginTop: "-16px" }}
                          >
                            <div>
                              <TextField
                                value={`${walletLimit}`}
                                lineDirection="left"
                                type="text"
                                style={{ width: "200px" }}
                                placeholder="Limit (Rs)"
                                disabled={
                                  mode == 2 ||
                                  isWalletIncluded == false ||
                                  isUnlimitedWallet
                                }
                                onChange={(e) => {
                                  let value = e.replace(/\D/g, "");
                                  if (value.length > 8) return;
                                  setWalletLimit(
                                    value == "" ? "" : Number(value)
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row> */}
                      <Row>
                        <Col xs={12} sm={3} md={3} lg={3}>
                          <div className="mp-plan-create-service-field-container">
                            <div className="mp-plan-label">
                              {`Wallet type`}
                              <label className="account-module-label-red">
                                *
                              </label>
                            </div>
                            <div id="wallet_type">
                              <SelectField
                                id="wallet_type"
                                placeholder="Select"
                                className="mp-plan-select-field"
                                menuItems={WALLET_TYPE_OPTIONS}
                                disabled={
                                  mode == 2 || isWalletIncluded == false
                                }
                                value={isUnlimitedWallet ? 2 : 1} // 1 = limited; 2 = unlimited
                                onChange={(e) => {
                                  if (e === 2) {
                                    //open popup - max
                                    changeWalletToUnLimitedConfirm();
                                  } else if (e === 1) {
                                    //open popup - min
                                    changeWalletToLimitedConfirm();
                                  }
                                }}
                              />
                            </div>
                          </div>
                        </Col>
                        {isUnlimitedWallet === false && (
                          <>
                            <Col xs={12} sm={1} md={1} lg={1}>
                              <div style={{ height: "20px" }}></div>
                            </Col>
                            <Col xs={12} sm={3} md={3} lg={3}>
                              <div className="mp-plan-create-service-field-container">
                                <div className="mp-plan-label">
                                  {`Wallet limit (Rs.)`}
                                  <label className="account-module-label-red">
                                    *
                                  </label>
                                </div>

                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                  }}
                                >
                                  <TextField
                                    id="wallet_limit"
                                    value={`${walletLimitInEditState}`}
                                    style={{ width: "90%" }}
                                    lineDirection="left"
                                    type="text"
                                    placeholder={
                                      canEditWalletLimit
                                        ? "Type here"
                                        : "Click edit icon to enter amount"
                                    }
                                    disabled={
                                      mode == 2 ||
                                      isWalletIncluded == false ||
                                      isUnlimitedWallet ||
                                      canEditWalletLimit == false
                                    }
                                    onChange={(e) => {
                                      let value = e.replace(/\D/g, "");
                                      if (value.length > 8) return;
                                      setWalletLimitInEditState(
                                        value == "" ? "" : Number(value),
                                      );
                                    }}
                                  />
                                  {mode == 2 ? (
                                    <></>
                                  ) : (
                                    <Button
                                      icon
                                      style={{
                                        cursor: "pointer",
                                      }}
                                      disabled={
                                        mode == 2 ||
                                        isWalletIncluded == false ||
                                        isUnlimitedWallet
                                      }
                                      onClick={() => {
                                        if (mode != 2) {
                                          const isValidNumber = (val) =>
                                            typeof val === "number" &&
                                            !isNaN(val);

                                          if (canEditWalletLimit === true) {
                                            const isEditedValid = isValidNumber(
                                              walletLimitInEditState,
                                            );
                                            const isOriginalValid =
                                              isValidNumber(walletLimit);

                                            if (isEditedValid) {
                                              const updated =
                                                walletLimitInEditState;

                                              if (
                                                !isOriginalValid ||
                                                walletLimit === ""
                                              ) {
                                                // Case: previously empty, now valid → just set directly
                                                setWalletLimit(updated);
                                                setCanEditWalletLimit(false);
                                              } else {
                                                const current = walletLimit;

                                                if (current > updated) {
                                                  reduceWalletLimitConfirm();
                                                } else if (updated > current) {
                                                  increaseWalletLimitConfirm();
                                                } else {
                                                  setCanEditWalletLimit(false);
                                                }
                                              }
                                            } else {
                                              // Special case: reducing from number to empty string
                                              if (
                                                isOriginalValid &&
                                                walletLimit > 0 &&
                                                walletLimitInEditState === ""
                                              ) {
                                                EventService.emit("showError", {
                                                  message:
                                                    "Wallet limit can't be left empty",
                                                });
                                              }
                                            }
                                          } else {
                                            setCanEditWalletLimit(true);
                                          }
                                        }
                                      }}
                                    >
                                      <FontIcon
                                        style={{
                                          color: "#EF7C01",
                                          lineHeight: "0",
                                          marginBottom: "15px",
                                        }}
                                      >
                                        {canEditWalletLimit ? "check" : "edit"}
                                      </FontIcon>
                                    </Button>
                                  )}
                                </div>
                              </div>
                            </Col>
                          </>
                        )}
                      </Row>
                      <Row>
                        <Col xs={12} sm={11} md={11} lg={11}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <div>
                              <Checkbox
                                id={`canWalletBeUsedByFamily`}
                                name={`mp-plan-checkbox-canWalletBeUsedByFamily`}
                                color={mode == 2 ? "default" : "secondary"}
                                disabled={
                                  mode == 2 || isWalletIncluded == false
                                }
                                checked={canWalletBeUsedByFamily}
                                style={{ marginLeft: "-10px" }}
                                onChange={(event) => {
                                  if (canWalletBeUsedByFamily) {
                                    setAllowedFamilyRelationsForWallet([]);
                                    setSelectAllFamilyForWallet(false);
                                  }
                                  setWalletCanBeUsedByFamily(
                                    !canWalletBeUsedByFamily,
                                  );
                                }}
                              />
                            </div>
                            <div className="mp-plan-label-checkbox">
                              Select if wallet can be used by family members
                            </div>
                          </div>
                          {/* <div
                            className={
                              isWalletIncluded
                                ? "mp-plan-box-selected"
                                : "mp-plan-box-unselected"
                            }
                          >
                            <div className="mp-plan-font">{"Self"}</div>
                          </div> */}
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <div>
                              <Checkbox
                                id={`selectAllFamilyForWallet`}
                                name={`mp-plan-checkbox-selectAllFamilyForWallet`}
                                color={mode == 2 ? "default" : "secondary"}
                                disabled={
                                  mode == 2 || isWalletIncluded == false
                                }
                                checked={selectAllFamilyForWallet}
                                style={{ marginLeft: "-10px" }}
                                onChange={(event) => {
                                  if (canWalletBeUsedByFamily) {
                                    setAllowedFamilyRelationsForWallet(
                                      selectAllFamilyForWallet == false
                                        ? allRelations
                                        : [],
                                    );
                                    setSelectAllFamilyForWallet(
                                      !selectAllFamilyForWallet,
                                    );
                                  }
                                }}
                              />
                            </div>
                            <div
                              className="mp-plan-label-checkbox"
                              style={{ marginRight: "10px" }}
                            >
                              All family &nbsp; or &nbsp; Choose member
                            </div>
                            <div className="mp-plan-multiple-box-options">
                              {familyRelationsArr.map((rel) => {
                                return (
                                  <div
                                    className={
                                      allowedFamilyRelationsForWallet.includes(
                                        rel.code,
                                      )
                                        ? "mp-plan-box-selected"
                                        : "mp-plan-box-unselected"
                                    }
                                    onClick={() => {
                                      if (
                                        canWalletBeUsedByFamily &&
                                        isWalletIncluded == true &&
                                        mode != 2
                                      ) {
                                        setAllowedFamilyRelationsForWallet(
                                          (prevRelations) =>
                                            prevRelations.includes(rel.code)
                                              ? prevRelations.filter(
                                                  (code) => code !== rel.code,
                                                )
                                              : [...prevRelations, rel.code],
                                        );
                                      }
                                    }}
                                  >
                                    <div className="mp-plan-font">
                                      {rel.code == 6
                                        ? "Daughter < 18"
                                        : rel.code == 7
                                          ? "Daughter > 18"
                                          : rel.code == 8
                                            ? "Son < 18"
                                            : rel.code == 9
                                              ? "Son > 18"
                                              : rel.code == 6
                                                ? "Daughter < 18"
                                                : rel.value}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
              <div style={{ margin: "0px -12px 0px -12px" }}>
                <Accordion
                  expanded={reimbursementExpanded}
                  onChange={() => setReimbursementExpanded((prev) => !prev)}
                >
                  <AccordionSummary
                    expandIcon={<FontIcon>keyboard_arrow_down</FontIcon>}
                    style={{ border: "1px solid #CED4DA", borderRadius: "5px" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontWeight: "600",
                        fontSize: "16px",
                        gap: "6px",
                      }}
                    >
                      <Checkbox
                        id="isReimbursementIncluded"
                        name="mp-plan-checkbox-isReimbursementIncluded"
                        color={mode == 2 ? "default" : "secondary"}
                        disabled={mode == 2 || isWalletIncluded == false}
                        checked={isReimbursementIncluded}
                        style={{ marginLeft: "-10px" }}
                        onChange={() => {
                          if (isWalletLimitNotFilled()) return;

                          if (isReimbursementIncluded) {
                            deSelectReimbursementIncluded();
                          } else {
                            setIsReimbursementIncluded(
                              !isReimbursementIncluded,
                            );
                          }
                        }}
                      />

                      <span>Claim included</span>

                      <InfoButton onClick={() => handleInfoClick(2)} />
                    </div>
                  </AccordionSummary>

                  <AccordionDetails>
                    <div className="mp-plan-create-plan-container">
                      <Row>
                        <Col xs={12} sm={11} md={11} lg={11}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <div>
                              <Checkbox
                                id={`canReimbursementBeUsedByFamily`}
                                name={`mp-plan-checkbox-canReimbursementBeUsedByFamily`}
                                color={mode == 2 ? "default" : "secondary"}
                                disabled={
                                  mode == 2 || isReimbursementIncluded == false
                                }
                                checked={canReimbursementBeUsedByFamily}
                                style={{ marginLeft: "-10px" }}
                                onChange={(event) => {
                                  if (canReimbursementBeUsedByFamily) {
                                    setAllowedFamilyRelationsForReimbursement(
                                      [],
                                    );
                                    setSelectAllFamilyForReimbursement(false);
                                  }
                                  setReimbursementCanBeUsedByFamily(
                                    !canReimbursementBeUsedByFamily,
                                  );
                                }}
                              />
                            </div>
                            <div className="mp-plan-label-checkbox">
                              Select if claim can be used by family members
                            </div>
                          </div>
                          {/* <div
                            className={
                              isReimbursementIncluded
                                ? "mp-plan-box-selected"
                                : "mp-plan-box-unselected"
                            }
                          >
                            <div className="mp-plan-font">{"Self"}</div>
                          </div> */}
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <div>
                              <Checkbox
                                id={`selectAllFamilyForReimbursement`}
                                name={`mp-plan-checkbox-selectAllFamilyForReimbursement`}
                                color={mode == 2 ? "default" : "secondary"}
                                disabled={
                                  mode == 2 || isReimbursementIncluded == false
                                }
                                checked={selectAllFamilyForReimbursement}
                                style={{ marginLeft: "-10px" }}
                                onChange={(event) => {
                                  if (canReimbursementBeUsedByFamily) {
                                    setAllowedFamilyRelationsForReimbursement(
                                      selectAllFamilyForReimbursement == false
                                        ? allRelations
                                        : [],
                                    );
                                    setSelectAllFamilyForReimbursement(
                                      !selectAllFamilyForReimbursement,
                                    );
                                  }
                                }}
                              />
                            </div>
                            <div
                              className="mp-plan-label-checkbox"
                              style={{ marginRight: "10px" }}
                            >
                              All family &nbsp; or &nbsp; Choose member
                            </div>
                            <div className="mp-plan-multiple-box-options">
                              {familyRelationsArr.map((rel) => {
                                return (
                                  <div
                                    className={
                                      allowedFamilyRelationsForReimbursement.includes(
                                        rel.code,
                                      )
                                        ? "mp-plan-box-selected"
                                        : "mp-plan-box-unselected"
                                    }
                                    onClick={() => {
                                      if (
                                        canReimbursementBeUsedByFamily &&
                                        isReimbursementIncluded == true &&
                                        mode != 2
                                      ) {
                                        setAllowedFamilyRelationsForReimbursement(
                                          (prevRelations) =>
                                            prevRelations.includes(rel.code)
                                              ? prevRelations.filter(
                                                  (code) => code !== rel.code,
                                                )
                                              : [...prevRelations, rel.code],
                                        );
                                      }
                                    }}
                                  >
                                    <div className="mp-plan-font">
                                      {rel.code == 6
                                        ? "Daughter < 18"
                                        : rel.code == 7
                                          ? "Daughter > 18"
                                          : rel.code == 8
                                            ? "Son < 18"
                                            : rel.code == 9
                                              ? "Son > 18"
                                              : rel.code == 6
                                                ? "Daughter < 18"
                                                : rel.value}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <div>
                              <Checkbox
                                id={`canReimbursementBeUsedByFamily`}
                                name={`mp-plan-checkbox-canReimbursementBeUsedByFamily`}
                                color={mode == 2 ? "default" : "secondary"}
                                disabled={
                                  mode == 2 || isReimbursementIncluded == false
                                }
                                checked={isBankAccountRequired}
                                style={{ marginLeft: "-10px" }}
                                onChange={(event) => {
                                  setIsBankAccountRequired(
                                    !isBankAccountRequired,
                                  );
                                }}
                              />
                            </div>
                            <div className="mp-plan-label-checkbox">
                              Select to enable “My bank account” section in app.
                              Claim amount will be refunded to user's provided
                              bank account
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
              <div style={{ margin: "0px -12px 0px -12px" }}>
                <Accordion
                  expanded={walletFaqsExpanded}
                  onChange={() => setWalletFaqsExpanded((prev) => !prev)}
                >
                  <AccordionSummary
                    expandIcon={<FontIcon>keyboard_arrow_down</FontIcon>}
                    style={{ border: "1px solid #CED4DA", borderRadius: "5px" }}
                  >
                    <div
                      style={{
                        fontWeight: "600",
                        fontSize: "16px",
                      }}
                    >
                      <Checkbox
                        id={`isWalletFaqsIncluded`}
                        name={`mp-plan-checkbox-isWalletFaqsIncluded`}
                        color={mode == 2 ? "default" : "secondary"}
                        disabled={mode == 2 || isWalletIncluded == false}
                        checked={isWalletFaqsIncluded}
                        style={{ marginLeft: "-10px" }}
                        onChange={(e) => {
                          if (isWalletLimitNotFilled()) {
                            return;
                          }
                          if (isWalletFaqsIncluded) {
                            deSelectFAQsIncluded();
                          } else {
                            setIsWalletFaqsIncluded(!isWalletFaqsIncluded);
                          }
                        }}
                      />
                      Wallet and claim FAQs
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="mp-plan-create-plan-container">
                      <div className="mp-plan-rule-table-container">
                        {walletFaqs.length > 0 &&
                          walletFaqs.map((row, index) => {
                            return (
                              <div
                                className="mp-plan-rule-table-row-container"
                                style={{ borderBottom: "1px solid #C2C2C2" }}
                              >
                                <div style={{ width: "4%" }}>{`${
                                  index + 1
                                }.`}</div>
                                <div style={{ width: "4%" }}>
                                  {mode == 2 ? (
                                    <></>
                                  ) : (
                                    <Button
                                      id="edit_faq"
                                      icon
                                      style={{
                                        cursor: "pointer",
                                      }}
                                      disabled={mode === 2}
                                      onClick={async () => {
                                        const result = await confirm2({
                                          title: "Wallet and claim FAQs",
                                          message:
                                            "Fill the FAQ question and it's answer",
                                          questionText: row.question,
                                          answerText: row.answer,
                                          width: "80%",
                                          buttons: {
                                            1: "close",
                                            2: {
                                              label: "Cancel",
                                              color: "zyGreen",
                                            },
                                            3: {
                                              label: "Save",
                                              color: "zyOrange",
                                            },
                                          },
                                        });

                                        console.log("Result: ", result);
                                        if (result.buttonKey === "3") {
                                          updateWalletFaq(
                                            index,
                                            result.questionText,
                                            result.answerText,
                                          );
                                        }
                                      }}
                                    >
                                      <FontIcon
                                        id="edit_faq"
                                        style={{
                                          color: "#EF7C01",
                                          lineHeight: "0",
                                          marginBottom: "18px",
                                        }}
                                      >
                                        {"edit"}
                                      </FontIcon>
                                    </Button>
                                  )}
                                </div>
                                <div
                                  style={{
                                    width: "5%",
                                    textAlign: "left",
                                    display: "flex",
                                  }}
                                >
                                  <Button
                                    icon
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    onClick={async () => {
                                      const result = await confirm2({
                                        title: "Wallet and claim FAQs",
                                        questionText: row.question,
                                        answerText: row.answer,
                                        width: "80%",
                                        viewOnly: true,
                                        buttons: {
                                          1: "close",
                                        },
                                      });
                                    }}
                                  >
                                    <FontIcon
                                      id="remove"
                                      style={{
                                        color: "#EF7C01",
                                        lineHeight: "0",
                                        marginBottom: "18px",
                                      }}
                                    >
                                      {"remove_red_eye"}
                                    </FontIcon>
                                  </Button>
                                </div>
                                <div
                                  id="question"
                                  style={{
                                    width: "40%",
                                    textAlign: "left",
                                    display: "flex",
                                  }}
                                >
                                  <span
                                    style={{
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    <strong>Question {`${index + 1}:`}</strong>{" "}
                                    {isMessageEffectivelyEmpty(row.question)
                                      ? ""
                                      : stripHtmlTags(row.question)}
                                  </span>
                                </div>
                                <div
                                  style={{
                                    width: "5%",
                                    textAlign: "left",
                                    display: "flex",
                                  }}
                                ></div>
                                <div
                                  id="answer"
                                  style={{
                                    width: "35%",

                                    textAlign: "left",
                                    display: "flex",
                                  }}
                                >
                                  <span
                                    style={{
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    <strong>Answer:</strong>{" "}
                                    {isMessageEffectivelyEmpty(row.answer)
                                      ? ""
                                      : stripHtmlTags(row.answer)}
                                  </span>
                                </div>
                                <div
                                  style={{
                                    width: "5%",
                                    textAlign: "left",
                                    display: "flex",
                                  }}
                                ></div>

                                <div style={{ width: "4%" }}>
                                  <Button
                                    icon
                                    disabled={mode == 2}
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      deleteWalletFaq(index);
                                    }}
                                  >
                                    <FontIcon
                                      id="close"
                                      style={{
                                        lineHeight: "0",
                                        marginBottom: "20px",
                                      }}
                                    >
                                      {"close"}
                                    </FontIcon>
                                  </Button>
                                </div>
                              </div>
                            );
                          })}
                        <div className="mp-plan-rule-table-row-container">
                          <div style={{ width: "4%" }}></div>

                          <div
                            id="add_new"
                            className={
                              isWalletFaqsIncluded && mode != 2
                                ? "orange-bold-add-new"
                                : "grey-bold-add-new"
                            }
                            onClick={() => {
                              if (isWalletFaqsIncluded && mode != 2) {
                                addEmptyWalletFaq();
                              }
                            }}
                          >
                            + Add new
                          </div>
                        </div>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
              {/* ~1 */}
              <div style={{ margin: "0px -12px 0px -12px" }}>
                <Accordion
                  expanded={categoryRuleExpanded}
                  onChange={() => setCategoryRuleExpanded((prev) => !prev)}
                >
                  <AccordionSummary
                    expandIcon={<FontIcon>keyboard_arrow_down</FontIcon>}
                    style={{ border: "1px solid #CED4DA", borderRadius: "5px" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontWeight: "600",
                        fontSize: "16px",
                        gap: "6px",
                      }}
                    >
                      <Checkbox
                        id="isCategoryRuleEnabled"
                        name="mp-plan-checkbox-isCategoryRuleEnabled"
                        color={mode == 2 ? "default" : "secondary"}
                        disabled={mode == 2 || isWalletIncluded == false}
                        checked={isCategoryRuleEnabled}
                        style={{ marginLeft: "-10px" }}
                        onChange={(e) => {
                          if (isWalletLimitNotFilled()) return;

                          if (isCategoryRuleEnabled) {
                            deSelectCategoryRuleIncluded();
                          } else {
                            setIsCategoryRuleEnabled(!isCategoryRuleEnabled);
                          }
                        }}
                      />

                      <span>Advanced wallet rules</span>

                      <InfoButton onClick={() => handleInfoClick(3)} />
                    </div>
                  </AccordionSummary>

                  <AccordionDetails>
                    <div className="mp-plan-create-plan-container">
                      <div className="mp-plan-rule-table-container">
                        <div className="mp-plan-rule-table-heading-row-container">
                          <div style={{ width: "4%" }}></div>
                          <div style={{ width: "15%", textAlign: "left" }}>
                            Service type
                          </div>
                          <div style={{ width: "8%" }}>
                            <div>Sublimit</div>
                            <div>applicable</div>
                          </div>
                          <div style={{ width: "15%" }}>
                            <div>Value</div>
                            <div className="radio-column-wrapper">
                              {isUnlimitedWallet === false && (
                                <div className="radio-option">
                                  <div>
                                    <OrangeRadio
                                      checked={
                                        valueTypeCategoryRuleSublimit ===
                                        PERCENT_TYPE
                                      }
                                      disabled={
                                        isCategoryRuleEnabled === false ||
                                        mode === 2
                                      }
                                      onChange={() => {
                                        changeToPercent(1); //passing column number
                                      }}
                                      value={"1"}
                                      name="mp-plan-account-radio"
                                    />
                                  </div>
                                  <div className="radio-label">Percent (%)</div>
                                </div>
                              )}

                              <div className="radio-option">
                                <div>
                                  <OrangeRadio
                                    checked={
                                      valueTypeCategoryRuleSublimit ===
                                      AMOUNT_TYPE
                                    }
                                    disabled={
                                      isCategoryRuleEnabled === false ||
                                      mode === 2
                                    }
                                    onChange={() => {
                                      changeToAmount(1);
                                    }}
                                    value={"2"}
                                    name="mp-plan-account-radio"
                                  />
                                </div>
                                <div className="radio-label">Amount (Rs.)</div>
                              </div>
                            </div>
                          </div>
                          <div style={{ width: "10%" }}>
                            <div>Fixed</div>
                            <div>amount</div>
                          </div>
                          <div style={{ width: "10%" }}>
                            <div>Per transaction</div>
                            <div>limit</div>
                          </div>
                          <div style={{ width: "15%" }}>
                            <div>Value</div>
                            <div className="radio-column-wrapper">
                              <div className="radio-option">
                                <div>
                                  <OrangeRadio
                                    checked={
                                      valueTypeCategoryRulePerTran ===
                                      PERCENT_TYPE
                                    }
                                    disabled={
                                      isCategoryRuleEnabled === false ||
                                      mode === 2
                                    }
                                    onChange={() => {
                                      changeToPercent(2);
                                    }}
                                    value={"1"}
                                    name="mp-plan-account-radio"
                                  />
                                </div>
                                <div className="radio-label">Percent (%)</div>
                              </div>

                              <div className="radio-option">
                                <div>
                                  <OrangeRadio
                                    checked={
                                      valueTypeCategoryRulePerTran ===
                                      AMOUNT_TYPE
                                    }
                                    disabled={
                                      isCategoryRuleEnabled === false ||
                                      mode === 2
                                    }
                                    onChange={() => {
                                      changeToAmount(2);
                                    }}
                                    value={"2"}
                                    name="mp-plan-account-radio"
                                  />
                                </div>
                                <div className="radio-label">Amount (Rs.)</div>
                              </div>
                            </div>
                          </div>
                          <div style={{ width: "8%" }}>
                            <div>Co-Pay by</div>
                            <div>employee</div>
                          </div>
                          <div style={{ width: "15%" }}>
                            <div>Value</div>
                            <div className="radio-column-wrapper">
                              <div className="radio-option">
                                <div>
                                  <OrangeRadio
                                    checked={
                                      valueTypeCategoryRuleCoPay ===
                                      PERCENT_TYPE
                                    }
                                    disabled={
                                      isCategoryRuleEnabled === false ||
                                      mode === 2
                                    }
                                    onChange={() => {
                                      changeToPercent(3);
                                    }}
                                    value={"1"}
                                    name="mp-plan-account-radio"
                                  />
                                </div>
                                <div className="radio-label">Percent (%)</div>
                              </div>

                              <div className="radio-option">
                                <div>
                                  <OrangeRadio
                                    checked={
                                      valueTypeCategoryRuleCoPay === AMOUNT_TYPE
                                    }
                                    disabled={
                                      isCategoryRuleEnabled === false ||
                                      mode === 2
                                    }
                                    onChange={() => {
                                      changeToAmount(3);
                                    }}
                                    value={"2"}
                                    name="mp-plan-account-radio"
                                  />
                                </div>
                                <div className="radio-label">Amount (Rs.)</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {serviceCategories?.length > 0 &&
                        categoryRuleData?.length > 0 ? (
                          categoryRuleData.map((row, index) => {
                            return (
                              <div className="mp-plan-rule-table-row-container">
                                <div style={{ width: "4%" }}>{`${
                                  index + 1
                                }.`}</div>
                                <div
                                  style={{ width: "15%", textAlign: "left" }}
                                >
                                  {
                                    serviceCategories.find(
                                      (e) => e.id === row.serviceCategoryId,
                                    ).name
                                  }
                                </div>
                                <div style={{ width: "8%" }}>
                                  <Checkbox
                                    id={`checkbox_service_type`}
                                    name={`mp-plan-checkbox-1`}
                                    color={
                                      mode == 2 || canEdit(1, index) === false
                                        ? "default"
                                        : "secondary"
                                    }
                                    disabled={
                                      isCategoryRuleEnabled === false ||
                                      canEdit(1, index) === false
                                    }
                                    checked={row.sublimit.enabled}
                                    style={{ marginLeft: "-10px" }}
                                    onChange={(event) => {
                                      updateCategoryRule(
                                        row.serviceCategoryId,
                                        1,
                                        1,
                                        !row.sublimit.enabled,
                                      );
                                    }}
                                  />
                                </div>
                                <div
                                  id={`service_type_amount`}
                                  style={{ width: "15%" }}
                                >
                                  <ValidatedAmountField
                                    id={`service_type`}
                                    valueType={valueTypeCategoryRuleSublimit}
                                    row={row}
                                    disabled={canEdit(1, index) === false}
                                    fieldKey="sublimit"
                                    mode={mode}
                                    isUnlimitedWallet={isUnlimitedWallet}
                                    walletLimit={walletLimit}
                                    columnNo={1}
                                    onUpdate={(cleaned) =>
                                      updateCategoryRule(
                                        row.serviceCategoryId,
                                        1,
                                        2,
                                        cleaned,
                                      )
                                    }
                                  />
                                </div>
                                <div style={{ width: "10%" }}>
                                  <Checkbox
                                    id={`checkbox_fixed_value`}
                                    name={`mp-plan-checkbox-2`}
                                    // color={
                                    //   mode === 2 ||
                                    //   (Array.isArray(
                                    //     fetchedPlan?.walletRules
                                    //       ?.serviceCategoryRules
                                    //   ) &&
                                    //     fetchedPlan.walletRules
                                    //       .serviceCategoryRules[index]
                                    //       ?.isFixedAmount === true)
                                    //     ? "default"
                                    //     : "secondary"
                                    // }
                                    color={mode === 2 ? "default" : "secondary"}
                                    disabled={
                                      isCategoryRuleEnabled === false ||
                                      mode === 2 ||
                                      isUnlimitedWallet
                                    }
                                    checked={row.isFixedAmount}
                                    style={{ marginLeft: "-10px" }}
                                    onChange={(event) => {
                                      updateCategoryRule(
                                        row.serviceCategoryId,
                                        4,
                                        0,
                                        !row.isFixedAmount,
                                      );
                                    }}
                                  />
                                </div>
                                <div style={{ width: "10%" }}>
                                  <Checkbox
                                    id={`checkbox_per_trans_limit`}
                                    name={`mp-plan-checkbox-3`}
                                    color={
                                      mode == 2 || canEdit(2, index) === false
                                        ? "default"
                                        : "secondary"
                                    }
                                    disabled={
                                      isCategoryRuleEnabled === false ||
                                      canEdit(2, index) === false
                                    }
                                    checked={row.perTransactionlimit.enabled}
                                    style={{ marginLeft: "-10px" }}
                                    onChange={(event) => {
                                      updateCategoryRule(
                                        row.serviceCategoryId,
                                        2,
                                        1,
                                        !row.perTransactionlimit.enabled,
                                      );
                                    }}
                                  />
                                </div>
                                <div style={{ width: "15%" }}>
                                  <ValidatedAmountField
                                    id="value_field"
                                    valueType={valueTypeCategoryRulePerTran}
                                    row={row}
                                    disabled={canEdit(2, index) === false}
                                    fieldKey="perTransactionlimit"
                                    mode={mode}
                                    isUnlimitedWallet={isUnlimitedWallet}
                                    walletLimit={walletLimit}
                                    columnNo={2}
                                    onUpdate={(cleaned) =>
                                      updateCategoryRule(
                                        row.serviceCategoryId,
                                        2,
                                        2,
                                        cleaned,
                                      )
                                    }
                                  />
                                </div>
                                <div style={{ width: "8%" }}>
                                  <Checkbox
                                    id={`checkbox_copay`}
                                    name={`mp-plan-checkbox-4`}
                                    color={
                                      mode == 2 || canEdit(3, index) === false
                                        ? "default"
                                        : "secondary"
                                    }
                                    disabled={
                                      isCategoryRuleEnabled === false ||
                                      canEdit(3, index) === false
                                    }
                                    checked={row.coPaylimit.enabled}
                                    style={{ marginLeft: "-10px" }}
                                    onChange={(event) => {
                                      updateCategoryRule(
                                        row.serviceCategoryId,
                                        3,
                                        1,
                                        !row.coPaylimit.enabled,
                                      );
                                    }}
                                  />
                                </div>
                                <div style={{ width: "15%" }}>
                                  <ValidatedAmountField
                                    id={`checkbox_fixed_value`}
                                    valueType={valueTypeCategoryRuleCoPay}
                                    row={row}
                                    disabled={canEdit(3, index) === false}
                                    fieldKey="coPaylimit"
                                    mode={mode}
                                    isUnlimitedWallet={isUnlimitedWallet}
                                    walletLimit={walletLimit}
                                    columnNo={3}
                                    onUpdate={(cleaned) =>
                                      updateCategoryRule(
                                        row.serviceCategoryId,
                                        3,
                                        2,
                                        cleaned,
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <GlobalSkeletonLoader />
                        )}
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
              {/* ~2 */}
              <div style={{ margin: "0px -12px 0px -12px" }}>
                <Accordion
                  expanded={serviceRuleExpanded}
                  onChange={() => setServiceRuleExpanded((prev) => !prev)}
                >
                  <AccordionSummary
                    expandIcon={<FontIcon>keyboard_arrow_down</FontIcon>}
                    style={{ border: "1px solid #CED4DA", borderRadius: "5px" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontWeight: "600",
                        fontSize: "16px",
                        gap: "6px",
                      }}
                    >
                      <Checkbox
                        id="isServiceRuleEnabled"
                        name="mp-plan-checkbox-isServiceRuleEnabled"
                        color={mode == 2 ? "default" : "secondary"}
                        disabled={mode == 2 || isWalletIncluded == false}
                        checked={isServiceRuleEnabled}
                        style={{ marginLeft: "-10px" }}
                        onChange={(e) => {
                          if (isWalletLimitNotFilled()) return;

                          if (isServiceRuleEnabled) {
                            deSelectServiceRuleIncluded();
                          } else {
                            setIsServiceRuleEnabled(!isServiceRuleEnabled);
                            addEmptyServiceRule();
                          }
                        }}
                      />

                      <span>Advanced health checkup service level rules</span>

                      <InfoButton onClick={() => handleInfoClick(4)} />
                    </div>
                  </AccordionSummary>

                  <AccordionDetails>
                    <div className="mp-plan-create-plan-container">
                      <div className="mp-plan-rule-table-container">
                        <div className="mp-plan-rule-table-heading-row-container">
                          <div style={{ width: "4%" }}></div>
                          <div style={{ width: "20%", textAlign: "left" }}>
                            Health checkup service ID
                          </div>
                          <div style={{ width: "3%" }}></div>
                          <div style={{ width: "20%" }}>
                            Transaction sublimit name
                          </div>
                          <div style={{ width: "3%" }}></div>
                          <div style={{ width: "13%" }}>
                            <div>Sublimit</div>
                            <div>applicable</div>
                          </div>
                          <div style={{ width: "15%" }}>
                            <div>Value</div>
                            <div className="radio-column-wrapper">
                              {isUnlimitedWallet === false && (
                                <div className="radio-option">
                                  <div>
                                    <OrangeRadio
                                      checked={
                                        valueTypeServiceRuleSublimit ===
                                        PERCENT_TYPE
                                      }
                                      disabled={
                                        isServiceRuleEnabled === false ||
                                        mode === 2
                                      }
                                      onChange={() => {
                                        changeToPercent(4);
                                      }}
                                      value={"1"}
                                      name="mp-plan-account-radio"
                                    />
                                  </div>
                                  <div className="radio-label">Percent (%)</div>
                                </div>
                              )}

                              <div className="radio-option">
                                <div>
                                  <OrangeRadio
                                    checked={
                                      valueTypeServiceRuleSublimit ===
                                      AMOUNT_TYPE
                                    }
                                    disabled={
                                      isServiceRuleEnabled === false ||
                                      mode === 2
                                    }
                                    onChange={() => {
                                      changeToAmount(4);
                                    }}
                                    value={"2"}
                                    name="mp-plan-account-radio"
                                  />
                                </div>
                                <div className="radio-label">Amount (Rs.)</div>
                              </div>
                            </div>
                          </div>
                          <div style={{ width: "15%" }}>
                            <div>Fixed</div>
                            <div>amount</div>
                          </div>

                          <div style={{ width: "3%" }}></div>
                        </div>
                        {serviceRuleData.map((row, index) => {
                          return (
                            <div className="mp-plan-rule-table-row-container">
                              <div style={{ width: "4%" }}>{`${
                                index + 1
                              }.`}</div>
                              <div
                                style={{
                                  width: "20%",
                                  textAlign: "left",
                                  display: "flex",
                                }}
                              >
                                <div
                                  style={{
                                    position: "relative",
                                    flex: 1,
                                    borderBottom: "1px solid #949494",
                                    paddingRight: "30px",
                                    lineHeight: "24px",
                                    minHeight: "24px",
                                    display: "flex",
                                    alignItems: "center",
                                    overflow: "hidden",
                                  }}
                                >
                                  <span
                                    style={{
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      display: "block",
                                      flex: 1,
                                    }}
                                    title={
                                      Array.isArray(
                                        serviceRuleData[index]?.serviceIds,
                                      )
                                        ? serviceRuleData[
                                            index
                                          ].serviceIds.join(", ")
                                        : ""
                                    }
                                  >
                                    {Array.isArray(
                                      serviceRuleData[index]?.serviceIds,
                                    ) &&
                                    serviceRuleData[index].serviceIds.length > 0
                                      ? serviceRuleData[index].serviceIds.join(
                                          ", ",
                                        )
                                      : "\u00A0"}
                                  </span>

                                  <Button
                                    icon
                                    style={{
                                      position: "absolute",
                                      bottom: "-1px",
                                      right: "0px",
                                      height: "32px",
                                      width: "32px",
                                      padding: "0px",
                                      minWidth: 0,
                                      lineHeight: "normal",
                                      background: "transparent",
                                    }}
                                    // disabled={mode == 2}
                                    onClick={(e) => {
                                      setDropdownAnchor(e.currentTarget);
                                      setOpenIndex(index);
                                    }}
                                  >
                                    <FontIcon style={{ fontSize: "20px" }}>
                                      arrow_drop_down
                                    </FontIcon>
                                  </Button>
                                </div>
                              </div>

                              <div style={{ width: "3%" }}></div>
                              <div style={{ width: "20%" }}>
                                <TextField2
                                  className="reactMDlike-underline"
                                  type="text"
                                  value={
                                    serviceRuleData[index]?.serviceCardName ||
                                    ""
                                  }
                                  style={{ width: "100%" }}
                                  disabled={mode === 2}
                                  placeholder="Type here"
                                  onChange={(e) => {
                                    updateServiceRule(
                                      index,
                                      6,
                                      null,
                                      e.target.value,
                                    );
                                  }}
                                />
                              </div>
                              <div style={{ width: "3%" }}></div>
                              <div style={{ width: "13%" }}>
                                <Checkbox
                                  id="checkbox_sublimit"
                                  name={`mp-plan-checkbox-1`}
                                  color={
                                    mode == 2 || canEdit(4, index) === false
                                      ? "default"
                                      : "secondary"
                                  }
                                  disabled={
                                    isServiceRuleEnabled === false ||
                                    canEdit(4, index) === false
                                  }
                                  checked={row.sublimit.enabled}
                                  style={{ marginLeft: "-10px" }}
                                  onChange={(event) => {
                                    updateServiceRule(
                                      index,
                                      1,
                                      1,
                                      !row.sublimit.enabled,
                                    );
                                  }}
                                />
                              </div>
                              <div style={{ width: "15%" }}>
                                <ValidatedAmountField
                                  id="sublimit"
                                  valueType={valueTypeServiceRuleSublimit}
                                  row={row}
                                  disabled={canEdit(4, index) === false}
                                  fieldKey="sublimit"
                                  mode={mode}
                                  isUnlimitedWallet={isUnlimitedWallet}
                                  walletLimit={walletLimit}
                                  columnNo={1}
                                  onUpdate={(cleaned) =>
                                    updateServiceRule(index, 1, 2, cleaned)
                                  }
                                />
                              </div>
                              <div style={{ width: "15%" }}>
                                <Checkbox
                                  id="checkbox_healthcheckup"
                                  name={`mp-plan-checkbox-2`}
                                  color={mode === 2 ? "default" : "secondary"}
                                  disabled={
                                    isServiceRuleEnabled === false ||
                                    mode === 2 ||
                                    isUnlimitedWallet
                                  }
                                  checked={row.isFixedAmount}
                                  style={{ marginLeft: "-10px" }}
                                  onChange={(event) => {
                                    updateServiceRule(
                                      index,
                                      4,
                                      0,
                                      !row.isFixedAmount,
                                    );
                                  }}
                                />
                              </div>

                              <div style={{ width: "3%" }}>
                                {/* <Button
                                  icon
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    deleteServiceRule(index);
                                  }}
                                >
                                  <FontIcon
                                    style={{
                                      lineHeight: "0",
                                      marginBottom: "20px",
                                    }}
                                  >
                                    {"close"}
                                  </FontIcon>
                                </Button> */}
                              </div>
                            </div>
                          );
                        })}
                        {isServiceRuleEnabled === false && (
                          <div className="mp-plan-rule-table-row-container">
                            <div style={{ width: "4%" }}></div>

                            {mode === 2 ? (
                              <div className={"grey-bold-add-new"}>
                                No rule added
                              </div>
                            ) : (
                              <div className={"grey-bold-add-new"}>
                                Select to add rules
                              </div>
                            )}
                          </div>
                        )}

                        {/* <div className="mp-plan-rule-table-row-container">
                          <div style={{ width: "4%" }}></div>

                          <div
                            className={
                              isServiceRuleEnabled
                                ? "orange-bold-add-new"
                                : "grey-bold-add-new"
                            }
                            onClick={() => {
                              if (isServiceRuleEnabled) {
                                addEmptyServiceRule();
                              }
                            }}
                          >
                            + Add more
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
              {/* ~3 */}
              <div style={{ margin: "0px -12px 0px -12px" }}>
                <Accordion
                  expanded={claimRuleExpanded}
                  onChange={() => setClaimRuleExpanded((prev) => !prev)}
                >
                  <AccordionSummary
                    expandIcon={<FontIcon>keyboard_arrow_down</FontIcon>}
                    style={{ border: "1px solid #CED4DA", borderRadius: "5px" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontWeight: "600",
                        fontSize: "16px",
                        gap: "6px",
                      }}
                    >
                      <Checkbox
                        id="isClaimRuleEnabled"
                        name="mp-plan-checkbox-isClaimRuleEnabled"
                        color={mode == 2 ? "default" : "secondary"}
                        disabled={
                          mode == 2 ||
                          isWalletIncluded == false ||
                          isReimbursementIncluded == false
                        }
                        checked={isClaimRuleEnabled}
                        style={{ marginLeft: "-10px" }}
                        onChange={(e) => {
                          if (isWalletLimitNotFilled()) return;

                          if (isClaimRuleEnabled) {
                            deSelectClaimRuleIncluded();
                          } else {
                            setIsClaimRuleEnabled(!isClaimRuleEnabled);
                          }
                        }}
                      />

                      <span>Advanced claims rules</span>

                      <InfoButton onClick={() => handleInfoClick(5)} />
                    </div>
                  </AccordionSummary>

                  <AccordionDetails>
                    <div className="mp-plan-create-plan-container">
                      <div className="mp-plan-rule-table-container">
                        <div className="mp-plan-rule-table-heading-row-container">
                          <div style={{ width: "4%" }}></div>
                          <div style={{ width: "14%", textAlign: "left" }}>
                            <div>Claim type</div>
                          </div>
                          <div style={{ width: "12%", textAlign: "left" }}>
                            Service type
                          </div>
                          <div style={{ width: "8%" }}>
                            <div>Sublimit</div>
                            <div>applicable</div>
                          </div>
                          <div style={{ width: "12%" }}>
                            <div>Value</div>
                            <div className="radio-column-wrapper">
                              {isUnlimitedWallet === false && (
                                <div className="radio-option">
                                  <div>
                                    <OrangeRadio
                                      checked={
                                        valueTypeClaimRuleSublimit ===
                                        PERCENT_TYPE
                                      }
                                      disabled={
                                        isClaimRuleEnabled === false ||
                                        mode === 2
                                      }
                                      onChange={() => {
                                        changeToPercent(5);
                                      }}
                                      value={"1"}
                                      name="mp-plan-account-radio"
                                    />
                                  </div>
                                  <div className="radio-label">Percent (%)</div>
                                </div>
                              )}

                              <div className="radio-option">
                                <div>
                                  <OrangeRadio
                                    checked={
                                      valueTypeClaimRuleSublimit === AMOUNT_TYPE
                                    }
                                    disabled={
                                      isClaimRuleEnabled === false || mode === 2
                                    }
                                    onChange={() => {
                                      changeToAmount(5);
                                    }}
                                    value={"2"}
                                    name="mp-plan-account-radio"
                                  />
                                </div>
                                <div className="radio-label">Amount (Rs.)</div>
                              </div>
                            </div>
                          </div>
                          <div style={{ width: "8%" }}>
                            <div>Fixed</div>
                            <div>amount</div>
                          </div>
                          <div style={{ width: "9%" }}>
                            <div>Per transaction</div>
                            <div>limit</div>
                          </div>
                          <div style={{ width: "12%" }}>
                            <div>Value</div>
                            <div className="radio-column-wrapper">
                              <div className="radio-option">
                                <div>
                                  <OrangeRadio
                                    checked={
                                      valueTypeClaimRulePerTran === PERCENT_TYPE
                                    }
                                    disabled={
                                      isClaimRuleEnabled === false || mode === 2
                                    }
                                    onChange={() => {
                                      changeToPercent(6);
                                    }}
                                    value={"1"}
                                    name="mp-plan-account-radio"
                                  />
                                </div>
                                <div className="radio-label">Percent (%)</div>
                              </div>

                              <div className="radio-option">
                                <div>
                                  <OrangeRadio
                                    checked={
                                      valueTypeClaimRulePerTran === AMOUNT_TYPE
                                    }
                                    disabled={
                                      isClaimRuleEnabled === false || mode === 2
                                    }
                                    onChange={() => {
                                      changeToAmount(6);
                                    }}
                                    value={"2"}
                                    name="mp-plan-account-radio"
                                  />
                                </div>
                                <div className="radio-label">Amount (Rs.)</div>
                              </div>
                            </div>
                          </div>
                          <div style={{ width: "8%" }}>
                            <div>Co-Pay by</div>
                            <div>employee</div>
                          </div>
                          <div style={{ width: "12%" }}>
                            <div>Value</div>
                            <div className="radio-column-wrapper">
                              <div className="radio-option">
                                <div>
                                  <OrangeRadio
                                    checked={
                                      valueTypeClaimRuleCoPay === PERCENT_TYPE
                                    }
                                    disabled={
                                      isClaimRuleEnabled === false || mode === 2
                                    }
                                    onChange={() => {
                                      changeToPercent(7);
                                    }}
                                    value={"1"}
                                    name="mp-plan-account-radio"
                                  />
                                </div>
                                <div className="radio-label">Percent (%)</div>
                              </div>

                              <div className="radio-option">
                                <div>
                                  <OrangeRadio
                                    checked={
                                      valueTypeClaimRuleCoPay === AMOUNT_TYPE
                                    }
                                    disabled={
                                      isClaimRuleEnabled === false || mode === 2
                                    }
                                    onChange={() => {
                                      changeToAmount(7);
                                    }}
                                    value={"2"}
                                    name="mp-plan-account-radio"
                                  />
                                </div>
                                <div className="radio-label">Amount (Rs.)</div>
                              </div>
                            </div>
                          </div>
                          <div style={{ width: "4%" }}></div>
                        </div>
                        {claimRuleData.map((row, index) => {
                          return (
                            <>
                              <div className="mp-plan-rule-table-row-container">
                                <div style={{ width: "4%" }}>{`${
                                  index + 1
                                }.`}</div>
                                <div
                                  style={{
                                    width: "14%",
                                    textAlign: "left",
                                    marginRight: "4px",
                                  }}
                                >
                                  <TextField2
                                    id="claim_type"
                                    className="reactMDlike-underline"
                                    type="text"
                                    value={
                                      claimRuleData[index]?.claimType || ""
                                    }
                                    placeholder="Type here"
                                    disabled={mode === 2}
                                    onChange={(e) => {
                                      let input = e.target.value;

                                      // input = input.replace(
                                      //   /[^a-zA-Z0-9:\- ]/g,
                                      //   ""
                                      // );

                                      if (input.length > 250) {
                                        input = input.slice(0, 250);
                                      }

                                      updateClaimRule(index, 6, null, input);
                                    }}
                                  />
                                </div>
                                <div
                                  style={{ width: "12%", textAlign: "left" }}
                                >
                                  <FormControl fullWidth size="small">
                                    <Select2
                                      id="select_service_type"
                                      displayEmpty
                                      disabled={mode == 2}
                                      value={
                                        claimRuleData[index]
                                          ?.serviceCategoryId || 0
                                      }
                                      onChange={(e) =>
                                        updateClaimRule(
                                          index,
                                          5,
                                          null,
                                          e.target.value,
                                        )
                                      }
                                      inputProps={{
                                        classes: {
                                          root: classes.noUnderlineInput,
                                        },
                                      }}
                                      className={classes.noUnderline}
                                      renderValue={(selected) => {
                                        if (!selected) return "Select";
                                        const selectedType =
                                          serviceCategories.find(
                                            (s) => s.id === selected,
                                          );
                                        return selectedType
                                          ? selectedType.name
                                          : "Select";
                                      }}
                                    >
                                      <MenuItem value={0}>
                                        <em>None</em>
                                      </MenuItem>
                                      {serviceCategories
                                        .filter((s) => {
                                          if (!s.isActive) return false;

                                          // 1. Collect all selected serviceCategoryIds from claimRuleData (except current index)
                                          const selectedIds = claimRuleData
                                            .map((r, i) =>
                                              i !== index
                                                ? r.serviceCategoryId
                                                : null,
                                            )
                                            .filter((id) => id);

                                          // 2. Collect all serviceCategoryIds where sublimit.enabled === false
                                          const disabledSublimitIds =
                                            categoryRuleData
                                              .filter(
                                                (r) =>
                                                  r.sublimit?.enabled === false,
                                              )
                                              .map((r) => r.serviceCategoryId);

                                          // 3. Exclude both selectedIds and disabledSublimitIds
                                          return (
                                            !selectedIds.includes(s.id) &&
                                            !disabledSublimitIds.includes(s.id)
                                          );
                                        })
                                        .map((type) => (
                                          <MenuItem
                                            key={type.id}
                                            value={type.id}
                                          >
                                            {type.name}
                                          </MenuItem>
                                        ))}
                                    </Select2>
                                  </FormControl>
                                </div>

                                <div style={{ width: "8%" }}>
                                  <Checkbox
                                    id={"submit_applicable"}
                                    name={`mp-plan-checkbox-1`}
                                    color={
                                      mode == 2 ||
                                      row.serviceCategoryId != 0 ||
                                      canEdit(5, index) === false
                                        ? "default"
                                        : "secondary"
                                    }
                                    disabled={
                                      isClaimRuleEnabled === false ||
                                      row.serviceCategoryId != 0 ||
                                      canEdit(5, index) === false
                                    }
                                    checked={row.sublimit.enabled}
                                    style={{ marginLeft: "-10px" }}
                                    onChange={(event) => {
                                      updateClaimRule(
                                        index,
                                        1,
                                        1,
                                        !row.sublimit.enabled,
                                      );
                                    }}
                                  />
                                </div>
                                <div id="value_field" style={{ width: "12%" }}>
                                  <ValidatedAmountField
                                    id="value"
                                    valueType={valueTypeClaimRuleSublimit}
                                    row={row}
                                    disabled={canEdit(5, index) === false}
                                    fieldKey="sublimit"
                                    mode={mode}
                                    isUnlimitedWallet={isUnlimitedWallet}
                                    walletLimit={walletLimit}
                                    columnNo={1}
                                    disabledExtraCheck={
                                      row.serviceCategoryId !== 0
                                    }
                                    onUpdate={(cleaned) =>
                                      updateClaimRule(index, 1, 2, cleaned)
                                    }
                                  />
                                </div>
                                <div style={{ width: "8%" }}>
                                  <Checkbox
                                    id={`fixed_amount`}
                                    name={`mp-plan-checkbox-2`}
                                    color={
                                      mode == 2 || row.serviceCategoryId != 0
                                        ? "default"
                                        : "secondary"
                                    }
                                    disabled={
                                      mode == 2 ||
                                      isClaimRuleEnabled === false ||
                                      row.serviceCategoryId != 0 ||
                                      isUnlimitedWallet
                                    }
                                    checked={row.isFixedAmount}
                                    style={{ marginLeft: "-10px" }}
                                    onChange={(event) => {
                                      updateClaimRule(
                                        index,
                                        4,
                                        0,
                                        !row.isFixedAmount,
                                      );
                                    }}
                                  />
                                </div>
                                <div style={{ width: "9%" }}>
                                  <Checkbox
                                    id={`transaction_per_limit`}
                                    name={`mp-plan-checkbox-1`}
                                    color={
                                      mode == 2 || canEdit(6, index) === false
                                        ? "default"
                                        : "secondary"
                                    }
                                    disabled={
                                      isClaimRuleEnabled === false ||
                                      canEdit(6, index) === false
                                    }
                                    checked={row.perTransactionlimit.enabled}
                                    style={{ marginLeft: "-10px" }}
                                    onChange={(event) => {
                                      updateClaimRule(
                                        index,
                                        2,
                                        1,
                                        !row.perTransactionlimit.enabled,
                                      );
                                    }}
                                  />
                                </div>
                                <div id="value_field" style={{ width: "12%" }}>
                                  <ValidatedAmountField
                                    id="value_field"
                                    valueType={valueTypeClaimRulePerTran}
                                    row={row}
                                    disabled={canEdit(6, index) === false}
                                    fieldKey="perTransactionlimit"
                                    mode={mode}
                                    isUnlimitedWallet={isUnlimitedWallet} // Always false for Reimbursement
                                    walletLimit={walletLimit}
                                    columnNo={2}
                                    disabledExtraCheck={
                                      row.perTransactionlimit.enabled === false
                                    }
                                    onUpdate={(cleaned) =>
                                      updateClaimRule(index, 2, 2, cleaned)
                                    }
                                  />
                                </div>
                                <div style={{ width: "8%" }}>
                                  <Checkbox
                                    id={`copay_by_employee`}
                                    name={`mp-plan-checkbox-1`}
                                    color={
                                      mode == 2 || canEdit(7, index) === false
                                        ? "default"
                                        : "secondary"
                                    }
                                    disabled={
                                      isClaimRuleEnabled === false ||
                                      canEdit(7, index) === false
                                    }
                                    checked={row.coPaylimit.enabled}
                                    style={{ marginLeft: "-10px" }}
                                    onChange={(event) => {
                                      updateClaimRule(
                                        index,
                                        3,
                                        1,
                                        !row.coPaylimit.enabled,
                                      );
                                    }}
                                  />
                                </div>
                                <div id="value_field" tyle={{ width: "12%" }}>
                                  <ValidatedAmountField
                                    id="value_field"
                                    valueType={valueTypeClaimRuleCoPay}
                                    row={row}
                                    disabled={canEdit(7, index) === false}
                                    fieldKey="coPaylimit"
                                    mode={mode}
                                    isUnlimitedWallet={isUnlimitedWallet}
                                    walletLimit={walletLimit}
                                    columnNo={3}
                                    disabledExtraCheck={
                                      row.coPaylimit.enabled === false
                                    }
                                    onUpdate={(cleaned) =>
                                      updateClaimRule(index, 3, 2, cleaned)
                                    }
                                  />
                                </div>
                                <div style={{ width: "4%" }}>
                                  {mode === 2 ? (
                                    <></>
                                  ) : (
                                    <Button
                                      icon
                                      disabled={mode === 2}
                                      style={{
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        deleteClaimRule(index);
                                      }}
                                    >
                                      <FontIcon
                                        id="close_button"
                                        style={{
                                          lineHeight: "0",
                                          marginBottom: "20px",
                                        }}
                                      >
                                        {"close"}
                                      </FontIcon>
                                    </Button>
                                  )}
                                </div>
                              </div>
                              <div className="mp-plan-rule-table-row-container-2">
                                <div style={{ width: "4%" }}></div>
                                <div
                                  style={{
                                    width: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    flexWrap: "wrap",
                                  }}
                                >
                                  <div
                                    className="mp-plan-rule-table-instruction-btn"
                                    onClick={async () => {
                                      // if (mode === 2) {
                                      //   return;
                                      // }
                                      const result = await confirm2({
                                        title: "Instructions",
                                        message: "",
                                        questionText: "NA", // or "NA" to hide question input
                                        answerText: row.instructions,
                                        width: "800px",
                                        viewOnly: mode === 2 ? true : false,
                                        buttons: {
                                          1: "close",
                                          2: {
                                            label: "Cancel",
                                            color: "zyGreen",
                                          },
                                          3: {
                                            label: "Save",
                                            color: "zyOrange",
                                          },
                                        },
                                      });

                                      if (result.buttonKey === "3") {
                                        updateClaimRule(
                                          index,
                                          7,
                                          null,
                                          result.answerText,
                                        );
                                      }
                                    }}
                                  >
                                    Instructions
                                    <FontIcon
                                      id="instructions"
                                      style={
                                        isMessageEffectivelyEmpty(
                                          row.instructions,
                                        )
                                          ? {
                                              color: "grey",
                                              lineHeight: "0",
                                              marginRight: "0px",
                                              fontSize: "18px",
                                              marginLeft: "4px",
                                            }
                                          : {
                                              color: "#25AF60",
                                              lineHeight: "0",
                                              marginRight: "0px",
                                              fontSize: "18px",
                                              marginLeft: "4px",
                                            }
                                      }
                                    >
                                      {"check_circle"}
                                    </FontIcon>
                                  </div>
                                  <div
                                    className="mp-plan-rule-table-instruction-btn"
                                    style={{
                                      opacity: row.serviceCategoryId ? 1 : 0.5,
                                      cursor: row.serviceCategoryId
                                        ? "pointer"
                                        : "not-allowed",
                                    }}
                                    title={
                                      row.serviceCategoryId
                                        ? ""
                                        : "Select a service type first"
                                    }
                                    onClick={() => {
                                      if (!row.serviceCategoryId) return;
                                      openCategoryDialog(index, "inclusions");
                                    }}
                                  >
                                    Inclusions
                                    <FontIcon
                                      id="inclusions"
                                      style={
                                        (row.inclusions?.length || 0) === 0
                                          ? {
                                              color: "grey",
                                              lineHeight: "0",
                                              marginRight: "0px",
                                              fontSize: "18px",
                                              marginLeft: "4px",
                                            }
                                          : {
                                              color: "#25AF60",
                                              lineHeight: "0",
                                              marginRight: "0px",
                                              fontSize: "18px",
                                              marginLeft: "4px",
                                            }
                                      }
                                    >
                                      {"check_circle"}
                                    </FontIcon>
                                  </div>
                                  <div
                                    className="mp-plan-rule-table-instruction-btn"
                                    style={{
                                      opacity: row.serviceCategoryId ? 1 : 0.5,
                                      cursor: row.serviceCategoryId
                                        ? "pointer"
                                        : "not-allowed",
                                    }}
                                    title={
                                      row.serviceCategoryId
                                        ? ""
                                        : "Select a service type first"
                                    }
                                    onClick={() => {
                                      if (!row.serviceCategoryId) return;
                                      openCategoryDialog(index, "exclusions");
                                    }}
                                  >
                                    Exclusions
                                    <FontIcon
                                      id="exclusions"
                                      style={
                                        (row.exclusions?.length || 0) === 0
                                          ? {
                                              color: "grey",
                                              lineHeight: "0",
                                              marginRight: "0px",
                                              fontSize: "18px",
                                              marginLeft: "4px",
                                            }
                                          : {
                                              color: "#25AF60",
                                              lineHeight: "0",
                                              marginRight: "0px",
                                              fontSize: "18px",
                                              marginLeft: "4px",
                                            }
                                      }
                                    >
                                      {"check_circle"}
                                    </FontIcon>
                                  </div>
                                </div>
                              </div>
                            </>
                          );
                        })}
                        <div className="mp-plan-rule-table-row-container">
                          <div style={{ width: "4%" }}></div>

                          {mode === 2 ? (
                            <></>
                          ) : (
                            <div
                              className={
                                isClaimRuleEnabled
                                  ? "orange-bold-add-new"
                                  : "grey-bold-add-new"
                              }
                              onClick={() => {
                                if (isClaimRuleEnabled) {
                                  addEmptyClaimRule();
                                }
                              }}
                            >
                              + Add new
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
              {/* ~4 */}
              <div style={{ margin: "0px -12px 0px -12px" }}>
                <Accordion
                  expanded={additionalClaimRuleExpanded}
                  onChange={() =>
                    setAdditionalClaimRuleExpanded((prev) => !prev)
                  }
                >
                  <AccordionSummary
                    expandIcon={<FontIcon>keyboard_arrow_down</FontIcon>}
                    style={{ border: "1px solid #CED4DA", borderRadius: "5px" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontWeight: "600",
                        fontSize: "16px",
                        gap: "6px",
                      }}
                    >
                      <Checkbox
                        id="isAdditionalClaimRuleEnabled"
                        name="mp-plan-checkbox-isAdditionalClaimRuleEnabled"
                        color={mode == 2 ? "default" : "secondary"}
                        disabled={
                          mode == 2 ||
                          isWalletIncluded == false ||
                          isReimbursementIncluded == false
                        }
                        checked={isAdditionalClaimRuleEnabled}
                        style={{ marginLeft: "-10px" }}
                        onChange={(e) => {
                          if (isWalletLimitNotFilled()) return;

                          if (isAdditionalClaimRuleEnabled) {
                            deSelectAdditionalClaimRules();
                          } else {
                            setIsAdditionalClaimRuleEnabled(
                              !isAdditionalClaimRuleEnabled,
                            );
                          }
                        }}
                      />
                      <span>Additional claim rules</span>
                      <InfoButton onClick={() => handleInfoClick(6)} />
                    </div>
                  </AccordionSummary>

                  <AccordionDetails>
                    <div className="mp-plan-create-plan-container">
                      <Row>
                        <Col xs={12} sm={11} md={11} lg={11}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              marginLeft: "10px",
                            }}
                          >
                            <div>
                              <Checkbox
                                id={`checkBoxInvoiceDateRule`}
                                name={`mp-plan-checkBoxInvoiceDateRule`}
                                color={mode == 2 ? "default" : "secondary"}
                                disabled={
                                  mode == 2 || !isAdditionalClaimRuleEnabled
                                }
                                checked={checkBoxInvoiceDateRule}
                                style={{ marginLeft: "-10px" }}
                                onChange={(event) => {
                                  if (checkBoxInvoiceDateRule) {
                                    setCheckBoxConsiderPlanDuration(false);
                                    setClaimFilingDuration("");
                                  }
                                  setCheckBoxInvoiceDateRule(
                                    !checkBoxInvoiceDateRule,
                                  );
                                }}
                              />
                            </div>
                            <div className="mp-plan-label-checkbox-semibold-label">
                              {`Apply invoice date rule`}
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col xs={12} sm={4} md={4} lg={4}>
                          <div
                            className="mp-plan-create-service-field-container"
                            style={{
                              marginLeft: "10px",
                              marginTop: "5px",
                            }}
                          >
                            <div className="mp-plan-label">{`Acceptable invoice date from current date (in days)`}</div>
                            <div>
                              <TextField
                                id="claim_filing_duration"
                                value={`${claimFilingDuration}`}
                                lineDirection="left"
                                placeholder="Type here"
                                style={{ width: "50%" }}
                                type="text"
                                disabled={mode == 2 || !checkBoxInvoiceDateRule}
                                onChange={(e) => {
                                  let value = e.replace(/\D/g, "");
                                  if (value.length > 3) return;
                                  if (/^\d+$/.test(e) || e === "") {
                                    const numValue =
                                      value === "" ? "" : Number(value);
                                    if (numValue === "" || numValue <= 365) {
                                      setClaimFilingDuration(numValue);
                                    }
                                  }
                                }}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col xs={12} sm={7} md={7} lg={7}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              marginLeft: "20px",
                              marginTop: "10px",
                            }}
                          >
                            <div>
                              <Checkbox
                                id={`checkBoxConsiderPlanDuration`}
                                name={`mp-plan-checkBoxConsiderPlanDuration`}
                                color={mode == 2 ? "default" : "secondary"}
                                disabled={mode == 2 || !checkBoxInvoiceDateRule}
                                checked={checkBoxConsiderPlanDuration}
                                style={{ marginLeft: "-10px" }}
                                onChange={(event) => {
                                  setCheckBoxConsiderPlanDuration(
                                    !checkBoxConsiderPlanDuration,
                                  );
                                }}
                              />
                            </div>
                            <div className="mp-plan-label-checkbox">
                              {`Prior to the plan start date`}
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col xs={12} sm={11} md={11} lg={11}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              marginLeft: "10px",
                            }}
                          >
                            <div>
                              <Checkbox
                                id={`checkBoxAddClaimRuleDeclaration`}
                                name={`mp-plan-checkBoxAddClaimRuleDeclaration`}
                                color={mode == 2 ? "default" : "secondary"}
                                disabled={
                                  mode == 2 || !isAdditionalClaimRuleEnabled
                                }
                                checked={checkBoxAddClaimRuleDeclaration}
                                style={{ marginLeft: "-10px" }}
                                onChange={(event) => {
                                  if (
                                    checkBoxAddClaimRuleDeclaration === true
                                  ) {
                                    setEditorStateDeclaration(
                                      EditorState.createEmpty(),
                                    );
                                    setDeclaration("");
                                  }
                                  setCheckBoxAddClaimRuleDeclaration(
                                    !checkBoxAddClaimRuleDeclaration,
                                  );
                                }}
                              />
                            </div>
                            <div className="mp-plan-label-checkbox-semibold-label">
                              {`Declaration`}
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12} sm={11} md={11} lg={11}>
                          <div className="mp-plan-field-container">
                            <div
                              style={{
                                borderBottom: "2px solid #E4E4E4",
                                marginTop: "10px",
                                marginLeft: "10px",
                              }}
                            >
                              <Editor
                                readOnly={
                                  mode == 2 ||
                                  checkBoxAddClaimRuleDeclaration == false
                                    ? true
                                    : false
                                }
                                editorState={editorStateDeclaration}
                                wrapperClassName=""
                                editorClassName=""
                                onEditorStateChange={
                                  _onEditorStateChangeDeclaration
                                }
                                stripPastedStyles={true}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col xs={12} sm={11} md={11} lg={11}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              marginLeft: "10px",
                            }}
                          >
                            <div>
                              <Checkbox
                                id={`checkBoxDocumentType`}
                                name={`mp-plan-checkBoxDocumentType`}
                                color={mode == 2 ? "default" : "secondary"}
                                disabled={
                                  mode == 2 || !isAdditionalClaimRuleEnabled
                                }
                                checked={checkBoxDocumentType}
                                style={{ marginLeft: "-10px" }}
                                onChange={(event) => {
                                  if (checkBoxDocumentType) {
                                    resetDocumentTypeData();
                                  }
                                  setCheckBoxDocumentType(
                                    !checkBoxDocumentType,
                                  );
                                }}
                              />
                            </div>
                            <div className="mp-plan-label-checkbox-semibold-label">
                              {`Document type`}
                            </div>
                          </div>
                        </Col>
                      </Row>

                      {documentTypeData.map((row, index) => {
                        // Find all keys already selected (except this row, so user can re-select it)
                        const selectedKeys = documentTypeData
                          .map((d, i) => (i !== index ? d.typeId : null))
                          .filter((k) => k !== null);

                        // Filter out already selected ones
                        const availableOptions = documentTypeOptions.filter(
                          (opt) => !selectedKeys.includes(opt.value),
                        );

                        return (
                          <div key={index} style={{ marginTop: "5px" }}>
                            <Row>
                              <Col xs={12} sm={2} md={2} lg={2}>
                                <div
                                  className="mp-plan-create-service-field-container"
                                  style={{ marginLeft: "10px" }}
                                >
                                  <div className="mp-plan-label">{`Label`}</div>
                                  <div>
                                    <SelectField
                                      id="label"
                                      placeholder="Select"
                                      className="mp-plan-select-field"
                                      menuItems={availableOptions}
                                      disabled={
                                        mode == 2 || !checkBoxDocumentType
                                      }
                                      value={row.typeId}
                                      onChange={(val) => {
                                        setDocumentTypeData((prev) =>
                                          prev.map((item, i) =>
                                            i === index
                                              ? { ...item, typeId: val }
                                              : item,
                                          ),
                                        );
                                      }}
                                    />
                                  </div>
                                </div>
                              </Col>
                              <Col xs={12} sm={9} md={9} lg={9}>
                                <div
                                  className="mp-plan-create-service-field-container"
                                  style={{ marginLeft: "45px" }}
                                >
                                  <div className="mp-plan-label">{`Text`}</div>
                                  <div>
                                    <TextField
                                      id="text"
                                      value={row.text}
                                      lineDirection="left"
                                      placeholder="Type here"
                                      disabled={
                                        mode == 2 || !checkBoxDocumentType
                                      }
                                      onChange={(e) => {
                                        const value = e.slice(0, 250);
                                        setDocumentTypeData((prev) =>
                                          prev.map((item, i) =>
                                            i === index
                                              ? { ...item, text: value }
                                              : item,
                                          ),
                                        );
                                      }}
                                    />
                                  </div>
                                </div>
                              </Col>
                              <Col xs={12} sm={1} md={1} lg={1}>
                                {index > 0 && (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      marginTop: "5px",
                                    }}
                                  >
                                    <Button
                                      id="close"
                                      icon
                                      disabled={mode == 2}
                                      style={{
                                        cursor:
                                          mode == 2 ? "not-allowed" : "pointer",
                                      }}
                                      onClick={() => {
                                        setDocumentTypeData((prev) =>
                                          prev.filter((_, i) => i !== index),
                                        );
                                      }}
                                    >
                                      <FontIcon
                                        style={{
                                          lineHeight: "0",
                                          marginBottom: "20px",
                                        }}
                                      >
                                        close
                                      </FontIcon>
                                    </Button>
                                  </div>
                                )}
                              </Col>
                            </Row>
                          </div>
                        );
                      })}
                      <div
                        className={
                          mode != 2 &&
                          documentTypeOptions.length >
                            documentTypeData.length &&
                          checkBoxDocumentType
                            ? "orange-bold-add-new"
                            : "grey-bold-add-new"
                        }
                        style={{
                          width: "fit-content",
                          marginLeft: "26px",
                          marginTop: "10px",
                        }}
                        onClick={() => {
                          if (
                            mode != 2 &&
                            documentTypeOptions.length >
                              documentTypeData.length &&
                            checkBoxDocumentType
                          ) {
                            addNewDocumentTypeData();
                          }
                        }}
                      >
                        + Add new
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
              {/* ~5 */}
              <div style={{ margin: "0px -12px 0px -12px" }}>
                <Accordion
                  expanded={additionalPlanRuleExpanded}
                  onChange={() =>
                    setAdditionalPlanRuleExpanded((prev) => !prev)
                  }
                >
                  <AccordionSummary
                    expandIcon={<FontIcon>keyboard_arrow_down</FontIcon>}
                    style={{ border: "1px solid #CED4DA", borderRadius: "5px" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontWeight: "600",
                        fontSize: "16px",
                        gap: "6px",
                      }}
                    >
                      <Checkbox
                        id="sAdditionalPlanRuleEnabled"
                        name="mp-plan-checkbox-isAdditionalPlanRuleEnabled"
                        color={mode == 2 ? "default" : "secondary"}
                        disabled={mode == 2}
                        checked={isAdditionalPlanRuleEnabled}
                        style={{ marginLeft: "-10px" }}
                        onChange={(e) => {
                          if (isAdditionalPlanRuleEnabled) {
                            deSelectAdditionalPlanRules();
                          } else {
                            setIsAdditionalPlanRuleEnabled(
                              !isAdditionalPlanRuleEnabled,
                            );
                          }
                        }}
                      />

                      <span>Additional plan rules</span>

                      <InfoButton onClick={() => handleInfoClick(7)} />
                    </div>
                  </AccordionSummary>

                  <AccordionDetails>
                    <div className="mp-plan-create-plan-container">
                      <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                          <div className="mp-plan-create-service-field-container">
                            {additionalPlanRulesObjArr.map((e, index) => (
                              <div
                                key={index}
                                style={{
                                  marginBottom: "16px",
                                  border: "1px solid #C3C3C3",
                                  padding: "8px 8px 8px 15px",
                                  borderRadius: "5px",
                                }}
                              >
                                {renderAdditionalPlanRulesForSerCatId(
                                  e.serviceCatId,
                                  index,
                                )}
                              </div>
                            ))}

                            <div
                              className={
                                mode != 2
                                  ? "orange-bold-add-new"
                                  : "grey-bold-add-new"
                              }
                              style={{
                                width: "fit-content",
                                marginLeft: "26px",
                                display: "none",
                              }}
                              onClick={() => {
                                if (mode != 2) {
                                  addNewServiceCategoryRow();
                                }
                              }}
                            >
                              + Add new
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
              {/* ~6 */}
              <div style={{ margin: "0px -12px 0px -12px" }}>
                <Accordion
                  expanded={eyeCareExpanded}
                  onChange={() => setEyeCareExpanded((prev) => !prev)}
                >
                  <AccordionSummary
                    expandIcon={<FontIcon>keyboard_arrow_down</FontIcon>}
                    style={{ border: "1px solid #CED4DA", borderRadius: "5px" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontWeight: "600",
                        fontSize: "16px",
                        gap: "6px",
                      }}
                    >
                      <Checkbox
                        id="sEyeCareIncluded"
                        name="mp-plan-checkbox-isEyeCareIncluded"
                        color={mode == 2 ? "default" : "secondary"}
                        disabled={mode == 2}
                        checked={isEyeCareIncluded}
                        style={{ marginLeft: "-10px" }}
                        onChange={(e) => {
                          setIsEyeCareIncluded(!isEyeCareIncluded);
                        }}
                      />

                      <span>Eye care</span>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "20px",
                          marginBottom: "16px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          <PurpleRadio
                            checked={eyeCareModule === 1}
                            disabled={mode === 2 || !isEyeCareIncluded}
                            onChange={() => handleEyeCareModuleChange(1)}
                            value={1}
                            name="eye-care-module-radio"
                          />
                          <span className="mp-plan-label">Module 1</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          <PurpleRadio
                            checked={eyeCareModule === 2}
                            disabled={mode === 2 || !isEyeCareIncluded}
                            onChange={() => handleEyeCareModuleChange(2)}
                            value={2}
                            name="eye-care-module-radio"
                          />
                          <span className="mp-plan-label">Module 2</span>
                        </div>
                      </div>
                      {eyeCareModule === 1 && (
                        <div>
                          <div
                            className="mp-plan-section-heading"
                            style={{ marginBottom: "8px" }}
                          >
                            {`Benefits covered`}
                          </div>
                          <div
                            className="mp-plan-label"
                            style={{ marginBottom: "8px" }}
                          >
                            {`Free basic eye check-up consultation`}
                          </div>
                          <ul
                            style={{
                              margin: "0 0 16px 20px",
                              padding: 0,
                              lineHeight: "24px",
                            }}
                          >
                            <li className="mp-plan-label">
                              At centre (Vision Express)
                            </li>
                            <li className="mp-plan-label">
                              At home and centre (Lenskart)
                            </li>
                          </ul>
                          <div
                            className="mp-plan-section-heading"
                            style={{ marginBottom: "8px" }}
                          >
                            {`Avail your benefits`}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "12px",
                            }}
                          >
                            {fetchedVisionProviders
                              ?.filter((p) => p.moduleType === 1)
                              .map((provider) => (
                                <div
                                  key={provider.id}
                                  className="mp-plan-vision-provider-card"
                                >
                                  <Checkbox
                                    id={`vision-provider-${provider.id}`}
                                    checked={selectedVisionProviders.includes(
                                      provider.id,
                                    )}
                                    color={mode == 2 ? "default" : "secondary"}
                                    disabled={mode == 2 || !isEyeCareIncluded}
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                    }}
                                    onChange={() => {
                                      setSelectedVisionProviders((prev) =>
                                        prev.includes(provider.id)
                                          ? prev.filter(
                                              (id) => id !== provider.id,
                                            )
                                          : [...prev, provider.id],
                                      );
                                    }}
                                  />
                                  <img
                                    src={provider.image}
                                    alt={provider.name}
                                    style={{
                                      maxWidth: "80%",
                                      maxHeight: "120px",
                                      objectFit: "contain",
                                    }}
                                  />
                                </div>
                              ))}
                          </div>
                        </div>
                      )}
                      {eyeCareModule === 2 && (
                        <div>
                          <div
                            className="mp-plan-section-heading"
                            style={{ marginBottom: "8px" }}
                          >
                            {`Benefits covered (visible to user)`}
                            <label className="account-module-label-red">
                              {" "}
                              *
                            </label>
                          </div>
                          <div
                            style={{
                              borderBottom: "2px solid #E4E4E4",
                              marginBottom: "16px",
                            }}
                          >
                            <Editor
                              readOnly={mode == 2 || !isEyeCareIncluded}
                              editorState={editorStateVisionBenefits}
                              wrapperClassName=""
                              editorClassName=""
                              onEditorStateChange={
                                _onEditorStateChangeVisionBenefits
                              }
                              stripPastedStyles={true}
                            />
                          </div>
                          <div
                            className="mp-plan-section-heading"
                            style={{ marginBottom: "8px" }}
                          >
                            {`Select cashless providers`}
                            <label className="account-module-label-red">
                              {" "}
                              *
                            </label>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "12px",
                            }}
                          >
                            {fetchedVisionProviders
                              ?.filter((p) => p.moduleType === 2)
                              .map((provider) => (
                                <div
                                  key={provider.id}
                                  className="mp-plan-vision-provider-card"
                                >
                                  <Checkbox
                                    id={`vision-provider-${provider.id}`}
                                    checked={selectedVisionProviders.includes(
                                      provider.id,
                                    )}
                                    color={mode == 2 ? "default" : "secondary"}
                                    disabled={mode == 2 || !isEyeCareIncluded}
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                    }}
                                    onChange={() => {
                                      setSelectedVisionProviders((prev) =>
                                        prev.includes(provider.id)
                                          ? prev.filter(
                                              (id) => id !== provider.id,
                                            )
                                          : [...prev, provider.id],
                                      );
                                    }}
                                  />
                                  <img
                                    src={provider.image}
                                    alt={provider.name}
                                    style={{
                                      maxWidth: "80%",
                                      maxHeight: "120px",
                                      objectFit: "contain",
                                    }}
                                  />
                                </div>
                              ))}
                          </div>
                          <div style={{ marginTop: "16px", width: "33.33%" }}>
                            <div className="mp-plan-label">{`Service category`}</div>
                            <div>
                              <TextField
                                value="Avail eye care"
                                lineDirection="left"
                                disabled
                              />
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              gap: "24px",
                              marginTop: "16px",
                              width: "66.66%",
                            }}
                          >
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div
                                className="mp-plan-label"
                                style={{ marginBottom: "8px" }}
                              >{`Eligible category`}</div>
                              <MultiSelectPicker
                                title="Select eligible benefits"
                                disabled={mode === 2 || !isEyeCareIncluded}
                                options={fetchedVisionBenefits
                                  .filter((b) => b.isActive)
                                  .map((b) => ({ label: b.name, value: b.id }))}
                                value={selectedEligibleBenefits}
                                onChange={setSelectedEligibleBenefits}
                                placeholder="Select..."
                                getOptionDisabled={(option) =>
                                  selectedIneligibleBenefits.some(
                                    (s) => s.value === option.value,
                                  )
                                }
                              />
                            </div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div
                                className="mp-plan-label"
                                style={{ marginBottom: "8px" }}
                              >{`Ineligible category`}</div>
                              <MultiSelectPicker
                                title="Select ineligible benefits"
                                disabled={mode === 2 || !isEyeCareIncluded}
                                options={fetchedVisionBenefits
                                  .filter((b) => b.isActive)
                                  .map((b) => ({ label: b.name, value: b.id }))}
                                value={selectedIneligibleBenefits}
                                onChange={setSelectedIneligibleBenefits}
                                placeholder="Select..."
                                getOptionDisabled={(option) =>
                                  selectedEligibleBenefits.some(
                                    (s) => s.value === option.value,
                                  )
                                }
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
              <div style={{ margin: "0px -12px 0px -12px" }}>
                <Accordion
                  expanded={welcomeMsgExpanded}
                  onChange={() => setWelcomeMsgExpanded((prev) => !prev)}
                >
                  <AccordionSummary
                    expandIcon={<FontIcon>keyboard_arrow_down</FontIcon>}
                    style={{ border: "1px solid #CED4DA", borderRadius: "5px" }}
                  >
                    <div
                      style={{
                        fontWeight: "600",
                        fontSize: "16px",
                      }}
                    >
                      <Checkbox
                        id={`isWelcomeMsgIncluded`}
                        name={`mp-plan-checkbox-isWelcomeMsgIncluded`}
                        color={mode == 2 ? "default" : "secondary"}
                        disabled={mode == 2}
                        checked={isWelcomeMsgIncluded}
                        style={{ marginLeft: "-10px" }}
                        onChange={(e) => {
                          setIsWelcomeMsgIncluded(!isWelcomeMsgIncluded);
                        }}
                      />
                      Welcome message on chat
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div
                      id="welcome_message"
                      className="mp-plan-create-plan-container"
                    >
                      <Row>
                        <Col xs={12} sm={11} md={11} lg={11}>
                          <div className="mp-plan-field-container">
                            <div
                              id="welcome_message"
                              style={{
                                borderBottom: "2px solid #E4E4E4",
                                marginTop: "10px",
                              }}
                            >
                              <Editor
                                id="welcome_message"
                                readOnly={
                                  mode == 2 || isWelcomeMsgIncluded == false
                                    ? true
                                    : false
                                }
                                editorState={editorState2}
                                wrapperClassName=""
                                editorClassName=""
                                onEditorStateChange={_onEditorStateChange2}
                                stripPastedStyles={true}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12} sm={3} md={3} lg={3}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <div>
                              <Checkbox
                                id={`isCTAButtonEnabled`}
                                name={`mp-plan-checkbox-isCTAButtonEnabled`}
                                color={mode == 2 ? "default" : "secondary"}
                                disabled={
                                  mode == 2 || isWelcomeMsgIncluded == false
                                }
                                checked={isCTAButtonEnabled}
                                style={{ marginLeft: "-10px" }}
                                onChange={(event) => {
                                  if (isCTAButtonEnabled) {
                                    setCtaButton("");
                                    setCtaText("");
                                    setCustomCtaText("");
                                    setCtaLink("");
                                  }
                                  setIsCTAButtonEnabled(!isCTAButtonEnabled);
                                }}
                              />
                            </div>
                            <div className="mp-plan-label-checkbox">
                              CTA button
                            </div>
                          </div>

                          <div
                            className="mp-plan-create-service-field-container"
                            style={{ marginTop: "-16px" }}
                          >
                            <div>
                              <SelectField
                                id="select_cta_text"
                                placeholder="Select CTA text"
                                className="mp-plan-select-field"
                                menuItems={CTA_BUTTON_OPTIONS}
                                disabled={
                                  mode == 2 ||
                                  isWelcomeMsgIncluded == false ||
                                  isCTAButtonEnabled == false
                                }
                                value={ctaButton}
                                onChange={(e) => {
                                  setCtaButton(e);
                                  if (e != "CUSTOM_CTA") {
                                    setCustomCtaText("");
                                    setCtaLink("");
                                  }
                                }}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col xs={12} sm={1} md={1} lg={1}>
                          <div style={{ height: "20px" }}></div>
                        </Col>
                        <Col xs={12} sm={3} md={3} lg={3}>
                          <div
                            className="mp-plan-create-service-field-container"
                            style={{ marginTop: "10px" }}
                          >
                            <div className="mp-plan-label">
                              {`Custom CTA text`}
                            </div>
                            <div>
                              <TextField
                                id="custom_chat_text"
                                value={customCtaText}
                                lineDirection="left"
                                disabled={
                                  mode == 2 ||
                                  ctaButton != "CUSTOM_CTA" ||
                                  isWelcomeMsgIncluded == false
                                }
                                placeholder={
                                  ctaButton != "CUSTOM_CTA" ? "" : "Type here"
                                }
                                onChange={(e) => {
                                  setCustomCtaText(e);
                                }}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col xs={12} sm={1} md={1} lg={1}>
                          <div style={{ height: "20px" }}></div>
                        </Col>
                        <Col xs={12} sm={3} md={3} lg={3}>
                          <div
                            className="mp-plan-create-service-field-container"
                            style={{ marginTop: "10px" }}
                          >
                            <div className="mp-plan-label">
                              {`Custom CTA link`}
                            </div>
                            <div>
                              <TextField
                                id="custom_chat_link"
                                value={`${ctaLink}`}
                                lineDirection="left"
                                disabled={
                                  mode == 2 ||
                                  ctaButton != "CUSTOM_CTA" ||
                                  isWelcomeMsgIncluded == false
                                }
                                placeholder={
                                  ctaButton != "CUSTOM_CTA" ? "" : "Type here"
                                }
                                onChange={(e) => {
                                  setCtaLink(e);
                                }}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
      {props?.data?.mode == "assign-service" && (
        <>
          <div style={{ height: "40px" }}></div>
          <div className="assigned-plans-table-outer-div">
            <h2 className="">Services included in the plan</h2>
            <div className="service-provider-header-inner-div">
              <Button
                // disabled={!(serviceData?.serviceTypeId == 2)}
                raised
                style={{
                  textTransform: "none",
                }}
                secondary
                onClick={() => {
                  if (fetchedPlan?.id) {
                    props.setView(4, {
                      mode: "assign",
                      accountId: props?.data?.accountId,
                      planId: fetchedPlan?.id,
                    });
                  } else {
                    EventService.emit("showError", {
                      message: `Unable to get plan id`,
                    });
                  }
                }}
              >
                Add
              </Button>
              <Button
                raised
                secondary
                style={{
                  textTransform: "none",
                }}
                onClick={openImportServicesSelector}
              >
                Import from existing plan
              </Button>
              <Button
                raised
                style={{
                  textTransform: "none",
                }}
                secondary
                onClick={() => {
                  if (fetchedPlan?.id) {
                    props.setView(7, {
                      mode: "create",
                      accountId: props?.data?.accountId,
                      planId: fetchedPlan?.id,
                    });
                  } else {
                    EventService.emit("showError", {
                      message: `Unable to get plan id`,
                    });
                  }
                }}
              >
                Add advanced sponsorship rule
              </Button>
            </div>
          </div>
        </>
      )}{" "}
      {props?.data?.mode == "renew" && (
        <>
          <div style={{ height: "40px" }}></div>
          <div className="assigned-plans-table-outer-div">
            <h2 className="">Services included in the plan</h2>
          </div>
        </>
      )}
      {(props?.data?.mode == "assign-service" ||
        props?.data?.mode == "renew") && (
        <div style={{ marginTop: "15px" }}>{expandableTile}</div>
      )}
      {Boolean(
        (props?.data?.mode == "assign-service" ||
          props?.data?.mode == "renew") &&
        (advSpRulesOnPlanResponseInitial?.rules ?? []).length > 0,
      ) && (
        <>
          <div style={{ height: "40px" }}></div>
          <h2>List of advanced sponsorship rules</h2>
          <div style={{ height: "24px" }}></div>
          <SponsorshipRulesTable
            {...{
              data: {
                accountId: props?.data?.accountId,
                planData: fetchedPlan,
                advSpRulesOnPlanResponse: advSpRulesOnPlanResponse,
              },
              getAdvSpRulesOnPlanByFilter: getAdvSpRulesOnPlanByFilter,
              setView: props?.setView,
              // setFilters: (newFilters) => { set}
            }}
          />
        </>
      )}
      {openRenewDialog && (
        <DialogContainer
          id="mp-calendar-changes-prop-confirm-dialog-3"
          visible={openRenewDialog}
          focusOnMount={false}
          onHide={() => {
            setOpenRenewDialog(false);
            setPlanToUpdate(null);
            setLoading(false);
          }}
          width="500px"
          autosizeContent
          height="auto"
          style={{ textAlign: "left" }}
          dialogStyle={{ borderRadius: "10px", position: "relative" }}
        >
          <div className="mp-confirm-diaglog-3">
            <div>{`Do you want to migrate the old plan users`}</div>
            <div>{`on renewing this plan?`}</div>
            <br />
            <div className="mp-confirm-diaglog-btn">
              <div className="mp-buttons-right-alignment">
                <Button
                  raised
                  disabled={loading}
                  className={"mp-button-save-enabled"}
                  onClick={() => {
                    if (planToUpdate != null) {
                      renewPlan({
                        ...planToUpdate,
                        migratePrevPlanUsers: true,
                      });
                    }
                  }}
                >
                  {"Yes"}
                </Button>

                <Button
                  raised
                  disabled={loading}
                  className="mp-button-cancel"
                  onClick={() => {
                    if (planToUpdate != null) {
                      renewPlan({
                        ...planToUpdate,
                        migratePrevPlanUsers: false,
                      });
                    }
                  }}
                >
                  {"No"}
                </Button>
              </div>
            </div>
          </div>
        </DialogContainer>
      )}
      {openInactiveDialog && (
        <DialogContainer
          id="mp-calendar-changes-prop-confirm-dialog-4"
          visible={openInactiveDialog}
          focusOnMount={false}
          onHide={() => {
            setOpenInactiveDialog(false);
            setPlanToUpdate(null);
            setLoading(false);
          }}
          width="500px"
          autosizeContent
          height="auto"
          style={{ textAlign: "left" }}
          dialogStyle={{ borderRadius: "10px", position: "relative" }}
        >
          <div className="mp-confirm-diaglog-3">
            <div>{`Are you sure you want to mark the plan`}</div>
            <div className="mp-confirm-diaglog-text">
              <div style={{ fontWeight: "bold" }}>{`${planName}`}&nbsp;</div>
              <div>{"as"}</div>
              <div style={{ fontWeight: "bold" }}>&nbsp;{`inactive`}&nbsp;</div>
              <div>{"?"}</div>
            </div>
            <br />
            <div className="mp-confirm-diaglog-btn">
              <div className="mp-buttons-right-alignment">
                <Button
                  raised
                  disabled={loading}
                  className={"mp-button-save-enabled"}
                  onClick={() => {
                    if (planToUpdate != null) {
                      updatePlan(planToUpdate);
                    }
                  }}
                >
                  {"Yes"}
                </Button>

                <Button
                  raised
                  disabled={loading}
                  className="mp-button-cancel"
                  onClick={() => {
                    if (planToUpdate != null) {
                      setPlanToUpdate(null);
                      setOpenInactiveDialog(false);
                      setLoading(false);
                    }
                  }}
                >
                  {"No"}
                </Button>
              </div>
            </div>
          </div>
        </DialogContainer>
      )}
      {openEndDateChangeDialog && (
        <DialogContainer
          id="mp-calendar-changes-prop-confirm-dialog-5"
          visible={openEndDateChangeDialog}
          focusOnMount={false}
          onHide={() => {
            if (loading) return;
            setOpenEndDateChangeDialog(false);
            setPlanToUpdate(null);
            setLoading(false);
            setEndDateUpdateError(null);
          }}
          width="900px"
          autosizeContent
          height="auto"
          style={{ textAlign: "left" }}
          dialogStyle={{ borderRadius: "10px", position: "relative" }}
        >
          <div className="mp-confirm-diaglog-3 mp-end-date-dialog">
            <div className="mp-end-date-dialog-header">
              <div className="mp-end-date-dialog-title">
                {isAccountEligibleForEndDatePropagation()
                  ? `Do you want to extend updated `
                  : `Confirm the updated `}
                <span style={{ fontWeight: "bold" }}>{`‘plan end date’`}</span>
                {isAccountEligibleForEndDatePropagation()
                  ? ` to the user level`
                  : ``}
              </div>
              <Button
                plain
                disabled={loading}
                className="mp-end-date-dialog-close"
                onClick={() => {
                  // Cancel the entire update so the user can keep editing.
                  if (loading) return;
                  setOpenEndDateChangeDialog(false);
                  setPlanToUpdate(null);
                  setLoading(false);
                  setEndDateUpdateError(null);
                }}
              >
                <img src={crossIcon} alt="close" height="25px" />
              </Button>
            </div>
            <div className="mp-end-date-dialog-details">
              <div className="mp-end-date-dialog-detail">
                <div className="mp-end-date-dialog-detail-label">
                  {"Account code"}
                </div>
                <div className="mp-end-date-dialog-detail-value">
                  {accountDetails?.accountCode || "-"}
                </div>
              </div>
              <div className="mp-end-date-dialog-detail">
                <div className="mp-end-date-dialog-detail-label">
                  {"Account name"}
                </div>
                <div className="mp-end-date-dialog-detail-value">
                  {accountDetails?.accountName || "-"}
                </div>
              </div>
              <div className="mp-end-date-dialog-detail">
                <div className="mp-end-date-dialog-detail-label">
                  {"Plan ID"}
                </div>
                <div className="mp-end-date-dialog-detail-value">
                  {fetchedPlan?.id || "-"}
                </div>
              </div>
              <div className="mp-end-date-dialog-detail">
                <div className="mp-end-date-dialog-detail-label">
                  {"Plan name"}
                </div>
                <div className="mp-end-date-dialog-detail-value">
                  {planName || fetchedPlan?.basicDetails?.name || "-"}
                </div>
              </div>
              <div className="mp-end-date-dialog-detail">
                <div className="mp-end-date-dialog-detail-label">
                  {"Plan start date"}
                </div>
                <div className="mp-end-date-dialog-detail-value">
                  {planDateFrom
                    ? moment.utc(planDateFrom).format("DD MMM YYYY")
                    : "-"}
                </div>
              </div>
              <div className="mp-end-date-dialog-detail">
                <div className="mp-end-date-dialog-detail-label">
                  {"Previous plan end date"}
                </div>
                <div className="mp-end-date-dialog-detail-value">
                  {fetchedPlan?.basicDetails?.endDate
                    ? moment
                        .utc(fetchedPlan.basicDetails.endDate)
                        .format("DD MMM YYYY")
                    : "-"}
                </div>
              </div>
              <div className="mp-end-date-dialog-detail">
                <div className="mp-end-date-dialog-detail-label">
                  {"Updated plan end date"}
                </div>
                <div className="mp-end-date-dialog-detail-value">
                  {planDateTo
                    ? moment.utc(planDateTo).format("DD MMM YYYY")
                    : "-"}
                </div>
              </div>
            </div>
            {endDateUpdateError && (
              <div
                style={{
                  color: "#d32f2f",
                  marginTop: "10px",
                  maxHeight: "150px",
                  overflowY: "auto",
                  wordBreak: "break-word",
                  paddingRight: "8px",
                }}
              >
                {endDateUpdateError}
              </div>
            )}
            {loading && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  margin: "15px 0",
                }}
              >
                <CircularProgress
                  id="end-date-update-progress"
                  style={{ margin: 0 }}
                />
              </div>
            )}
            {!isAccountEligibleForEndDatePropagation() && (
              // ZY-10084: the backend refuses propagation for these accounts, so do not offer it.
              // The end date change itself still goes through.
              <div
                style={{
                  color: "#8a6d3b",
                  background: "#fcf8e3",
                  border: "1px solid #faebcc",
                  borderRadius: "4px",
                  marginTop: "10px",
                  marginBottom: "20px",
                  padding: "10px",
                  wordBreak: "break-word",
                }}
              >
                {`User level propagation is only available for corporate accounts. Account code ${
                  accountDetails?.accountCode || "-"
                } is not eligible, so the plan end date will be updated, but will not be propagated to patients on this plan.`}
              </div>
            )}
            {endDateUpdateError ? null : (
              <div className="mp-confirm-diaglog-btn">
                <div className="mp-buttons-right-alignment">
                  {isAccountEligibleForEndDatePropagation() && (
                    <Button
                      raised
                      disabled={loading}
                      className={"mp-button-save-enabled"}
                      onClick={() => {
                        proceedAfterEndDateConfirm(true);
                      }}
                    >
                      {"Yes"}
                    </Button>
                  )}

                  <Button
                    raised
                    disabled={loading}
                    className="mp-button-cancel"
                    onClick={() => {
                      proceedAfterEndDateConfirm(false);
                    }}
                  >
                    {isAccountEligibleForEndDatePropagation()
                      ? "No"
                      : "Update plan only"}
                  </Button>
                </div>
              </div>
            )}
          </div>
        </DialogContainer>
      )}
      {
        <Popper
          open={openIndex !== null}
          anchorEl={dropdownAnchor}
          placement="bottom"
          modifiers={[
            {
              name: "offset",
              options: {
                offset: [0, 4],
              },
            },
          ]}
          elevation={3}
          style={{
            padding: 8,
            width: 380,
          }}
        >
          <ClickAwayListener onClickAway={() => setOpenIndex(null)}>
            <Paper elevation={3} style={{ padding: 8, minWidth: 200 }}>
              <div style={{ display: "flex" }}>
                <div
                  style={{ flex: "1", fontWeight: "600", lineHeight: "30px" }}
                >
                  Search to select service ID
                </div>
                <div
                  onClick={() => setOpenIndex(null)}
                  style={{ margin: "5px", cursor: "pointer" }}
                >
                  <FontIcon
                    style={{
                      color: "#EF7C01",
                      lineHeight: "0",

                      fontSize: "28px",
                    }}
                  >
                    arrow_forward
                  </FontIcon>
                </div>
              </div>
              <div>
                <Autocomplete
                  multiple
                  disabled={mode === 2}
                  id="plan-wallet-select-service-id"
                  options={
                    mode === 1
                      ? allServices.filter((s) => s.isActive === true)
                      : allServices
                  }
                  getOptionLabel={(option) =>
                    `(${option.id}) ${option.serviceName}`
                  }
                  getOptionDisabled={(option) =>
                    !option.isActive ||
                    serviceRuleData
                      .flatMap((row, i) =>
                        i !== openIndex ? row.serviceIds || [] : [],
                      )
                      .includes(option.id)
                  }
                  value={
                    Array.isArray(serviceRuleData[openIndex]?.serviceIds)
                      ? allServices.filter((e) =>
                          serviceRuleData[openIndex].serviceIds.includes(e.id),
                        )
                      : []
                  }
                  onChange={(e, v) => {
                    const selectedIds = v.map((opt) => opt.id);
                    updateServiceRule(openIndex, 5, null, selectedIds);
                  }}
                  style={{
                    width: "100%",
                    // maxHeight: "200px",
                    overflowY: "scroll",
                    overflowX: "hidden",
                  }}
                  renderInput={(params) => (
                    <TextField2
                      {...params}
                      placeholder=""
                      className="autocomplete-text-field-class"
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </div>
            </Paper>
          </ClickAwayListener>
        </Popper>
      }
      {isCopyServicesPromptOpen && (
        <DialogContainer
          id="mp-copy-services-prompt"
          visible={isCopyServicesPromptOpen}
          focusOnMount={false}
          onHide={() => {
            if (!loading) {
              setIsCopyServicesPromptOpen(false);
            }
          }}
          width="500px"
          autosizeContent
          height="auto"
          style={{ textAlign: "left" }}
          dialogStyle={{ borderRadius: "10px", position: "relative" }}
        >
          <div className="mp-copy-services-prompt">
            <div className="mp-copy-services-prompt-heading">
              Do you also want to copy services from existing plan?
            </div>
            <div className="mp-copy-services-prompt-actions">
              <button
                type="button"
                className="mp-copy-btn-grey-outline"
                disabled={loading}
                onClick={() => {
                  copyPlan(false, []);
                }}
              >
                No
              </button>
              <button
                type="button"
                className="mp-copy-btn-orange mp-copy-btn-orange-active"
                disabled={loading}
                onClick={() => {
                  openCopyServicesSelector();
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </DialogContainer>
      )}
      {isCopyServicesSelectorOpen && (
        <DialogContainer
          id="mp-copy-services-selector"
          visible={isCopyServicesSelectorOpen}
          focusOnMount={false}
          onHide={() => {
            // Clicking outside the popup should only dismiss it and keep the
            // user on the current (Copy Plan / assign-service) screen — don't
            // exit the whole copy flow.
            if (!loading) {
              setIsCopyServicesSelectorOpen(false);
            }
          }}
          width="1100px"
          autosizeContent
          height="auto"
          style={{ textAlign: "left" }}
          dialogStyle={{ borderRadius: "10px", position: "relative" }}
        >
          <div className="mp-copy-services-selector">
            <h2 className="mp-copy-picker-heading">
              Choose plan from which you want to copy the services
            </h2>

            <div className="mp-copy-picker-form-row">
              <div className="mp-copy-picker-field">
                <div className="mp-plan-label">
                  Plan ID <span className="mp-copy-picker-required">*</span>
                </div>
                <div className="mp-copy-picker-id-input-wrapper">
                  <TextField
                    id="copy_services_plan_id"
                    placeholder="Search"
                    type="number"
                    value={copyServicesSearchInput}
                    onChange={(val) =>
                      setCopyServicesSearchInput(String(val ?? ""))
                    }
                    lineDirection="left"
                  />
                  <button
                    type="button"
                    className={
                      copyServicesSearchInput && !copyServicesLookupLoading
                        ? "mp-copy-picker-arrow mp-copy-picker-arrow-active"
                        : "mp-copy-picker-arrow"
                    }
                    disabled={
                      !copyServicesSearchInput || copyServicesLookupLoading
                    }
                    onClick={fetchCopyServicesPlan}
                    aria-label="Fetch plan details"
                  >
                    <FontIcon>arrow_forward</FontIcon>
                  </button>
                </div>
              </div>

              <div className="mp-copy-picker-field">
                <div className="mp-plan-label">Plan name</div>
                <TextField
                  id="copy_services_plan_name"
                  value={copyServicesSourcePlan?.basicDetails?.name ?? "-"}
                  disabled
                  lineDirection="left"
                />
              </div>

              <div className="mp-copy-picker-field">
                <div className="mp-plan-label">Account name</div>
                <TextField
                  id="copy_services_account_name"
                  value={copyServicesSourceAccount?.accountName ?? "-"}
                  disabled
                  lineDirection="left"
                />
              </div>

              <div className="mp-copy-picker-field">
                <div className="mp-plan-label">Account code</div>
                <TextField
                  id="copy_services_account_code"
                  value={copyServicesSourcePlan?.accountCode ?? "-"}
                  disabled
                  lineDirection="left"
                />
              </div>
            </div>

            <div style={{ height: 16 }} />

            <ExpandableTableSelectableAssignedServices
              data={{
                accountId: props?.data?.accountId,
                planData: copyServicesSourcePlan,
                assignedServices: copyServicesArray,
                allAssignedServicesArray: allCopyServicesArray,
              }}
              pageNum={copyServicesPageNum}
              pageSize={copyServicesPageSize}
              totalCount={copyServicesTotalCount}
              goToPrevPage={copyServicesGoToPrevPage}
              goToNextPage={copyServicesGoToNextPage}
              filterObj={copyServicesFilterObj}
              setFilterObj={setCopyServicesFilterObj}
              selectedServiceIds={selectedCopyServiceIds}
              isAllSelected={isAllCopyServicesSelected}
              onToggleService={toggleCopyService}
              onToggleAll={toggleAllCopyServices}
            />

            <div className="mp-copy-services-selector-actions">
              <button
                type="button"
                className="mp-copy-btn-grey-outline"
                disabled={loading}
                onClick={() => {
                  if (copyServicesMode === "import-into-existing") {
                    exitCopyFlowToAssignedPlans();
                  } else {
                    copyPlan(false, []);
                  }
                }}
              >
                No
              </button>
              <button
                type="button"
                className={
                  isAllCopyServicesSelected || selectedCopyServiceIds.length > 0
                    ? "mp-copy-btn-orange mp-copy-btn-orange-active"
                    : "mp-copy-btn-orange"
                }
                disabled={
                  loading ||
                  (!isAllCopyServicesSelected &&
                    selectedCopyServiceIds.length === 0)
                }
                onClick={() => {
                  if (isAllCopyServicesSelected) {
                    if (hasActiveCopyFilters(copyServicesFilterObj)) {
                      fetchAllFilteredCopyServiceIds((ids) =>
                        copyPlan(false, ids),
                      );
                    } else {
                      copyPlan(true, []);
                    }
                  } else {
                    copyPlan(false, selectedCopyServiceIds);
                  }
                }}
              >
                {copyServicesMode === "import-into-existing"
                  ? "Add"
                  : "Add & Create"}
              </button>
            </div>
          </div>
        </DialogContainer>
      )}
      {isCopySuccessOpen && (
        <DialogContainer
          id="mp-copy-success"
          visible={isCopySuccessOpen}
          focusOnMount={false}
          onHide={exitCopyFlowToAssignedPlans}
          width="480px"
          autosizeContent
          height="auto"
          style={{ textAlign: "center" }}
          dialogStyle={{ borderRadius: "10px", position: "relative" }}
        >
          <div className="mp-copy-success-modal">
            <img
              src={successAnimationGif}
              alt="success"
              className="mp-copy-success-gif"
            />
            <h2 className="mp-copy-success-heading">
              {copyServicesMode === "import-into-existing"
                ? "Services imported successfully!"
                : "Plan created successfully!"}
            </h2>
            <button
              type="button"
              className="mp-copy-success-done-btn"
              onClick={exitCopyFlowToAssignedPlans}
            >
              Done
            </button>
          </div>
        </DialogContainer>
      )}
      {<ConfirmDialog />}
      {
        <FAQDialog
          dialogState={dialogState}
          questionEditorState={questionEditorState}
          setQuestionEditorState={setQuestionEditorState}
          answerEditorState={answerEditorState}
          setAnswerEditorState={setAnswerEditorState}
          handleClose={handleClose}
        />
      }
      <CategorySelectDialog
        visible={categoryDialog.open}
        type={categoryDialog.type}
        subtitle={categoryDialogServiceCategory?.name || ""}
        candidates={categoryDialogCandidates}
        initialSelected={categoryDialogSelected}
        lockedLabels={categoryDialogLocked}
        viewOnly={mode === 2}
        onCancel={closeCategoryDialog}
        onSave={handleCategoryDialogSave}
        onAddCategory={handleAddCandidateCategory}
      />
    </div>
  );
};

export default CreatePlan;
